webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(26);
	
	__webpack_require__(30);
	
	__webpack_require__(32);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(60);
	
	var _lodash = __webpack_require__(198);
	
	__webpack_require__(200);
	
	var _VERSION = __webpack_require__(534);
	
	var _root = __webpack_require__(702);
	
	var _configureStore = __webpack_require__(726);
	
	var _initialState = __webpack_require__(615);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _persistStorage = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//APP
	function migrate(persistedState, currentState) {
		// NOTE: Do not use localStorage in development.
		if (false) {
			return currentState;
		}
	
		if (persistedState && _persistStorage.storage.get(_VERSION.VERSION_KEY) === _VERSION.APP_VERSION) {
			return persistedState;
		}
		_persistStorage.storage.set(_VERSION.VERSION_KEY, _VERSION.APP_VERSION);
		return currentState;
	}
	
	//LIBS
	
	
	var store = (0, _configureStore.configureStore)(migrate(_persistStorage.storage.get(_VERSION.STATE_KEY), _initialState2.default));
	
	if (false) {
		// NOTE: to debug
		window.store = store;
	}
	
	store.subscribe((0, _lodash.throttle)(function () {
		return _persistStorage.storage.set(_VERSION.STATE_KEY, store.getState());
	}, 1000));
	
	(0, _reactDom.render)(_react2.default.createElement(_root.Root, { store: store }), document.getElementById('root'));

/***/ },

/***/ 26:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 30:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 32:
/***/ function(module, exports) {

	'use strict';
	
	if (!Object.values) {
	  Object.values = function (x) {
	    return Object.keys(x).reduce(function (y, z) {
	      return y.push(x[z]) && y;
	    }, []);
	  };
	}
	
	if (!Object.entries) {
	  Object.entries = function (x) {
	    return Object.keys(x).reduce(function (y, z) {
	      return y.push([z, x[z]]) && y;
	    }, []);
	  };
	}
	
	if (!Array.prototype.includes) {
	  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
	    if (this == null) {
	      throw new TypeError('Array.prototype.includes called on null or undefined');
	    }
	
	    var O = Object(this);
	    var len = parseInt(O.length, 10) || 0;
	    if (len === 0) {
	      return false;
	    }
	    var n = parseInt(arguments[1], 10) || 0;
	    var k;
	    if (n >= 0) {
	      k = n;
	    } else {
	      k = len + n;
	      if (k < 0) {
	        k = 0;
	      }
	    }
	    var currentElement;
	    while (k < len) {
	      currentElement = O[k];
	      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
	        // NaN !== NaN
	        return true;
	      }
	      k++;
	    }
	    return false;
	  };
	}

/***/ },

/***/ 200:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(201);

/***/ },

/***/ 201:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _PluginRegister = __webpack_require__(202);
	
	var _PluginRegister2 = _interopRequireDefault(_PluginRegister);
	
	var _Index = __webpack_require__(542);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Compositions = __webpack_require__(700);
	
	var _Compositions2 = _interopRequireDefault(_Compositions);
	
	var _Composition = __webpack_require__(701);
	
	var _Composition2 = _interopRequireDefault(_Composition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_PluginRegister2.default.register({
		path: '/',
		component: _Index2.default,
		title: 'Genetic Algorithms (reference)'
	});
	
	_PluginRegister2.default.register({
		path: '/compositions',
		component: _Compositions2.default,
		title: 'Manage compositions'
	});
	
	_PluginRegister2.default.register({
		path: '/compositions/:composition',
		component: _Composition2.default,
		title: 'Manage compositions',
		useNav: false
	});

/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _routes = __webpack_require__(203);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _nav = __webpack_require__(205);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// TODO: reimplement singleton to context
	
	/**
	 * @description Used to register plugins in app.
	 * Also provides a link in navigation sidebar
	 */
	var PluginRegister = function () {
		function PluginRegister() {
			_classCallCheck(this, PluginRegister);
		}
	
		_createClass(PluginRegister, [{
			key: 'register',
	
			/**
	   * @param {Object} options
	   * @param {string} options.path
	   * @param {React.Component} options.component
	   * @param {string} options.title 
	   * @param {Boolean} [options.useNav=true]
	   * @return {void}
	   */
			value: function register(_ref) {
				var path = _ref.path,
				    component = _ref.component,
				    title = _ref.title,
				    _ref$useNav = _ref.useNav,
				    useNav = _ref$useNav === undefined ? true : _ref$useNav;
	
				useNav && _nav2.default.push({ path: path, title: title });
				_routes2.default.childRoutes.push({ path: path, component: component });
			}
		}]);
	
		return PluginRegister;
	}();
	
	exports.default = new PluginRegister();

/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _App = __webpack_require__(204);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = {
		path: '/ga',
		component: _App2.default,
		childRoutes: []
	};
	
	exports.default = routes;

/***/ },

/***/ 204:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nav = __webpack_require__(205);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _LayoutNavBar = __webpack_require__(459);
	
	var _LayoutNavBar2 = _interopRequireDefault(_LayoutNavBar);
	
	var _LayoutSideBar = __webpack_require__(537);
	
	var _LayoutSideBar2 = _interopRequireDefault(_LayoutSideBar);
	
	var _LayoutMain = __webpack_require__(541);
	
	var _LayoutMain2 = _interopRequireDefault(_LayoutMain);
	
	var _Index = __webpack_require__(542);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
		_inherits(App, _React$Component);
	
		function App() {
			_classCallCheck(this, App);
	
			return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
		}
	
		_createClass(App, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_LayoutNavBar2.default, null),
					_react2.default.createElement(
						_reactBootstrap.Grid,
						{ fluid: true },
						_react2.default.createElement(
							_reactBootstrap.Row,
							null,
							_react2.default.createElement(_LayoutSideBar2.default, { nav: _nav2.default }),
							_react2.default.createElement(
								_LayoutMain2.default,
								null,
								this.props.children || _react2.default.createElement(_Index2.default, null)
							)
						)
					)
				);
			}
		}]);
	
		return App;
	}(_react2.default.Component);
	
	exports.default = App;

/***/ },

/***/ 205:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Array<{title: string, path: string}>
	 */
	var nav = [];
	/*
	nav.push({
		title: 'Home',
		path: '/'
	});
	*/
	exports.default = nav;

/***/ },

/***/ 459:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlayerControls = __webpack_require__(460);
	
	var _PlayerControls2 = _interopRequireDefault(_PlayerControls);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _reactRouter = __webpack_require__(479);
	
	var _VERSION = __webpack_require__(534);
	
	var _resetState = __webpack_require__(535);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayoutNavBar = function (_React$Component) {
		_inherits(LayoutNavBar, _React$Component);
	
		function LayoutNavBar() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, LayoutNavBar);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LayoutNavBar.__proto__ || Object.getPrototypeOf(LayoutNavBar)).call.apply(_ref, [this].concat(args))), _this), _this.onResetState = function () {
				return (0, _resetState.resetState)();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(LayoutNavBar, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_reactBootstrap.Navbar,
					{ inverse: true, fixedTop: true },
					_react2.default.createElement(
						_reactBootstrap.NavbarBrand,
						null,
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '#/' },
							'GENOM ',
							_VERSION.APP_VERSION || ''
						)
					),
					_react2.default.createElement(_PlayerControls2.default, null),
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ style: { marginTop: 6 }, onClick: this.onResetState },
						'Reset state'
					)
				);
			}
		}]);
	
		return LayoutNavBar;
	}(_react2.default.Component);
	
	exports.default = LayoutNavBar;

/***/ },

/***/ 460:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Player = __webpack_require__(461);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _reactBootstrap = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerControls = function (_React$Component) {
		_inherits(PlayerControls, _React$Component);
	
		function PlayerControls(params) {
			_classCallCheck(this, PlayerControls);
	
			var _this = _possibleConstructorReturn(this, (PlayerControls.__proto__ || Object.getPrototypeOf(PlayerControls)).call(this, params));
	
			_Player2.default.onSet(function (notes) {
				_this.setState({
					enabled: Boolean(notes)
				});
			});
	
			_this.state = {
				enabled: false
			};
			return _this;
		}
	
		_createClass(PlayerControls, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'form',
					{ className: 'navbar-form navbar-left' },
					_react2.default.createElement(
						_reactBootstrap.ButtonGroup,
						null,
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ disabled: !this.state.enabled, onClick: this.play.bind(this) },
							_react2.default.createElement('span', { className: 'glyphicon glyphicon-play' })
						),
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ disabled: !this.state.enabled, onClick: this.stop.bind(this) },
							_react2.default.createElement('span', { className: 'glyphicon glyphicon-stop' })
						)
					)
				);
			}
		}, {
			key: 'play',
			value: function play() {
				_Player2.default.play();
			}
		}, {
			key: 'stop',
			value: function stop() {
				_Player2.default.stop();
			}
		}]);
	
		return PlayerControls;
	}(_react2.default.Component);
	
	exports.default = PlayerControls;

/***/ },

/***/ 461:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _soundfontPlayer = __webpack_require__(462);
	
	var _soundfontPlayer2 = _interopRequireDefault(_soundfontPlayer);
	
	var _instrumentNames = __webpack_require__(477);
	
	var _instrumentNames2 = _interopRequireDefault(_instrumentNames);
	
	var _common = __webpack_require__(478);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	window.AudioContext = window.AudioContext || window.webkitAudioContext;
	
	function isHold(val) {
		return val === -1;
	}
	
	function isPause(val) {
		return val === 0;
	}
	
	var NOTE_LENGTH = 0.2; // 1/8 is 300ms const for now TODO: move to options
	
	var Converter = function () {
		function Converter() {
			_classCallCheck(this, Converter);
		}
	
		_createClass(Converter, null, [{
			key: 'convert',
	
			//notes is Array<number> where number -1, .. , 15
			value: function convert(notes) {
				var result = [];
	
				notes.forEach(function (noteCode) {
					if (isHold(noteCode) && result.length) {
						result[result.length - 1].duration += NOTE_LENGTH;
						return;
					}
	
					if (isPause(noteCode)) {
						result.push({
							note: null,
							duration: NOTE_LENGTH
						});
						return;
					}
	
					result.push({
						note: _common.REFERENCE_TABLE[noteCode],
						duration: NOTE_LENGTH
					});
				});
	
				return result;
			}
		}]);
	
		return Converter;
	}();
	
	// NOTE: copy paste from soundfont-player
	
	
	function nameToUrl(name) {
		var sf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MusyngKite';
		var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'mp3';
	
		var protocol = window.location.protocol;
		return protocol + '//gleitz.github.io/midi-js-soundfonts/' + sf + '/' + name + '-' + format + '.js';
	}
	
	//this._instrument.play(note, time, duration);
	
	var Player = function () {
		function Player() {
			var _this = this;
	
			var instrumentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _instrumentNames2.default.acoustic_grand_piano;
	
			_classCallCheck(this, Player);
	
			this._callbacks = [];
			this._ctx = new window.AudioContext();
	
			this._notes = [];
			this._prevNotes = [];
			this._timeout = null;
			this._instrument = null;
	
			this._isPlaying = false;
	
			_soundfontPlayer2.default.instrument(this._ctx, instrumentName, {
				nameToUrl: nameToUrl
			}).then(function (instrument) {
				return _this._instrument = instrument;
			});
		}
	
		_createClass(Player, [{
			key: 'set',
			value: function set(notes) {
				this._notes = Converter.convert(notes);
				this._prevNotes = this._notes.slice();
				this._runCallbacks(notes);
			}
		}, {
			key: '_runCallbacks',
			value: function _runCallbacks(param) {
				if (this._callbacks.length) {
					this._callbacks.forEach(function (callback) {
						callback(param);
					});
				}
			}
		}, {
			key: 'onSet',
			value: function onSet(callback) {
				this._callbacks.push(callback);
			}
		}, {
			key: 'offSet',
			value: function offSet() {
				this._callbacks = [];
			}
	
			//notes is Array<number> where number -1, .. , 15
	
		}, {
			key: 'play',
			value: function play(notes) {
				if (notes) {
					this.set(notes);
				}
	
				if (this._instrument) {
					this._playInternal();
				} else {
					console.warn('Instruments not loaded yet');
				}
			}
		}, {
			key: 'clear',
			value: function clear() {
				this._notes = [];
				this._prevNotes = [];
				this._runCallbacks(null);
			}
		}, {
			key: '_playInternal',
			value: function _playInternal() {
				this._isPlaying = true;
				this._notes = this._prevNotes.slice();
				this._playTick();
			}
		}, {
			key: '_playTick',
			value: function _playTick() {
				var _this2 = this;
	
				var noteItem = this._notes.shift();
	
				if (!noteItem || !this._isPlaying) {
					this._clear();
					return;
				}
	
				var note = noteItem.note,
				    duration = noteItem.duration;
	
				this._instrument.play(note, this._ctx.currentTime);
				this._timeout = setTimeout(function () {
					return _this2._playTick();
				}, duration * 1000); // timeout use mileseconds while we put second into noteItem
			}
		}, {
			key: '_clear',
			value: function _clear() {
				clearTimeout(this._timeout);
				this._timeout = null;
			}
		}, {
			key: 'stop',
			value: function stop() {
				this._isPlaying = false;
			}
		}]);
	
		return Player;
	}();
	
	exports.default = new Player();

/***/ },

/***/ 477:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var instrumentNames = {
		accordion: 'accordion',
		acoustic_bass: 'acoustic_bass',
		acoustic_grand_piano: 'acoustic_grand_piano',
		acoustic_guitar_nylon: 'acoustic_guitar_nylon',
		acoustic_guitar_steel: 'acoustic_guitar_steel',
		agogo: 'agogo',
		alto_sax: 'alto_sax',
		applause: 'applause',
		bagpipe: 'bagpipe',
		banjo: 'banjo',
		baritone_sax: 'baritone_sax',
		bassoon: 'bassoon',
		bird_tweet: 'bird_tweet',
		blown_bottle: 'blown_bottle',
		brass_section: 'brass_section',
		breath_noise: 'breath_noise',
		bright_acoustic_piano: 'bright_acoustic_piano',
		celesta: 'celesta',
		cello: 'cello',
		choir_aahs: 'choir_aahs',
		church_organ: 'church_organ',
		clarinet: 'clarinet',
		clavinet: 'clavinet',
		contrabass: 'contrabass',
		distortion_guitar: 'distortion_guitar',
		drawbar_organ: 'drawbar_organ',
		dulcimer: 'dulcimer',
		electric_bass_finger: 'electric_bass_finger',
		electric_bass_pick: 'electric_bass_pick',
		electric_grand_piano: 'electric_grand_piano',
		electric_guitar_clean: 'electric_guitar_clean',
		electric_guitar_jazz: 'electric_guitar_jazz',
		electric_guitar_muted: 'electric_guitar_muted',
		electric_piano_1: 'electric_piano_1',
		electric_piano_2: 'electric_piano_2',
		english_horn: 'english_horn',
		fiddle: 'fiddle',
		flute: 'flute',
		french_horn: 'french_horn',
		fretless_bass: 'fretless_bass',
		fx_1_rain: 'fx_1_rain',
		fx_2_soundtrack: 'fx_2_soundtrack',
		fx_3_crystal: 'fx_3_crystal',
		fx_4_atmosphere: 'fx_4_atmosphere',
		fx_5_brightness: 'fx_5_brightness',
		fx_6_goblins: 'fx_6_goblins',
		fx_7_echoes: 'fx_7_echoes',
		fx_8_scifi: 'fx_8_scifi',
		glockenspiel: 'glockenspiel',
		guitar_fret_noise: 'guitar_fret_noise',
		guitar_harmonics: 'guitar_harmonics',
		gunshot: 'gunshot',
		harmonica: 'harmonica',
		harpsichord: 'harpsichord',
		helicopter: 'helicopter',
		honkytonk_piano: 'honkytonk_piano',
		kalimba: 'kalimba',
		koto: 'koto',
		lead_1_square: 'lead_1_square',
		lead_2_sawtooth: 'lead_2_sawtooth',
		lead_3_calliope: 'lead_3_calliope',
		lead_4_chiff: 'lead_4_chiff',
		lead_5_charang: 'lead_5_charang',
		lead_6_voice: 'lead_6_voice',
		lead_7_fifths: 'lead_7_fifths',
		lead_8_bass__lead: 'lead_8_bass__lead',
		marimba: 'marimba',
		melodic_tom: 'melodic_tom',
		music_box: 'music_box',
		muted_trumpet: 'muted_trumpet',
		oboe: 'oboe',
		ocarina: 'ocarina',
		orchestra_hit: 'orchestra_hit',
		orchestral_harp: 'orchestral_harp',
		overdriven_guitar: 'overdriven_guitar',
		pad_1_new_age: 'pad_1_new_age',
		pad_2_warm: 'pad_2_warm',
		pad_3_polysynth: 'pad_3_polysynth',
		pad_4_choir: 'pad_4_choir',
		pad_5_bowed: 'pad_5_bowed',
		pad_6_metallic: 'pad_6_metallic',
		pad_7_halo: 'pad_7_halo',
		pad_8_sweep: 'pad_8_sweep',
		pan_flute: 'pan_flute',
		percussive_organ: 'percussive_organ',
		piccolo: 'piccolo',
		pizzicato_strings: 'pizzicato_strings',
		recorder: 'recorder',
		reed_organ: 'reed_organ',
		reverse_cymbal: 'reverse_cymbal',
		rock_organ: 'rock_organ',
		seashore: 'seashore',
		shakuhachi: 'shakuhachi',
		shamisen: 'shamisen',
		shanai: 'shanai',
		sitar: 'sitar',
		slap_bass_1: 'slap_bass_1',
		slap_bass_2: 'slap_bass_2',
		soprano_sax: 'soprano_sax',
		steel_drums: 'steel_drums',
		string_ensemble_1: 'string_ensemble_1',
		string_ensemble_2: 'string_ensemble_2',
		synth_bass_1: 'synth_bass_1',
		synth_bass_2: 'synth_bass_2',
		synth_brass_1: 'synth_brass_1',
		synth_brass_2: 'synth_brass_2',
		synth_choir: 'synth_choir',
		synth_drum: 'synth_drum',
		synth_strings_1: 'synth_strings_1',
		synth_strings_2: 'synth_strings_2',
		taiko_drum: 'taiko_drum',
		tango_accordion: 'tango_accordion',
		telephone_ring: 'telephone_ring',
		tenor_sax: 'tenor_sax',
		timpani: 'timpani',
		tinkle_bell: 'tinkle_bell',
		tremolo_strings: 'tremolo_strings',
		trombone: 'trombone',
		trumpet: 'trumpet',
		tuba: 'tuba',
		tubular_bells: 'tubular_bells',
		vibraphone: 'vibraphone',
		viola: 'viola',
		violin: 'violin',
		voice_oohs: 'voice_oohs',
		whistle: 'whistle',
		woodblock: 'woodblock',
		xylophone: 'xylophone'
	};
	
	exports.default = instrumentNames;

/***/ },

/***/ 478:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var REFERENCE_TABLE = exports.REFERENCE_TABLE = {
		1: 'C3',
		2: 'D3',
		3: 'E3',
		4: 'F3',
		5: 'G3',
		6: 'A3',
		7: 'B3',
		8: 'C4',
		9: 'D4',
		10: 'E4',
		11: 'F4',
		12: 'G4',
		13: 'A4',
		14: 'B4'
	};

/***/ },

/***/ 534:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_VERSION = exports.APP_VERSION = '0.0.4';
	var STATE_KEY = exports.STATE_KEY = '__APP_STATE__';
	var VERSION_KEY = exports.VERSION_KEY = '__APP_VERSION__';

/***/ },

/***/ 535:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.resetState = resetState;
	
	var _persistStorage = __webpack_require__(536);
	
	var _VERSION = __webpack_require__(534);
	
	function resetState() {
		_persistStorage.storage.remove(_VERSION.VERSION_KEY);
		_persistStorage.storage.remove(_VERSION.STATE_KEY);
		location.reload();
	}

/***/ },

/***/ 536:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var storage = exports.storage = {
		get: function get(key) {
			try {
				return JSON.parse(localStorage.getItem(key));
			} catch (e) {
				return undefined;
			}
		},
		set: function set(key, value) {
			try {
				return localStorage.setItem(key, JSON.stringify(value));
			} catch (e) {
				return undefined;
			}
		},
		remove: function remove(key) {
			try {
				return localStorage.removeItem(key);
			} catch (e) {
				return undefined;
			}
		}
	};

/***/ },

/***/ 537:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _reactRouterBootstrap = __webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayoutSideBar = function (_React$Component) {
	    _inherits(LayoutSideBar, _React$Component);
	
	    function LayoutSideBar() {
	        _classCallCheck(this, LayoutSideBar);
	
	        return _possibleConstructorReturn(this, (LayoutSideBar.__proto__ || Object.getPrototypeOf(LayoutSideBar)).apply(this, arguments));
	    }
	
	    _createClass(LayoutSideBar, [{
	        key: 'render',
	        value: function render() {
	            var navItems = this.props.nav.map(function (navItem) {
	                return _react2.default.createElement(
	                    _reactRouterBootstrap.LinkContainer,
	                    { key: navItem.path, to: navItem.path },
	                    _react2.default.createElement(
	                        _reactBootstrap.NavItem,
	                        null,
	                        navItem.title
	                    )
	                );
	            });
	
	            return _react2.default.createElement(
	                _reactBootstrap.Col,
	                { sm: 3, md: 2, className: 'sidebar' },
	                _react2.default.createElement(
	                    _reactBootstrap.Nav,
	                    { className: 'nav-sidebar' },
	                    navItems
	                )
	            );
	        }
	    }]);
	
	    return LayoutSideBar;
	}(_react2.default.Component);
	
	exports.default = LayoutSideBar;

/***/ },

/***/ 541:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LayoutMain = function (_React$Component) {
		_inherits(LayoutMain, _React$Component);
	
		function LayoutMain() {
			_classCallCheck(this, LayoutMain);
	
			return _possibleConstructorReturn(this, (LayoutMain.__proto__ || Object.getPrototypeOf(LayoutMain)).apply(this, arguments));
		}
	
		_createClass(LayoutMain, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_reactBootstrap.Col,
					{ sm: 9, md: 10, mdOffset: 2, smOffset: 3, className: 'main' },
					this.props.children
				);
			}
		}]);
	
		return LayoutMain;
	}(_react2.default.Component);
	
	exports.default = LayoutMain;

/***/ },

/***/ 542:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(543);
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(198);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _Graph = __webpack_require__(545);
	
	var _Player = __webpack_require__(461);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _GAOptions = __webpack_require__(604);
	
	var _GAOptions2 = _interopRequireDefault(_GAOptions);
	
	var _GARunner = __webpack_require__(694);
	
	var _IndividualsTable = __webpack_require__(696);
	
	var _Sheet = __webpack_require__(697);
	
	var _Sheet2 = _interopRequireDefault(_Sheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //styles
	
	
	//libs
	
	
	//Components
	
	
	var DEFAULT_STATE = {
		/**
	  * @description App state
	  */
		working: false,
		paused: false,
	
		/**
	  * @description Used to draw Music Scores 
	  */
		selected: null,
	
		/**
	  * @description Old population holder for single evolution 
	  * @deprecated
	  * @type {{ content: number[], fitness: { value: number, full: { [key: string]: number } }}[]
	  */
		population: [],
	
		/**
	  * @description Populations hash for evolutions
	  * @type { { [evolutionName: string]: { content: number[], fitness: { value: number, full: { [key: string]: number } } }[] }
	  */
		populations: {},
	
		/**
	  * @type { { name: string, values: { x: number, y: number }[] }[] }
	  */
		statistics: [],
	
		/**
	  * @description Used with multiple evolutions to display multiple progress bars
	  * @type {{[evolutionName: string]: number}}
	  */
		percentages: {},
	
		/**
	  * @description Progress
	  */
		percentage: 0,
	
		/**
	  * @description Best one of all evolutions
	  * @type {{fitness: { value: number }}}
	  */
		best: null,
	
		/**
	  * @description Best for each evolutions
	  * @type { [evolutionName: string]: {fitness: { value: number }} }
	 	*/
		bests: {}
	};
	
	var Index = function (_React$Component) {
		_inherits(Index, _React$Component);
	
		function Index() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, Index);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Index.__proto__ || Object.getPrototypeOf(Index)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, DEFAULT_STATE), _this.runner = null, _this.select = function (item) {
				_Player2.default.set(item.content);
				_this.setState({
					selected: item.content
				});
			}, _this.run = function () {
				var newState = _extends({}, DEFAULT_STATE, {
					bests: {},
					statistics: [{
						name: 'darwin-evolution',
						values: [{ x: 0, y: 0 }]
					}],
					working: true
				});
	
				_this.setState(newState);
	
				if (_this.runner) {
					_this.runner.destroy();
				}
	
				_this.runner = _this._createRunner();
			}, _this.resume = function () {
				_this.setState({
					paused: false
				});
				_this.runner && _this.runner.resume();
			}, _this.pause = function () {
				_this.setState({
					paused: true
				});
				_this.runner && _this.runner.pause();
			}, _this.stop = function () {
				_this.runner && _this.runner.stop();
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
		/**
	  * @type {GARunner}
	  */
	
	
		_createClass(Index, [{
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var store = this.context.store;
	
	
				var scoresPanel = null;
				var progressBar = null;
				var best = null;
				var individualsTable = null;
	
				if (this.state.population.length) {
					// TODO: create table for each worker, or use different colors for rows?
					individualsTable = _react2.default.createElement(_IndividualsTable.IndividualsTable, {
						population: this.state.population,
						onSelect: this.select });
				}
				if (!(0, _lodash.isEmpty)(this.state.populations)) {
					individualsTable = _react2.default.createElement(
						'div',
						null,
						Object.entries(this.state.populations).map(function (_ref2) {
							var _ref3 = _slicedToArray(_ref2, 2),
							    name = _ref3[0],
							    population = _ref3[1];
	
							return _react2.default.createElement(_IndividualsTable.IndividualsTable, {
								key: name,
								name: name,
								population: population,
								onSelect: _this2.select });
						})
					);
				}
	
				if (this.state.selected) {
					scoresPanel = _react2.default.createElement(
						_reactBootstrap.Panel,
						{ header: 'Scores' },
						_react2.default.createElement(_Sheet2.default, { data: this.state.selected })
					);
				}
	
				/**
	    * @deprecated
	    * @description Display progress bar for single evolution
	    */
				if (this.state.percentage) {
					var currentPercent = this.state.percentage | 0;
					progressBar = _react2.default.createElement(
						'div',
						{ className: 'progress-bar-wrapper' },
						_react2.default.createElement(
							'h3',
							null,
							'Progress: '
						),
						_react2.default.createElement(_reactBootstrap.ProgressBar, { now: currentPercent, label: currentPercent + '%' })
					);
				}
				/**
	    * @description Display progress bar for multiple evolutions
	    */
				if (!(0, _lodash.isEmpty)(this.state.percentages)) {
					progressBar = this._renderProgressBarForEvolutions();
				}
	
				// Best Guys ProgressBar
				if (this.state.best) {
					var bestValue = this.state.best.fitness.value * 100 | 0;
					best = _react2.default.createElement(
						'div',
						{ className: 'progress-bar-wrapper' },
						_react2.default.createElement(
							'h3',
							null,
							'Best: '
						),
						_react2.default.createElement(_reactBootstrap.ProgressBar, { bsStyle: 'success', now: bestValue, label: bestValue + '%', key: '1' })
					);
				}
	
				return _react2.default.createElement(
					_reactBootstrap.Grid,
					{ fluid: true },
					_react2.default.createElement(
						_reactBootstrap.Row,
						null,
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ sm: 8, md: 8 },
							this.state.statistics.length ? _react2.default.createElement(_Graph.Graph, { series: this.state.statistics }) : null,
							scoresPanel,
							_react2.default.createElement(_GAOptions2.default, { store: store })
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ sm: 4, md: 4 },
							_react2.default.createElement(
								_reactBootstrap.Panel,
								{ header: 'Population' },
								this._renderButtons(),
								best,
								progressBar,
								individualsTable
							)
						)
					)
				);
			}
		}, {
			key: '_renderProgressBarForEvolutions',
			value: function _renderProgressBarForEvolutions() {
				var _this3 = this;
	
				return _react2.default.createElement(
					'div',
					null,
					Object.entries(this.state.percentages).map(function (_ref4) {
						var _ref5 = _slicedToArray(_ref4, 2),
						    name = _ref5[0],
						    percent = _ref5[1];
	
						return [_this3._getEvolutionProgressHeaderText(name), percent | 0];
					}).map(function (_ref6) {
						var _ref7 = _slicedToArray(_ref6, 2),
						    name = _ref7[0],
						    percent = _ref7[1];
	
						return _react2.default.createElement(
							'div',
							{ key: name, className: 'progress-bar-wrapper' },
							_react2.default.createElement(
								'h5',
								null,
								'Progress ',
								name,
								':'
							),
							_react2.default.createElement(_reactBootstrap.ProgressBar, { now: percent, label: percent + '%' })
						);
					})
				);
			}
		}, {
			key: '_getEvolutionProgressHeaderText',
			value: function _getEvolutionProgressHeaderText(evolutionKey) {
				var name = evolutionKey.replace('-evolution', '');
				var best = this.state.bests[evolutionKey];
				if (!best) {
					return '(' + name + ')';
				}
				return '(' + name + ') ' + (best.fitness.value * 100 | 0) + '%';
			}
		}, {
			key: '_renderButtons',
			value: function _renderButtons() {
				return _react2.default.createElement(
					_reactBootstrap.ButtonGroup,
					null,
					this._renderFirstButton(),
					_react2.default.createElement(
						_reactBootstrap.Button,
						{ bsStyle: 'danger', onClick: this.stop },
						_react2.default.createElement('span', { className: 'glyphicon glyphicon-stop' })
					)
				);
			}
		}, {
			key: '_renderFirstButton',
			value: function _renderFirstButton() {
				var _state = this.state,
				    paused = _state.paused,
				    working = _state.working;
	
	
				if (working && !paused) {
					return _react2.default.createElement(
						_reactBootstrap.Button,
						{ bsStyle: 'warning', onClick: this.pause },
						_react2.default.createElement('span', { className: 'glyphicon glyphicon-pause' })
					);
				}
	
				return _react2.default.createElement(
					_reactBootstrap.Button,
					{ bsStyle: 'success', onClick: working ? this.resume : this.run },
					_react2.default.createElement('span', { className: 'glyphicon glyphicon-play' })
				);
			}
		}, {
			key: '_createRunner',
			value: function _createRunner() {
				var options = this.context.store.getState().GA;
	
				if (options.options.useEvolutionStrategies) {
					return this._createEvolutionRunner(options);
				} else {
					return this._createDefaultRunner(options);
				}
			}
		}, {
			key: '_createDefaultRunner',
			value: function _createDefaultRunner(options) {
				var _this4 = this;
	
				var onDone = function onDone(_ref8) {
					var population = _ref8.data;
					return _this4.setState({ population: population, working: false, paused: false });
				}; // onDone back to default state
				var onPause = function onPause(_ref9) {
					var population = _ref9.data;
					return _this4.setState({ population: population });
				};
				var onProgress = function onProgress(_ref10) {
					var percentage = _ref10.percentage,
					    best = _ref10.best;
	
					var statistics = _this4.state.statistics;
	
					statistics[0].values.push({
						x: percentage,
						y: best.fitness.value * 100
					});
	
					_this4.setState({ best: best, percentage: percentage, statistics: statistics });
				};
				return new _GARunner.GARunner(options, { onDone: onDone, onProgress: onProgress, onPause: onPause });
			}
		}, {
			key: '_createEvolutionRunner',
			value: function _createEvolutionRunner(options) {
				var _this5 = this;
	
				var onDone = function onDone(_ref11) {
					var id = _ref11.id,
					    population = _ref11.data;
					var populations = _this5.state.populations;
	
					var name = _this5._getNameFromId(id);
					_this5.setState({
						populations: _extends({}, populations, _defineProperty({}, name, population)),
						working: false,
						paused: false
					});
				};
				var onPause = function onPause(_ref12) {
					var id = _ref12.id,
					    population = _ref12.data;
					var populations = _this5.state.populations;
	
					var name = _this5._getNameFromId(id);
					_this5.setState({
						populations: _extends({}, populations, _defineProperty({}, name, population))
					});
				};
				var onProgress = function onProgress(_ref13) {
					var id = _ref13.id,
					    percentage = _ref13.percentage,
					    best = _ref13.best;
					var _state2 = _this5.state,
					    statistics = _state2.statistics,
					    bests = _state2.bests;
	
	
					var prevBestFitnessValue = _this5.state.best && _this5.state.best.fitness.value || 0;
					var currentBestFitnessValue = best.fitness.value;
					var percentages = _this5.state.percentages;
	
					var name = _this5._getNameFromId(id);
					var series = statistics.find(function (x) {
						return x.name === name;
					});
					var item = {
						x: percentage,
						y: currentBestFitnessValue * 100
					};
	
					if (series) {
						series.values.push(item);
					} else {
						statistics.push({
							name: name,
							values: [{
								x: 0,
								y: 0
							}, item]
						});
					}
	
					var newState = {
						statistics: statistics,
						bests: _extends({}, bests, _defineProperty({}, name, best)),
						percentages: _extends({}, percentages, _defineProperty({}, name, percentage))
					};
	
					if (currentBestFitnessValue > prevBestFitnessValue) {
						newState.best = best;
					}
	
					_this5.setState(newState);
				};
				return new _GARunner.GARunner(options, { onDone: onDone, onProgress: onProgress, onPause: onPause });
			}
		}, {
			key: '_getNameFromId',
			value: function _getNameFromId(id) {
				return id.split('_')[0];
			}
		}]);
	
		return Index;
	}(_react2.default.Component);
	// TODO: redo with react-redux connect later on
	
	
	exports.default = Index;
	Index.contextTypes = {
		store: _react2.default.PropTypes.object
	};

/***/ },

/***/ 543:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 545:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Graph = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _reactD = __webpack_require__(546);
	
	var _reactDimensions = __webpack_require__(602);
	
	var _reactDimensions2 = _interopRequireDefault(_reactDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleGraph = function (_React$Component) {
		_inherits(SimpleGraph, _React$Component);
	
		function SimpleGraph() {
			_classCallCheck(this, SimpleGraph);
	
			return _possibleConstructorReturn(this, (SimpleGraph.__proto__ || Object.getPrototypeOf(SimpleGraph)).apply(this, arguments));
		}
	
		_createClass(SimpleGraph, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    series = _props.series,
				    containerWidth = _props.containerWidth;
	
				var width = containerWidth - 40;
				var viewBoxObject = {
					x: 0,
					y: 0,
					width: width,
					height: width / 2
				};
	
				return _react2.default.createElement(
					_reactBootstrap.Panel,
					{ header: 'Graph' },
					_react2.default.createElement(_reactD.LineChart, {
						legend: true,
						data: series,
						width: viewBoxObject.width,
						height: viewBoxObject.height,
						viewBoxObject: viewBoxObject,
						yAxisLabel: 'Best',
						xAxisLabel: 'Elapsed Iteration',
						gridHorizontal: true })
				);
			}
		}]);
	
		return SimpleGraph;
	}(_react2.default.Component);
	
	var Graph = exports.Graph = (0, _reactDimensions2.default)()(SimpleGraph);

/***/ },

/***/ 604:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CrossoverProvider = __webpack_require__(605);
	
	var _MutationProvider = __webpack_require__(619);
	
	var _FitnessProvider = __webpack_require__(642);
	
	var _options = __webpack_require__(670);
	
	var _EvolutionProvider = __webpack_require__(671);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*export default ({ store }) => (
	    <div>
	        <EvolutionProvider store={store} />
	        <GAOptionsComponent store={store} />
	        <CrossoverProvider store={store} />
	        <MutationProvider store={store} />
	        <FitnessProvider store={store} />
	    </div>
	);*/
	
	exports.default = function (_ref) {
	    var store = _ref.store;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_EvolutionProvider.Component, { store: store }),
	        _react2.default.createElement(_options.render, { store: store }),
	        _react2.default.createElement(_CrossoverProvider.Component, { store: store }),
	        _react2.default.createElement(_MutationProvider.Component, { store: store }),
	        _react2.default.createElement(_FitnessProvider.Component, { store: store })
	    );
	};

/***/ },

/***/ 605:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Component = exports.run = undefined;
	
	var _createProvider2 = __webpack_require__(606);
	
	var _createProvider3 = _interopRequireDefault(_createProvider2);
	
	var _OnePointCrossover = __webpack_require__(616);
	
	var _OnePointCrossover2 = _interopRequireDefault(_OnePointCrossover);
	
	var _TwoPointCrossover = __webpack_require__(617);
	
	var _TwoPointCrossover2 = _interopRequireDefault(_TwoPointCrossover);
	
	var _RandomCrossover = __webpack_require__(618);
	
	var _RandomCrossover2 = _interopRequireDefault(_RandomCrossover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _createProvider = (0, _createProvider3.default)('crossover', [_OnePointCrossover2.default, _TwoPointCrossover2.default, _RandomCrossover2.default]);
	
	var run = _createProvider.run,
	    Component = _createProvider.Component;
	exports.run = run;
	exports.Component = Component;

/***/ },

/***/ 606:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createCompositeProvider = createCompositeProvider;
	
	var _createPluginsHash = __webpack_require__(607);
	
	var _createRenderComponent = __webpack_require__(608);
	
	var _BaseCalculateProvider = __webpack_require__(613);
	
	var _BaseCalculateProvider2 = _interopRequireDefault(_BaseCalculateProvider);
	
	var _CompositeCalculateProvider = __webpack_require__(614);
	
	var _CompositeCalculateProvider2 = _interopRequireDefault(_CompositeCalculateProvider);
	
	var _initialState = __webpack_require__(615);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = _initialState2.default.GA;
	
	function createCompositeProvider(providerName, context) {
		var plugins = (0, _createPluginsHash.createPluginsHash)(context);
		var instance = new _CompositeCalculateProvider2.default(plugins, initialState, providerName);
	
		// NOTE: run is actually getCalculation function
		var run = instance.getRunOnce.bind(instance);
		return {
			run: run,
			Component: (0, _createRenderComponent.createRenderComponent)(providerName, plugins)
		};
	}
	
	/**
	 * @param {string} providerName
	 * @param {Array<Object>} context
	 * @param {boolean} randomRun
	 * @returns {{ run: Function, Component: Function }}
	 */
	
	exports.default = function (providerName, context) {
		var randomRun = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
		var plugins = (0, _createPluginsHash.createPluginsHash)(context);
		var instance = new _BaseCalculateProvider2.default(plugins, initialState, providerName);
	
		// NOTE: run is actually getCalculation function
		var run = randomRun ? instance.getRunRandom.bind(instance) : instance.getRunOnce.bind(instance);
		return {
			run: run,
			Component: (0, _createRenderComponent.createRenderComponent)(providerName, plugins)
		};
	};

/***/ },

/***/ 607:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	 * @param {Array<{name: string, getInitialState: Function}>} context;
	 */
	var createPluginsHash = exports.createPluginsHash = function createPluginsHash(context) {
		return context.reduce(function (hash, value) {
			if (!value.getInitialState) {
				value.getInitialState = function () {
					return {};
				};
			}
			hash[value.name] = value;
			return hash;
		}, {});
	};

/***/ },

/***/ 608:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createRenderComponent = undefined;
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _UIFactory = __webpack_require__(609);
	
	var _index = __webpack_require__(612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description pluginKey = crossover | mutation | fitness | evolution
	 */
	var createRenderComponent = exports.createRenderComponent = function createRenderComponent(pluginKey, plugins) {
		var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
		    _ref$expanded = _ref.expanded,
		    expanded = _ref$expanded === undefined ? false : _ref$expanded;
	
		return function (_ref2) {
			var store = _ref2.store;
	
			var state = store.getState().GA[pluginKey];
	
			var onblur = function onblur(name, field, value) {
				store.dispatch((0, _index.changeOptions)([pluginKey, name, field], value));
			};
	
			var options = Object.keys(plugins).map(function (name) {
				var plugin = plugins[name];
				var innerMarkup = plugin.render && plugin.render(state[name], onblur.bind(null, name));
				return _react2.default.createElement(
					_reactBootstrap.Panel,
					{ header: name, key: name },
					_react2.default.createElement(_UIFactory.SliderControl, {
						defaultValue: state[name].weight,
						onBlur: onblur.bind(null, name),
						field: 'weight' }),
					innerMarkup
				);
			});
	
			return _react2.default.createElement(
				_reactBootstrap.Panel,
				{ defaultExpanded: expanded, collapsible: true, header: pluginKey + ' options' },
				options
			);
		};
	};

/***/ },

/***/ 609:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createSliderFactory = exports.probabilitySlider = exports.CheckboxControl = exports.SliderControl = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseControl = function (_React$Component) {
	    _inherits(BaseControl, _React$Component);
	
	    function BaseControl() {
	        _classCallCheck(this, BaseControl);
	
	        return _possibleConstructorReturn(this, (BaseControl.__proto__ || Object.getPrototypeOf(BaseControl)).apply(this, arguments));
	    }
	
	    _createClass(BaseControl, [{
	        key: 'render',
	        value: function render() {
	            throw new Error('Abstract class');
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(_ref, e) {
	            var field = _ref.field,
	                _ref$type = _ref.type,
	                type = _ref$type === undefined ? 'number' : _ref$type;
	
	            var value = void 0;
	            switch (type) {
	                case 'number':
	                    value = Number(e.target.value);
	                    break;
	                case 'boolean':
	                    value = e.target.checked;
	                    break;
	            }
	
	            this.props.onBlur(field, value);
	        }
	    }]);
	
	    return BaseControl;
	}(_react2.default.Component);
	
	//{ obj, field, ?title, ?min, ?max}
	
	
	var SliderControl = exports.SliderControl = function (_BaseControl) {
	    _inherits(SliderControl, _BaseControl);
	
	    function SliderControl(params) {
	        _classCallCheck(this, SliderControl);
	
	        var _this2 = _possibleConstructorReturn(this, (SliderControl.__proto__ || Object.getPrototypeOf(SliderControl)).call(this, params));
	
	        _this2.onChange = function (event) {
	            _this2.setState({ value: event.target.value });
	        };
	
	        var _this2$props = _this2.props,
	            field = _this2$props.field,
	            defaultValue = _this2$props.defaultValue;
	
	        _this2.state = { value: defaultValue };
	        _this2.blurBinded = _this2.onBlur.bind(_this2, { field: field, type: 'number' });
	        return _this2;
	    }
	
	    _createClass(SliderControl, [{
	        key: 'render',
	        value: function render() {
	            //optional
	            var title = this.props.title || _utils.stringUtils.camelCaseToHuman(this.props.field);
	            var min = this.props.min || 0;
	            var max = this.props.max || 1;
	            var step = this.props.step || 0.01;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    title,
	                    ' - ',
	                    this.state.value
	                ),
	                _react2.default.createElement('input', {
	                    type: 'range',
	                    value: this.state.value,
	                    min: min,
	                    max: max,
	                    step: step,
	                    onChange: this.onChange,
	                    onBlur: this.blurBinded })
	            );
	        }
	    }]);
	
	    return SliderControl;
	}(BaseControl);
	
	var CheckboxControl = exports.CheckboxControl = function (_BaseControl2) {
	    _inherits(CheckboxControl, _BaseControl2);
	
	    function CheckboxControl(params) {
	        _classCallCheck(this, CheckboxControl);
	
	        var _this3 = _possibleConstructorReturn(this, (CheckboxControl.__proto__ || Object.getPrototypeOf(CheckboxControl)).call(this, params));
	
	        _this3.state = { value: _this3.props.defaultValue };
	        return _this3;
	    }
	
	    _createClass(CheckboxControl, [{
	        key: 'onChange',
	        value: function onChange(event) {
	            this.setState({ value: event.target.value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                field = _props.field,
	                defaultValue = _props.defaultValue,
	                title = _props.title;
	
	            var actualTitle = title || _utils.stringUtils.camelCaseToHuman(field);
	            return _react2.default.createElement(
	                'div',
	                { className: 'checkbox' },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        defaultChecked: defaultValue,
	                        onChange: this.onChange.bind(this),
	                        onBlur: this.onBlur.bind(this, { field: field, type: 'boolean' }) }),
	                    actualTitle
	                )
	            );
	        }
	    }]);
	
	    return CheckboxControl;
	}(BaseControl);
	
	var probabilitySlider = exports.probabilitySlider = function probabilitySlider(field) {
	    return { field: field, min: 0, max: 1, step: 0.01 };
	};
	
	var createSliderFactory = exports.createSliderFactory = function createSliderFactory(state, onblur) {
	    return function (fields) {
	        return fields.map(function (_ref2) {
	            var field = _ref2.field,
	                _ref2$title = _ref2.title,
	                title = _ref2$title === undefined ? _utils.stringUtils.camelCaseToHuman(field) : _ref2$title,
	                _ref2$min = _ref2.min,
	                min = _ref2$min === undefined ? 1 : _ref2$min,
	                _ref2$max = _ref2.max,
	                max = _ref2$max === undefined ? 100 : _ref2$max,
	                _ref2$step = _ref2.step,
	                step = _ref2$step === undefined ? 1 : _ref2$step;
	            return _react2.default.createElement(SliderControl, {
	                key: field,
	                defaultValue: state[field],
	                onBlur: onblur,
	                field: field,
	                title: title,
	                min: min,
	                max: max,
	                step: step
	            });
	        });
	    };
	};

/***/ },

/***/ 610:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _NotesUtils = __webpack_require__(611);
	
	Object.defineProperty(exports, 'notesUtils', {
		enumerable: true,
		get: function get() {
			return _interopRequireDefault(_NotesUtils).default;
		}
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkArray(arr) {
		if (!Array.isArray(arr)) {
			throw new TypeError('arr should be an array ' + arr + ' given.');
		}
	}
	
	function checkObj(obj) {
		if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
			throw new TypeError('obj should be an object ' + obj + ' given');
		}
	}
	
	var numberUtils = {
		/**
	  * @param {number} startIndex
	  * @param {number} endIndex not included
	  * @returns {number}
	  */
		randomBetween: function randomBetween(startIndex, endIndex) {
			if (startIndex < 0 || endIndex < 0) {
				throw 'wft randomBetween';
			}
			if (endIndex === undefined) {
				endIndex = startIndex;
				startIndex = 0;
			}
	
			return Math.floor(Math.random() * endIndex) + startIndex;
		},
		normalizeValue: function normalizeValue(value, maxValue) {
			if (value <= maxValue) {
				return value;
			}
			var rem = value % maxValue;
			return rem ? rem : maxValue;
		},
	
	
		/**
	  * @param {number} value - float or int
	  * @param {{ max: number, min: number }} options
	  * @returns {number}
	  */
		strip: function strip(value) {
			var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
			    _ref$min = _ref.min,
			    min = _ref$min === undefined ? 0 : _ref$min,
			    _ref$max = _ref.max,
			    max = _ref$max === undefined ? 1 : _ref$max;
	
			if (value < min) {
				return min;
			}
	
			if (value >= max) {
				return max;
			}
	
			return value;
		},
	
	
		/**
	  * @param {number} basis
	  * @param {number} percent - from 0 to 1
	  * @param {{min: number, max: number}}
	  */
		fluctuate: function fluctuate(basis) {
			var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.2;
	
			var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
			    _ref2$min = _ref2.min,
			    min = _ref2$min === undefined ? 0 : _ref2$min,
			    _ref2$max = _ref2.max,
			    max = _ref2$max === undefined ? 1 : _ref2$max;
	
			var newValue = basis + percent * Math.random() * (randomUtils.headsOrTails() ? 1 : -1);
			return numberUtils.strip(newValue, { min: min, max: max });
		}
	};
	
	var arrayUtils = exports.arrayUtils = {
		last: function last(array) {
			return array[array.length - 1];
		},
	
	
		/**
	  * @param {T} value
	  * @param {number} length - int or float
	  * @returns {T[]}
	  */
		make: function make(value, length) {
			// NOTE: length converted to int to prevent infinite loop in while
			length = length | 0;
			var arr = [];
			while (length--) {
				arr[length] = value;
			}
			return arr;
		},
	
	
		/**
	  * @param {number} count
	  * @param {number} length
	  * @param {Array<number>} except - except indexes
	  * @returns {Array<number>}
	  */
		getRandomIndexes: function getRandomIndexes(count, length, except) {
			var result = [];
	
			if (count > length) {
				count = length;
			}
	
			while (count > 0) {
				var newIndex = numberUtils.randomBetween(length);
				if (result.indexOf(newIndex) !== -1) {
					continue;
				}
	
				if (except && except.includes(newIndex)) {
					continue;
				}
	
				result.push(newIndex);
				count--;
			}
	
			return result;
		},
		randomKey: function randomKey(arr) {
			checkArray(arr);
			return numberUtils.randomBetween(arr.length);
		},
		randomElement: function randomElement(arr) {
			var randomKey = arrayUtils.randomKey(arr);
			return arr[randomKey];
		},
		findObjectByKey: function findObjectByKey(array, field, value) {
			return array.find(function (element) {
				return element.hasOwnProperty(field) && element[field] === value;
			});
		}
	};
	
	var objectUtils = {
		randomElement: function randomElement(obj) {
			checkObj(obj);
			var keys = Object.keys(obj);
			var randomKey = arrayUtils.randomElement(keys);
			return obj[randomKey];
		}
	};
	
	var stringUtils = {
		camelCaseToHuman: function camelCaseToHuman(str) {
			// \d - any digit 0..9 and other locals
			var reg = /([a-z])([A-Z])/g;
			var template = '$1 $2';
			var splitter = ' ';
	
			return str.replace(reg, template).split(splitter).map(function (w) {
				return stringUtils.firstUpper(w);
			}).join(splitter);
		},
		firstUpper: function firstUpper(str) {
			return '' + str[0].toUpperCase() + str.slice(1).toLowerCase();
		}
	};
	
	var selectionUtils = {
		/**
	  * @param {Object} obj
	  * @param {(field: object) => number} fn - weight getter. Should be between 0 and 1
	  * @returns {string}
	  */
		getRandomKey: function getRandomKey(obj) {
			var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
				return x;
			};
	
			var keys = Object.keys(obj);
			var weights = Object.values(obj).map(function (value) {
				return fn(value) * 100;
			});
			return selectionUtils._roulette(keys, weights);
		},
		getRandomKeyByWeight: function getRandomKeyByWeight(obj) {
			return selectionUtils.getRandomKey(obj, function (x) {
				return x.weight;
			});
		},
		_roulette: function _roulette(keys, weights) /*: string (key)*/{
			var rouletteArray = [];
	
			keys.forEach(function (key, i) {
				rouletteArray = rouletteArray.concat(arrayUtils.make(key, weights[i]));
			});
	
			var index = numberUtils.randomBetween(rouletteArray.length);
			return rouletteArray[index];
		}
	};
	
	var randomUtils = exports.randomUtils = {
		headsOrTails: function headsOrTails() {
			return Math.random() > 0.5;
		}
	};
	
	// https://gist.github.com/jed/982883
	var uuid = exports.uuid = function uuid(a) {
		return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
	};
	
	exports.objUtils = objectUtils;
	exports.numberUtils = numberUtils;
	exports.stringUtils = stringUtils;
	exports.selectionUtils = selectionUtils;

/***/ },

/***/ 611:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PAUSE = 0;
	var HOLD = -1;
	
	var NotesUtils = function () {
		function NotesUtils() {
			_classCallCheck(this, NotesUtils);
		}
	
		_createClass(NotesUtils, [{
			key: "toRhythm",
	
			/*
	  	[1, -2, 3, 1, 1] where 1 is 1/8 and "-" is pause
	  */
			// TODO: redo fitness and this creepy logic
			value: function toRhythm(data) {
				var result = [];
				var bar = undefined;
	
				data.forEach(function (item, i) {
					if (i % 8 === 0) {
						if (bar) {
							result.push(bar);
						}
						bar = [];
					}
	
					if (item === PAUSE) {
						bar.push(-1);
						return;
					}
	
					if (item === HOLD && bar.length) {
						var prevIndex = bar.length - 1;
						var prevValue = bar[prevIndex];
						bar[prevIndex] = prevValue > 0 ? prevValue + 1 : prevValue - 1;
						return;
					}
	
					bar.push(1);
				});
				result.push(bar);
	
				return result;
			}
		}, {
			key: "toPitch",
			value: function toPitch(data) {
				var ignoreOctaves = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				var result = [];
				var bar = undefined;
	
				data.forEach(function (item, i) {
					if (i % 8 === 0) {
						if (bar) {
							result.push(bar);
						}
						bar = [];
					}
					if (item === PAUSE || item === HOLD) {
						return;
					}
	
					bar.push(ignoreOctaves ? item % 7 : item);
				});
	
				if (bar.length) {
					result.push(bar);
				}
	
				return result;
			}
		}]);
	
		return NotesUtils;
	}();
	
	exports.default = new NotesUtils();

/***/ },

/***/ 612:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.changeOptions = changeOptions;
	var OPTIONS_CHANGE_ACTION = exports.OPTIONS_CHANGE_ACTION = 'optionsChangeAction';
	
	function changeOptions(optionsPath, value) {
		return {
			type: OPTIONS_CHANGE_ACTION,
			optionsPath: optionsPath,
			value: value
		};
	}

/***/ },

/***/ 613:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(610);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @description Provides calculation fn
	 * 1) Once (current fitness, crossover)
	 * 2) New everytime (mutations)
	 */
	var BaseCalculateProvider = function () {
		function BaseCalculateProvider(allPlugins, initialState, name) {
			_classCallCheck(this, BaseCalculateProvider);
	
			this._all = allPlugins;
			this._providerName = name; // Mutation, Crossover, Fitness. (any Genetic Operator)
			this._registerInStore(initialState);
		}
	
		/**
	  * @description Gets run function once
	  */
	
	
		_createClass(BaseCalculateProvider, [{
			key: 'getRunOnce',
			value: function getRunOnce(options) {
				var _getKeyAndFunction2 = this._getKeyAndFunction(options),
				    fn = _getKeyAndFunction2.fn,
				    key = _getKeyAndFunction2.key;
	
				var settings = options[key];
	
				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}
	
					return fn.run.apply(fn, _toConsumableArray(args.concat(settings)));
				};
			}
		}, {
			key: 'getRunRandom',
			value: function getRunRandom(options) {
				var _this = this;
	
				return function () {
					for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
						args[_key2] = arguments[_key2];
					}
	
					var _getKeyAndFunction3 = _this._getKeyAndFunction(options),
					    fn = _getKeyAndFunction3.fn,
					    key = _getKeyAndFunction3.key;
	
					var argsExtended = args.concat(options[key]);
					return fn.run.apply(fn, _toConsumableArray(argsExtended));
				};
			}
		}, {
			key: '_getKeyAndFunction',
			value: function _getKeyAndFunction(options) {
				var key = this._getKey(options);
				var fn = this._getFunction(key);
				return { key: key, fn: fn };
			}
		}, {
			key: '_getKey',
			value: function _getKey(options) {
				return _utils.selectionUtils.getRandomKeyByWeight(options);
			}
		}, {
			key: '_getFunction',
			value: function _getFunction(key) {
				return this._all[key];
			}
		}, {
			key: '_registerInStore',
			value: function _registerInStore(initialState) {
				var _this2 = this;
	
				initialState[this._providerName] = {};
				Object.keys(this._all).map(function (key) {
					return _this2._all[key];
				}).forEach(function (_ref) {
					var name = _ref.name,
					    getInitialState = _ref.getInitialState;
					return initialState[_this2._providerName][name] = getInitialState();
				});
			}
		}]);
	
		return BaseCalculateProvider;
	}();
	
	exports.default = BaseCalculateProvider;

/***/ },

/***/ 614:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(198);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _BaseCalculateProvider = __webpack_require__(613);
	
	var _BaseCalculateProvider2 = _interopRequireDefault(_BaseCalculateProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CompositeCalculateProvider = function (_BaseCalculateProvide) {
		_inherits(CompositeCalculateProvider, _BaseCalculateProvide);
	
		function CompositeCalculateProvider() {
			_classCallCheck(this, CompositeCalculateProvider);
	
			return _possibleConstructorReturn(this, (CompositeCalculateProvider.__proto__ || Object.getPrototypeOf(CompositeCalculateProvider)).apply(this, arguments));
		}
	
		_createClass(CompositeCalculateProvider, [{
			key: 'getRunOnce',
	
			/**
	   * @description Gets run function once
	   */
			value: function getRunOnce(options) {
				var _this2 = this;
	
				// get bounded fn and keys * weights
	
				var MAX_WEIGHT = Object.keys(options).map(function (k) {
					return options[k].weight;
				}).reduce(function (sum, weight) {
					return sum + weight;
				}, 0);
	
				var keyWeightRaw = (0, _lodash2.default)(options).pickBy(function (_ref) {
					var weight = _ref.weight;
					return weight > 0;
				});
	
				var keyWeight = keyWeightRaw.mapValues(function (v) {
					return v.weight / MAX_WEIGHT;
				}).value();
	
				// NOTE: pick first provider with _important key if it's here
				// TODO: DEBUG {
				{
					var debugKeyWeight = Object.keys(options).reduce(function (reducer, key) {
						var _important = options[key]._important;
	
	
						if (reducer.found) {
							return reducer;
						}
	
						if (_important) {
							reducer.found = true;
							reducer.value[key] = 1;
						}
	
						return reducer;
					}, { found: false, value: {} }).value;
					if (!_lodash2.default.isEmpty(debugKeyWeight)) {
						keyWeight = debugKeyWeight;
					}
				}
				// }
	
				var fnsAndWeight = Object.keys(keyWeight).reduce(function (reducer, key) {
					var settings = options[key];
					var weight = keyWeight[key];
					var _fn = _this2._all[key].run;
	
					return _extends({}, reducer, _defineProperty({}, key, {
						key: key,
						weight: weight,
						fn: function fn() {
							for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
								args[_key] = arguments[_key];
							}
	
							return _fn.apply(undefined, [].concat(args, [settings]));
						}
					}));
				}, {});
	
				return function () {
					for (var _len2 = arguments.length, data = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
						data[_key2] = arguments[_key2];
					}
	
					return Object.keys(fnsAndWeight).map(function (k) {
						return fnsAndWeight[k];
					}).reduce(function (reducer, _ref2) {
						var fn = _ref2.fn,
						    weight = _ref2.weight,
						    key = _ref2.key;
	
						var value = fn.apply(undefined, data) * weight;
						return {
							value: value + reducer.value,
							full: _extends({}, reducer.full, _defineProperty({}, key, value))
						};
					}, {
						value: 0,
						full: {}
					});
				};
			}
		}, {
			key: 'getRunRandom',
			value: function getRunRandom() {
				throw new Error('CompositeCalculateProvider use only run once fn');
			}
		}]);
	
		return CompositeCalculateProvider;
	}(_BaseCalculateProvider2.default);
	
	exports.default = CompositeCalculateProvider;

/***/ },

/***/ 615:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// NOTE: populated by plugins, etc
	var initialState = {
		GA: {}
	};
	exports.default = initialState;

/***/ },

/***/ 616:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _utils = __webpack_require__(610);
	
	function createPortion(source, point) {
		return [source.slice(0, point), source.slice(point)];
	}
	
	function crossover(a, b) {
		var point = _utils.numberUtils.randomBetween(a.length);
		var aPortions = createPortion(a, point);
		var bPortions = createPortion(b, point);
	
		if (Math.random() > 0.5) {
			return [].concat(aPortions[0], bPortions[1]);
		} else {
			return [].concat(bPortions[0], aPortions[1]);
		}
	}
	
	var getInitialState = function getInitialState() {
		return { weight: 0.5 };
	};
	
	exports.default = {
		name: 'one-point-crossover',
		run: crossover,
		getInitialState: getInitialState
	};

/***/ },

/***/ 617:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _utils = __webpack_require__(610);
	
	function createPortion(source, firstPoint, secondPoint) {
		return [source.slice(0, firstPoint), source.slice(firstPoint, secondPoint), source.slice(secondPoint)];
	}
	
	function crossover(a, b) {
		var result = [];
		var firstPoint = _utils.numberUtils.randomBetween(a.length);
		var secondPoint = _utils.numberUtils.randomBetween(a.length);
		var aUsed = false;
		var bUsed = false;
	
		while (secondPoint === firstPoint) {
			secondPoint = _utils.numberUtils.randomBetween(a.length);
		}
	
		if (firstPoint > secondPoint) {
			var temp = firstPoint;
			firstPoint = secondPoint;
			secondPoint = temp;
		}
	
		var aPortions = createPortion(a, firstPoint, secondPoint);
		var bPortions = createPortion(b, firstPoint, secondPoint);
	
		for (var i = 0, l = aPortions.length; i < l; i++) {
			if (i === l - 1) {
				if (!bUsed) {
					result = result.concat(bPortions[i]);
					continue;
				} else if (!aUsed) {
					result = result.concat(aPortions[i]);
					continue;
				}
			}
	
			if (_utils.randomUtils.headsOrTails()) {
				result = result.concat(aPortions[i]);
				aUsed = true;
			} else {
				result = result.concat(bPortions[i]);
				bUsed = true;
			}
		}
	
		return result;
	}
	
	var getInitialState = function getInitialState() {
		return { weight: 0.7 };
	};
	
	exports.default = {
		name: 'two-point-crossover',
		getInitialState: getInitialState,
		run: crossover
	};

/***/ },

/***/ 618:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _utils = __webpack_require__(610);
	
	function crossover(a, b) {
		var clone = b.slice();
		var indexes = _utils.arrayUtils.getRandomIndexes(a.length / 2, a.length);
	
		indexes.forEach(function (index) {
			clone[index] = a[index];
		});
	
		return clone;
	}
	
	var getInitialState = function getInitialState() {
		return { weight: 0.5 };
	};
	
	exports.default = {
		name: 'random-crossover',
		run: crossover,
		getInitialState: getInitialState
	};

/***/ },

/***/ 619:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Component = exports.run = undefined;
	
	var _createProvider2 = __webpack_require__(606);
	
	var _createProvider3 = _interopRequireDefault(_createProvider2);
	
	var _changeDurationMutation = __webpack_require__(620);
	
	var _changeDurationMutation2 = _interopRequireDefault(_changeDurationMutation);
	
	var _copyPasteMutation = __webpack_require__(627);
	
	var _copyPasteMutation2 = _interopRequireDefault(_copyPasteMutation);
	
	var _orderMutation = __webpack_require__(632);
	
	var _orderMutation2 = _interopRequireDefault(_orderMutation);
	
	var _randomMutation = __webpack_require__(633);
	
	var _randomMutation2 = _interopRequireDefault(_randomMutation);
	
	var _reverseMutation = __webpack_require__(634);
	
	var _reverseMutation2 = _interopRequireDefault(_reverseMutation);
	
	var _sortMutation = __webpack_require__(635);
	
	var _sortMutation2 = _interopRequireDefault(_sortMutation);
	
	var _swap2Mutation = __webpack_require__(637);
	
	var _swap2Mutation2 = _interopRequireDefault(_swap2Mutation);
	
	var _swapGroupMutation = __webpack_require__(638);
	
	var _swapGroupMutation2 = _interopRequireDefault(_swapGroupMutation);
	
	var _transposeMutation = __webpack_require__(639);
	
	var _transposeMutation2 = _interopRequireDefault(_transposeMutation);
	
	var _upAndDownMutation = __webpack_require__(641);
	
	var _upAndDownMutation2 = _interopRequireDefault(_upAndDownMutation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _createProvider = (0, _createProvider3.default)('mutation', [_changeDurationMutation2.default, _copyPasteMutation2.default, _orderMutation2.default, _randomMutation2.default, _reverseMutation2.default, _sortMutation2.default, _swap2Mutation2.default, _swapGroupMutation2.default, _transposeMutation2.default, _upAndDownMutation2.default], true /* random run on every request */);
	
	var run = _createProvider.run,
	    Component = _createProvider.Component;
	exports.run = run;
	exports.Component = Component;

/***/ },

/***/ 620:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _utils = __webpack_require__(610);
	
	var _Composition = __webpack_require__(621);
	
	var _Composition2 = _interopRequireDefault(_Composition);
	
	var _NotesConverter = __webpack_require__(622);
	
	var _NotesConverter2 = _interopRequireDefault(_NotesConverter);
	
	var _Note = __webpack_require__(623);
	
	var _Note2 = _interopRequireDefault(_Note);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultOptions = {
		count: 64
	};
	
	// TODO: class vs functions combination
	
	var ChangeDuration = function () {
		function ChangeDuration() {
			_classCallCheck(this, ChangeDuration);
		}
	
		_createClass(ChangeDuration, [{
			key: 'mutate',
			value: function mutate(data) {
				var _this = this;
	
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				options = Object.assign({}, defaultOptions, options);
	
				var composition = new _Composition2.default(data);
				var bars = composition.bars();
	
				var newBars = bars.map(function (bar) {
					var countOfIndexes = Math.floor(options.count / bars.length);
					var maxIndex = bar.length - 1 - 1; //we need neighbor
	
	
					if (countOfIndexes >= maxIndex) {
						return bar;
					}
	
					return _utils.arrayUtils.getRandomIndexes(countOfIndexes, maxIndex).reduce(function (store, mutateIndex) {
						// If random index exist before but now array (bar) became smaller so we don't have it
						if (!store[mutateIndex + 1]) {
							return store;
						}
						var mutateNotes = [store[mutateIndex].clone(), store[mutateIndex + 1].clone()];
						return [].concat(_toConsumableArray(store.slice(0, mutateIndex).map(function (n) {
							return n.clone();
						})), _toConsumableArray(_this._mutateOne.apply(_this, mutateNotes)), _toConsumableArray(store.slice(mutateIndex + 2)));
					}, bar);
				});
	
				return _NotesConverter2.default.fromBarsToRaw(newBars);
			}
	
			/**
	   * @param  {Note} a [description]
	   * @param  {Note} b [description]
	   * @return {[Note, Note] | [Note]}
	   */
	
		}, {
			key: '_mutateOne',
			value: function _mutateOne(a, b) {
				var inverse = false;
	
				if (Math.random() < 0.5) {
					inverse = true;
					var _ref = [b, a];
					a = _ref[0];
					b = _ref[1];
				}
	
				var newA = _Note2.default.create(a.value(), a.length() + 1);
	
				if (b.length() === 1) {
					return [newA];
				}
	
				var newB = _Note2.default.create(b.value(), b.length() - 1);
				return inverse ? [newB, newA] : [newA, newB];
			}
		}]);
	
		return ChangeDuration;
	}();
	
	var instance = new ChangeDuration();
	
	var run = instance.mutate.bind(instance);
	
	var render = function render(state, onblur) {
		return _react2.default.createElement(_UIFactory.SliderControl, {
			defaultValue: state.count,
			onBlur: onblur.bind(null, 'count'),
			field: 'count',
			title: 'Count of genes',
			min: 1,
			max: 16,
			step: 1
		});
	};
	
	var getInitialState = function getInitialState() {
		return {
			weight: 0.4,
			count: 7
		};
	};
	
	exports.default = {
		name: 'change-duration-mutation',
		run: run,
		render: render,
		getInitialState: getInitialState
	};

/***/ },

/***/ 621:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _NotesConverter = __webpack_require__(622);
	
	var _NotesConverter2 = _interopRequireDefault(_NotesConverter);
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Composition = function () {
		_createClass(Composition, null, [{
			key: 'create',
			value: function create(raw, barLength) {
				return new Composition(raw, barLength);
			}
		}]);
	
		function Composition(raw) {
			var barLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _MusicContext2.default.getBarLength();
	
			_classCallCheck(this, Composition);
	
			if (!Array.isArray(raw)) {
				throw 'Invalid argument raw: ' + raw + ', should be an array of numbers';
			}
	
			this._barLength = barLength;
			this._raw = null;
			this._notes = null;
			this._bars = null;
	
			this._updateState(raw);
		}
	
		_createClass(Composition, [{
			key: 'length',
			value: function length() {
				return this._notes.length;
			}
		}, {
			key: 'bars',
			value: function bars() {
				var _this = this;
	
				var result = [];
				var bar = [];
				var counter = 0;
	
				this._notes.forEach(function (note) {
					counter += note.length();
					bar.push(note.clone());
	
					console.assert(counter <= _this._barLength, 'Counter: ' + counter + ' but should be less than ' + _this._barLength);
					if (counter === _this._barLength) {
						counter = 0;
						result.push(bar);
						bar = [];
					}
				});
	
				return result;
			}
		}, {
			key: 'rawBars',
			value: function rawBars() {
				return this.bars().map(function (bar) {
					return bar.reduce(function (reducer, note) {
						return [].concat(_toConsumableArray(reducer), _toConsumableArray(note.toRaw()));
					}, []);
				});
			}
		}, {
			key: 'raw',
			value: function raw() {
				return this._raw.slice();
			}
		}, {
			key: '_updateState',
			value: function _updateState(raw) {
				this._raw = raw.slice();
				this._notes = _NotesConverter2.default.toNotes(this._raw);
				this._bars = this.bars();
			}
		}]);
	
		return Composition;
	}();
	
	exports.default = Composition;

/***/ },

/***/ 622:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Note = __webpack_require__(623);
	
	var _Note2 = _interopRequireDefault(_Note);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NotesConverter = function () {
		function NotesConverter() {
			_classCallCheck(this, NotesConverter);
	
			this._PAUSE = 0;
			this._HOLD = -1;
		}
	
		_createClass(NotesConverter, [{
			key: 'toNotes',
			value: function toNotes(raw) {
				var result = [];
				var previousNoteValue = 0;
	
				for (var i = 0, l = raw.length; i < l; i++) {
					var item = raw[i];
	
					// If first item is hold
					if (i === 0 && item === this._HOLD) {
						//console.warn('First note is hold! Something wrong, replace it with pause');
						result.push(_Note2.default.create(0, 1, false));
						continue;
					}
	
					// If Hold on first note of bars
					if (item === this._HOLD && i % 8 === 0) {
						result.push(_Note2.default.create(previousNoteValue, 1, true));
						continue;
					}
	
					if (item === this._HOLD) {
						var last = result.pop();
						result.push(_Note2.default.create(last.value(), last.length() + 1, false));
						continue;
					}
	
					previousNoteValue = item;
					result.push(_Note2.default.create(item, 1, false));
				}
	
				return result;
			}
		}, {
			key: 'fromBarsToRaw',
			value: function fromBarsToRaw(bars) {
				var result = [];
	
				bars.forEach(function (bar) {
					bar.forEach(function (n) {
						result = result.concat(n.toRaw());
					});
				});
	
				return result;
			}
		}]);
	
		return NotesConverter;
	}();
	
	exports.default = new NotesConverter();

/***/ },

/***/ 623:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //#technical_debt value in range [-1 .. 14]
	
	
	var _common = __webpack_require__(624);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PAUSE = 0;
	var NOTES_IN_OCTAVE = 7;
	
	var Note = function () {
		function Note(value) {
			var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
			var legato = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
			_classCallCheck(this, Note);
	
			if (value < 0 || _common.availableValues.indexOf(value) === -1) {
				throw 'Invalid argument value: ' + value;
			}
	
			if (!Number.isInteger(length) || length <= 0) {
				throw 'Invalid argument length: ' + length;
			}
	
			this._value = value;
			this._length = length;
			this._legato = legato;
		}
	
		_createClass(Note, [{
			key: 'clone',
			value: function clone() {
				return new Note(this._value, this._length, this._legato);
			}
		}, {
			key: 'pitch',
			value: function pitch() {
				var ignoreOctave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
				if (!this.isNote()) {
					throw 'Current note is pause';
				}
	
				return ignoreOctave ? this._value % NOTES_IN_OCTAVE : this._value;
			}
		}, {
			key: 'value',
			value: function value() {
				return this._value;
			}
		}, {
			key: 'length',
			value: function length() {
				return this._length;
			}
		}, {
			key: 'isNote',
			value: function isNote() {
				return this._value > PAUSE;
			}
		}, {
			key: 'isPause',
			value: function isPause() {
				return this._value === PAUSE;
			}
	
			// TODO: redo with reduce ... that's unreadable
	
		}, {
			key: 'toRaw',
			value: function toRaw() {
				var result = [this._value];
	
				if (this._length > 1) {
					var count = this._length - 1;
					while (count > 0) {
						count--;
						result.push(-1);
					}
				}
	
				return result;
			}
	
			//Immutable
			/**
	   * @param  {Number} howMuch
	   * @return {Note}
	   */
	
		}, {
			key: 'increaseLength',
			value: function increaseLength() {
				var howMuch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
				return this._changeLength(howMuch);
			}
	
			/**
	   * @param  {Number} howMuch
	   * @return {Note}
	   */
	
		}, {
			key: 'decreaseLength',
			value: function decreaseLength() {
				var howMuch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
				if (this._length === 1) {
					throw 'Length can not be less than 1';
				}
				return this._changeLength(-howMuch);
			}
	
			/**
	   * @param  {Number} howMuch
	   * @return {Note}
	   */
	
		}, {
			key: '_changeLength',
			value: function _changeLength(howMuch) {
				return Note.create(this._value, this._length + howMuch);
			}
		}], [{
			key: 'create',
			value: function create(value, length, legato) {
				return new Note(value, length, legato);
			}
		}]);
	
		return Note;
	}();
	
	exports.default = Note;

/***/ },

/***/ 624:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	//TODO: get it from music context?/
	var availableValues = exports.availableValues = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
	
	/*
	grid - 1/8
	-1 - previous
	0 - pause
	1 - C
	2 - D
	...
	*/
	//grid - 1/8
	var REFERENCE_INDIVIDUAL = exports.REFERENCE_INDIVIDUAL = [3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 5, -1, 1, -1, -1, 2, 3, -1, -1, -1, -1, -1, -1, -1, 4, -1, 4, -1, 4, -1, -1, 4, 4, -1, 3, -1, 3, -1, 3, 3, 3, -1, 2, -1, 2, -1, 3, -1, 2, -1, -1, -1, 5, -1, -1, -1, 3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 5, -1, 1, -1, -1, 2, 3, -1, -1, -1, -1, -1, -1, -1, 4, -1, 4, -1, 4, -1, -1, 4, 4, -1, 3, -1, 3, -1, 3, 3, 5, -1, 5, -1, 4, -1, 2, -1, 1, -1, -1, -1, -1, -1, -1, -1];
	
	//ЧИЖИК
	/*export const REFERENCE_INDIVIDUAL = [
		10, -1, 8, -1, 10, -1, 8, -1,
		11, -1, 10, -1, 9, -1, -1, -1,
	
		5, -1, 5, -1, 5, -1, 6, 7,
		8, -1, 8, -1, 8, -1, -1, -1,
	
		10, -1, 8, -1, 10, -1, 8, -1,
		11, -1, 10, -1, 9, -1, -1, -1,
	
		5, -1, 5, -1, 5, -1, 6, 7,
		8, -1, 8, -1, 8, -1, -1, -1,
	
		10, -1, 8, -1, 10, -1, 8, -1,
		11, -1, 10, -1, 9, -1, -1, -1,
	
		5, -1, 5, -1, 5, -1, 6, 7,
		8, -1, 8, -1, 8, -1, -1, -1,
	
		10, -1, 8, -1, 10, -1, 8, -1,
		11, -1, 10, -1, 9, -1, -1, -1,
	
		5, -1, 5, -1, 5, -1, 6, 7,
		8, -1, 8, -1, 8, -1, -1, -1
	];
	
	*/
	var SOVIET = exports.SOVIET = [8, 6, -1, 8, -1, 9, -1, 12, -1, 11, -1, -1, -1, -1, -1, 11, 12, 11, -1, 10, -1, 9, -1, 12, -1, 11, -1, -1, -1, -1, -1, -1, 11, 11, -1, 10, -1, 11, -1, -1, 9, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 5, 8, 9, 8, 7, 0, 0, 0, 0, 0, 0, 0, 6];

/***/ },

/***/ 625:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.HOLD = exports.PAUSE = exports.availableValuesInGF = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _SimpleStorage = __webpack_require__(626);
	
	var _SimpleStorage2 = _interopRequireDefault(_SimpleStorage);
	
	var _common = __webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_BAR_LENGTH = 8;
	
	// TODO: use MusicContext instead
	var availableValuesInGF = exports.availableValuesInGF = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
	var PAUSE = exports.PAUSE = 0;
	var HOLD = exports.HOLD = -1;
	
	// TODO: used in composition/s jsx
	
	var MusicContext = function () {
		function MusicContext() {
			_classCallCheck(this, MusicContext);
		}
	
		_createClass(MusicContext, [{
			key: 'selectComposition',
			value: function selectComposition(key) {
				_SimpleStorage2.default.setCurrent(key);
			}
		}, {
			key: 'getCurrentComposition',
			value: function getCurrentComposition() {
				return _SimpleStorage2.default.getCurrent() || _common.REFERENCE_INDIVIDUAL;
			}
		}, {
			key: 'getCurrentKey',
			value: function getCurrentKey() {
				return _SimpleStorage2.default.getCurrentKey();
			}
		}, {
			key: 'getCompositionLength',
			value: function getCompositionLength() {
				return 128;
			}
		}, {
			key: 'getAllCompositions',
			value: function getAllCompositions() {
				return _SimpleStorage2.default.getKeys();
			}
		}, {
			key: 'isValidName',
			value: function isValidName(name) {
				return this.getAllCompositions().indexOf(name) === -1;
			}
		}, {
			key: 'save',
			value: function save(name, composition) {
				return _SimpleStorage2.default.save(name, composition);
			}
		}, {
			key: 'remove',
			value: function remove(name) {
				return _SimpleStorage2.default.remove(name);
			}
		}, {
			key: 'getByKey',
			value: function getByKey(key) {
				return _SimpleStorage2.default.getByKey(key);
			}
		}, {
			key: 'getDefault',
			value: function getDefault() {
				return _SimpleStorage2.default.getDefault();
			}
		}, {
			key: 'getBarLength',
			value: function getBarLength() {
				// FIXME: HARDCODE FOR NOW
				return DEFAULT_BAR_LENGTH;
			}
		}, {
			key: 'getMaxOneOctaveValue',
			value: function getMaxOneOctaveValue() {
				return 7;
			}
		}, {
			key: 'getAvailableValues',
			value: function getAvailableValues(ignoreOctaves) {
				var maxOneOctaveValue = this.getMaxOneOctaveValue();
				return ignoreOctaves ? availableValuesInGF.filter(function (x) {
					return x <= maxOneOctaveValue;
				}) : availableValuesInGF;
			}
		}, {
			key: 'getAvailablePitchValues',
			value: function getAvailablePitchValues() {
				var excludeArray = [PAUSE, HOLD];
				return availableValuesInGF.filter(function (x) {
					return !excludeArray.includes(x);
				});
			}
	
			// TODO: here for now
	
		}, {
			key: 'getIntervalReference',
			value: function getIntervalReference() {
				//only for Cmaj in halftones
				var INTERVAL_REFERENCE = [
				//First octave
				2, //C-D
				2, //D-E
				1, //E-F
				2, //F-G
				2, //G-A
				2, //A-B
				1, //B-C
				//Second octave
				2, //C-D
				2, //D-E
				1, //E-F
				2, //F-G
				2, //G-A
				2, //A-B
				1 //B-C
				];
	
				return INTERVAL_REFERENCE;
			}
		}, {
			key: 'getHalfTonesBeetween',
			value: function getHalfTonesBeetween(a, b) {
				var intervalReference = this.getIntervalReference();
				if (a > b) {
					var temp = a;
					a = b;
					b = temp;
				}
	
				var arrayToSum = intervalReference.slice(a, b);
	
				return arrayToSum.reduce(function (prevValue, item) {
					return prevValue + item;
				}, 0);
			}
		}]);
	
		return MusicContext;
	}();
	
	exports.default = new MusicContext();

/***/ },

/***/ 626:
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FIRMWARE_INDIVIDUAL_KEY = 'default';
	var FIRMWARE_INDIVIDUAL = [3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 5, -1, 1, -1, -1, 2, 3, -1, -1, -1, -1, -1, -1, -1, 4, -1, 4, -1, 4, -1, -1, 4, 4, -1, 3, -1, 3, -1, 3, 3, 3, -1, 2, -1, 2, -1, 3, -1, 2, -1, -1, -1, 5, -1, -1, -1, 3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 3, -1, 3, -1, -1, -1, 3, -1, 5, -1, 1, -1, -1, 2, 3, -1, -1, -1, -1, -1, -1, -1, 4, -1, 4, -1, 4, -1, -1, 4, 4, -1, 3, -1, 3, -1, 3, 3, 5, -1, 5, -1, 4, -1, 2, -1, 1, -1, -1, -1, -1, -1, -1, -1];
	
	var ALL_KEY = '__all';
	var CURRENT_KEY = '__current';
	
	var localStorageInstance = global.localStorage || {
		getItem: function getItem() {
			return undefined;
		},
		setItem: function setItem() {
			return undefined;
		},
		removeItem: function removeItem() {
			return undefined;
		},
		clear: function clear() {
			return undefined;
		}
	};
	
	var SimpleStorage = function () {
		function SimpleStorage() {
			_classCallCheck(this, SimpleStorage);
		}
	
		_createClass(SimpleStorage, [{
			key: 'getKeys',
			value: function getKeys() {
				var keys = this._getKeys();
				if (!keys) {
					return [FIRMWARE_INDIVIDUAL_KEY];
				}
				keys.unshift(FIRMWARE_INDIVIDUAL_KEY);
				return keys;
			}
		}, {
			key: '_getKeys',
			value: function _getKeys() {
				var keysRaw = localStorageInstance.getItem(ALL_KEY);
				return JSON.parse(keysRaw);
			}
		}, {
			key: 'getDefault',
			value: function getDefault() {
				return FIRMWARE_INDIVIDUAL;
			}
		}, {
			key: 'getByKey',
			value: function getByKey(key) {
				if (key === FIRMWARE_INDIVIDUAL_KEY) {
					return this.getDefault();
				}
	
				var compositionRaw = localStorageInstance.getItem(key);
				if (!compositionRaw) {
					return null;
				}
				return JSON.parse(compositionRaw);
			}
		}, {
			key: 'save',
			value: function save(key, value) {
				try {
					value = JSON.stringify(value);
					localStorageInstance.setItem(key, value);
					var prevKeys = JSON.parse(localStorageInstance.getItem(ALL_KEY)) || [];
	
					if (prevKeys.indexOf(key) === -1) {
						prevKeys.push(key);
					}
	
					localStorageInstance.setItem(ALL_KEY, JSON.stringify(prevKeys));
				} catch (e) {
					console.warn('You got invalid data');
					return false;
				}
				return true;
			}
		}, {
			key: 'getCurrentKey',
			value: function getCurrentKey() {
				return localStorageInstance.getItem(CURRENT_KEY) || 'default';
			}
		}, {
			key: 'getCurrent',
			value: function getCurrent() {
				return this.getByKey(this.getCurrentKey());
			}
		}, {
			key: 'setCurrent',
			value: function setCurrent(key) {
				localStorageInstance.setItem(CURRENT_KEY, key);
			}
		}, {
			key: 'remove',
			value: function remove(key) {
				var prevKeys = JSON.parse(localStorageInstance.getItem(ALL_KEY)) || [];
				var index = prevKeys.indexOf(key);
				if (index !== -1) {
					prevKeys.splice(index, 1);
				}
				localStorageInstance.setItem(ALL_KEY, JSON.stringify(prevKeys));
				localStorageInstance.removeItem(key);
			}
		}, {
			key: 'clear',
			value: function clear() {
				localStorageInstance.clear();
			}
		}]);
	
		return SimpleStorage;
	}();
	
	exports.default = new SimpleStorage();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 627:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createGroupMutation = __webpack_require__(628);
	
	exports.default = (0, _createGroupMutation.createGroupMutation)('copy-paste-mutation', function (groups, _ref) {
		var _ref2 = _slicedToArray(_ref, 2),
		    fromIndexes = _ref2[0],
		    toIndexes = _ref2[1];
	
		groups.copy(fromIndexes, toIndexes);
	});

/***/ },

/***/ 628:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createCalculate = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.createGroupMutation = createGroupMutation;
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _createGroupsWithRandomOffset = __webpack_require__(629);
	
	var _common = __webpack_require__(631);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description options.groupSize in percents!
	 */
	var createCalculate = exports.createCalculate = function createCalculate(fn) {
		return function (data, options) {
			if (!(Array.isArray(data) && data.every(function (item) {
				return typeof item === 'number';
			}))) {
				throw new TypeError('Value of argument "data" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(data));
			}
	
			if (!(options != null && typeof options.groupSize === 'number' && typeof options.count === 'number')) {
				throw new TypeError('Value of argument "options" violates contract.\n\nExpected:\n{\n  groupSize: number;\n  count: number;\n}\n\nGot:\n' + _inspect(options));
			}
	
			var size = data.length;
			var groupsCount = options.count;
			var groupSize = (0, _common.fromPercentToValue)(size, options.groupSize);
	
			// 1. Validation
			(0, _common.validateGroupsInput)(size, groupSize, groupsCount);
	
			// 2. Create groups
			var groups = (0, _createGroupsWithRandomOffset.createGroupsWithRandomOffset)(data, groupSize);
	
			// 3. Generate random indexes
	
			var _getGroupsIndexes = (0, _common.getGroupsIndexes)(groupsCount, groups.length()),
			    _getGroupsIndexes2 = _slicedToArray(_getGroupsIndexes, 2),
			    fromIndexes = _getGroupsIndexes2[0],
			    toIndexes = _getGroupsIndexes2[1];
	
			// 4. Do something with indexes and group
	
	
			fn(groups, [fromIndexes, toIndexes], options);
	
			return groups.toRaw();
		};
	};
	
	var render = function render(_ref, onblur) {
		var count = _ref.count,
		    groupSize = _ref.groupSize;
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_UIFactory.SliderControl, {
				defaultValue: count,
				onBlur: onblur,
				field: 'count',
				title: 'Count of groups',
				min: 1,
				max: 10,
				step: 1
			}),
			_react2.default.createElement(_UIFactory.SliderControl, {
				defaultValue: groupSize,
				onBlur: onblur,
				field: 'groupSize',
				title: 'Group size in percents',
				min: 1,
				max: 100,
				step: 1
			})
		);
	};
	
	var initialState = {
		weight: 0.2,
		groupSize: 5,
		count: 2
	};
	
	function createGroupMutation(name, fn) {
		var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : initialState;
	
		return {
			name: name,
			run: createCalculate(fn),
			render: render,
			getInitialState: function getInitialState() {
				return state;
			}
		};
	}
	
	function _inspect(input, depth) {
		var maxDepth = 4;
		var maxKeys = 15;

		if (depth === undefined) {
			depth = 0;
		}

		depth += 1;

		if (input === null) {
			return 'null';
		} else if (input === undefined) {
			return 'void';
		} else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
			return typeof input === 'undefined' ? 'undefined' : _typeof(input);
		} else if (Array.isArray(input)) {
			if (input.length > 0) {
				var _ret = function () {
					if (depth > maxDepth) return {
							v: '[...]'
						};

					var first = _inspect(input[0], depth);

					if (input.every(function (item) {
						return _inspect(item, depth) === first;
					})) {
						return {
							v: first.trim() + '[]'
						};
					} else {
						return {
							v: '[' + input.slice(0, maxKeys).map(function (item) {
								return _inspect(item, depth);
							}).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']'
						};
					}
				}();

				if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
			} else {
				return 'Array';
			}
		} else {
			var keys = Object.keys(input);

			if (!keys.length) {
				if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
					return input.constructor.name;
				} else {
					return 'Object';
				}
			}

			if (depth > maxDepth) return '{...}';
			var indent = '  '.repeat(depth - 1);
			var entries = keys.slice(0, maxKeys).map(function (key) {
				return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
			}).join('\n  ' + indent);

			if (keys.length >= maxKeys) {
				entries += '\n  ' + indent + '...';
			}

			if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
				return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
			} else {
				return '{\n  ' + indent + entries + '\n' + indent + '}';
			}
		}
	}

/***/ },

/***/ 629:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createGroupsWithRandomOffset = createGroupsWithRandomOffset;
	
	var _Groups = __webpack_require__(630);
	
	var _utils = __webpack_require__(610);
	
	function getMaxOffset(size, groupSize) {
		return size % groupSize;
	}
	
	function createGroupsWithRandomOffset(data, groupSize) {
		var maxOffset = getMaxOffset(data.length, groupSize);
		var offset = _utils.numberUtils.randomBetween(0, maxOffset + 1);
		return new _Groups.Groups(data, groupSize, offset);
	}

/***/ },

/***/ 630:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Groups = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(198);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Groups = exports.Groups = function () {
		_createClass(Groups, null, [{
			key: 'create',
			value: function create(data, size) {
				var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
				if (!(Array.isArray(data) && data.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "data" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(data));
				}
	
				if (!(typeof size === 'number')) {
					throw new TypeError('Value of argument "size" violates contract.\n\nExpected:\nnumber\n\nGot:\n' + _inspect(size));
				}
	
				if (!(typeof offset === 'number')) {
					throw new TypeError('Value of argument "offset" violates contract.\n\nExpected:\nnumber\n\nGot:\n' + _inspect(offset));
				}
	
				return new Groups(data, size, offset);
			}
		}]);
	
		function Groups(data, size) {
			var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
			_classCallCheck(this, Groups);
	
			if (!(Array.isArray(data) && data.every(function (item) {
				return typeof item === 'number';
			}))) {
				throw new TypeError('Value of argument "data" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(data));
			}
	
			if (!(typeof size === 'number')) {
				throw new TypeError('Value of argument "size" violates contract.\n\nExpected:\nnumber\n\nGot:\n' + _inspect(size));
			}
	
			if (!(typeof offset === 'number')) {
				throw new TypeError('Value of argument "offset" violates contract.\n\nExpected:\nnumber\n\nGot:\n' + _inspect(offset));
			}
	
			this._chunks = this._createChunks(data, size, offset);
		}
	
		_createClass(Groups, [{
			key: 'swap',
			value: function swap(first, second) {
				var _this = this;
	
				if (!(Array.isArray(first) && first.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "first" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(first));
				}
	
				if (!(Array.isArray(second) && second.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "second" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(second));
				}
	
				var hash = this._arraysToMap(first, second);
				var backHash = this._arraysToMap(second, first);
	
				this._chunks = this._chunks.map(function (item, index) {
					if (hash[index]) {
						return _this._chunks[hash[index]];
					}
	
					if (backHash[index]) {
						return _this._chunks[backHash[index]];
					}
	
					return item;
				});
			}
		}, {
			key: 'copy',
			value: function copy(first, second) {
				var _this2 = this;
	
				if (!(Array.isArray(first) && first.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "first" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(first));
				}
	
				if (!(Array.isArray(second) && second.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "second" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(second));
				}
	
				var hash = this._arraysToMap(first, second);
				this._chunks = this._chunks.map(function (item, index) {
					return hash[index] == null ? item : _this2._chunks[hash[index]];
				});
			}
		}, {
			key: 'length',
			value: function length() {
				function _ref3(_id3) {
					if (!(typeof _id3 === 'number')) {
						throw new TypeError('Function return value violates contract.\n\nExpected:\nnumber\n\nGot:\n' + _inspect(_id3));
					}
	
					return _id3;
				}
	
				return _ref3(this._chunks.length);
			}
		}, {
			key: 'set',
			value: function set(index, value) {
				this._chunks[index] = value;
			}
		}, {
			key: 'get',
			value: function get(index) {
				return this._chunks[index];
			}
		}, {
			key: 'all',
			value: function all() {
				return this._chunks;
			}
		}, {
			key: 'toRaw',
			value: function toRaw() {
				function _ref4(_id4) {
					if (!(Array.isArray(_id4) && _id4.every(function (item) {
						return typeof item === 'number';
					}))) {
						throw new TypeError('Function return value violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(_id4));
					}
	
					return _id4;
				}
	
				return _ref4((0, _lodash.flatten)(this._chunks));
			}
		}, {
			key: '_createChunks',
			value: function _createChunks(data, size, offset) {
				function _ref5(_id5) {
					if (!(Array.isArray(_id5) && _id5.every(function (item) {
						return Array.isArray(item) && item.every(function (item) {
							return typeof item === 'number';
						});
					}))) {
						throw new TypeError('Function return value violates contract.\n\nExpected:\nArray<Array<number>>\n\nGot:\n' + _inspect(_id5));
					}
	
					return _id5;
				}
	
				var firstChunk = data.slice(0, offset);
				var rest = (0, _lodash.chunk)(data.slice(offset), size);
				return _ref5(firstChunk.length ? [firstChunk].concat(_toConsumableArray(rest)) : rest);
			}
	
			// TODO: maybe export somewhere arrayUtils, objectUtils
	
		}, {
			key: '_arraysToMap',
			value: function _arraysToMap(first, second) {
				function _ref6(_id6) {
					if (!(_id6 != null && (typeof _id6 === 'undefined' ? 'undefined' : _typeof(_id6)) === 'object' && Object.keys(_id6).every(function (key) {
						var _id7 = _id6[key];
						return typeof _id7 === 'number';
					}))) {
						throw new TypeError('Function return value violates contract.\n\nExpected:\n{ [id: number]: number\n}\n\nGot:\n' + _inspect(_id6));
					}
	
					return _id6;
				}
	
				if (!(Array.isArray(first) && first.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "first" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(first));
				}
	
				if (!(Array.isArray(second) && second.every(function (item) {
					return typeof item === 'number';
				}))) {
					throw new TypeError('Value of argument "second" violates contract.\n\nExpected:\nArray<number>\n\nGot:\n' + _inspect(second));
				}
	
				return _ref6(first.reduce(function (reducer, value, index) {
					return _extends({}, reducer, _defineProperty({}, value, second[index]));
				}, {}));
			}
		}]);

		return Groups;
	}();

	function _inspect(input, depth) {
		var maxDepth = 4;
		var maxKeys = 15;

		if (depth === undefined) {
			depth = 0;
		}

		depth += 1;

		if (input === null) {
			return 'null';
		} else if (input === undefined) {
			return 'void';
		} else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
			return typeof input === 'undefined' ? 'undefined' : _typeof(input);
		} else if (Array.isArray(input)) {
			if (input.length > 0) {
				var _ret = function () {
					if (depth > maxDepth) return {
							v: '[...]'
						};

					var first = _inspect(input[0], depth);

					if (input.every(function (item) {
						return _inspect(item, depth) === first;
					})) {
						return {
							v: first.trim() + '[]'
						};
					} else {
						return {
							v: '[' + input.slice(0, maxKeys).map(function (item) {
								return _inspect(item, depth);
							}).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']'
						};
					}
				}();

				if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
			} else {
				return 'Array';
			}
		} else {
			var keys = Object.keys(input);

			if (!keys.length) {
				if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
					return input.constructor.name;
				} else {
					return 'Object';
				}
			}

			if (depth > maxDepth) return '{...}';
			var indent = '  '.repeat(depth - 1);
			var entries = keys.slice(0, maxKeys).map(function (key) {
				return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
			}).join('\n  ' + indent);

			if (keys.length >= maxKeys) {
				entries += '\n  ' + indent + '...';
			}

			if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
				return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
			} else {
				return '{\n  ' + indent + entries + '\n' + indent + '}';
			}
		}
	}

/***/ },

/***/ 631:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.validateGroupsInput = validateGroupsInput;
	exports.fromPercentToValue = fromPercentToValue;
	exports.getGroupsIndexes = getGroupsIndexes;
	
	var _utils = __webpack_require__(610);
	
	function validateGroupsInput(size, groupSize, groupsCount) {
		if (size < groupSize * groupsCount) {
			throw new Error('Invalid groupSize: ' + groupSize + ' or groupsCount: ' + groupsCount + ' for size: ' + size);
		}
	}
	
	function fromPercentToValue(size, percent) {
		return Math.floor(size * percent / 100);
	}
	
	/**
	 * returns 2 groups of indexes 
	 */
	function getGroupsIndexes(groupsCount, groupsSize) {
		// TODO: [0, groupSize - 1] quick fix to not grab first and last indexes
		var swapIndexes = _utils.arrayUtils.getRandomIndexes(groupsCount * 2, groupsSize, [0, groupsSize - 1]);
		var middle = swapIndexes.length / 2;
		return [swapIndexes.slice(0, middle), swapIndexes.slice(middle)];
	}

/***/ },

/***/ 632:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createGroupMutation = __webpack_require__(628);
	
	var _lodash = __webpack_require__(198);
	
	var _utils = __webpack_require__(610);
	
	exports.default = (0, _createGroupMutation.createGroupMutation)('order-mutation', function (groups, _ref) {
		var _ref2 = _slicedToArray(_ref, 1),
		    indexes = _ref2[0];
	
		indexes.forEach(function (i) {
			var chunk = groups.get(i);
			var sorted = (0, _lodash.sortBy)(chunk);
			groups.set(i, _utils.randomUtils.headsOrTails() ? sorted : sorted.reverse());
		});
	});

/***/ },

/***/ 633:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _utils = __webpack_require__(610);
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function run(data, _ref) {
		var percents = _ref.percents;
	
		var availableValues = _MusicContext2.default.getAvailableValues();
		var length = data.length;
		var count = Math.floor(length * percents / 100);
	
		return _utils.arrayUtils.getRandomIndexes(count, length).reduce(function (store, index) {
			store[index] = _utils.arrayUtils.randomElement(availableValues);
			return store;
		}, data.slice());
	}
	
	var render = function render(state, onblur) {
		return _react2.default.createElement(_UIFactory.SliderControl, {
			defaultValue: state.percents,
			onBlur: onblur.bind(null, 'percents'),
			field: 'percents',
			title: 'Percents',
			min: 1,
			max: 50,
			step: 1
		});
	};
	
	var getInitialState = function getInitialState() {
		return {
			weight: 0.25,
			percents: 5
		};
	};
	
	exports.default = {
		name: 'random-mutation',
		run: run,
		render: render,
		getInitialState: getInitialState
	};

/***/ },

/***/ 634:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createGroupMutation = __webpack_require__(628);
	
	exports.default = (0, _createGroupMutation.createGroupMutation)('reverse-mutation', function (groups, _ref) {
		var _ref2 = _slicedToArray(_ref, 1),
		    indexes = _ref2[0];
	
		indexes.forEach(function (i) {
			groups.set(i, groups.get(i).reverse());
		});
	});

/***/ },

/***/ 635:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _calculate = __webpack_require__(636);
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COUNT_OF_GENS = _MusicContext2.default.getCompositionLength();
	
	var render = function render(state, onblur) {
		return _react2.default.createElement(_UIFactory.SliderControl, {
			defaultValue: state.count,
			onBlur: onblur.bind(null, 'count'),
			field: 'count',
			title: 'Count of genes',
			min: 1,
			max: COUNT_OF_GENS,
			step: 1
		});
	};
	
	var getInitialState = function getInitialState() {
		return {
			weight: 1,
			count: 10
		};
	};
	
	exports.default = {
		name: 'sort-mutation',
		run: _calculate.calculate,
		render: render,
		getInitialState: getInitialState
	};

/***/ },

/***/ 636:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.calculate = calculate;
	
	var _utils = __webpack_require__(610);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function calculate(data, options) {
		if (options.count >= data.length) {
			throw 'To much gens for sort mutation';
		}
	
		var length = data.length;
		var startIndex = _utils.numberUtils.randomBetween(0, length - options.count);
		var endIndex = startIndex + options.count;
	
		var sorted = data.slice(startIndex, endIndex).sort(function (a, b) {
			return +a - +b;
		});
	
		return [].concat(_toConsumableArray(data.slice(0, startIndex)), _toConsumableArray(sorted), _toConsumableArray(data.slice(endIndex)));
	}

/***/ },

/***/ 637:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _utils = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = {
		count: 64
	};
	
	function run(data) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		options = Object.assign({}, defaultOptions, options);
	
		_utils.arrayUtils
		// -1 cause we need neighbor
		.getRandomIndexes(options.count, data.length - 1).forEach(function (i) {
			var temp = data[i];
			data[i] = data[i + 1];
			data[i + 1] = temp;
		});
	
		return data;
	}
	
	var render = function render(state, onblur) {
		return _react2.default.createElement(_UIFactory.SliderControl, {
			defaultValue: state.count,
			onBlur: onblur.bind(null, 'count'),
			field: 'count',
			title: 'Count of genes',
			min: 1,
			max: 128,
			step: 1
		});
	};
	
	var getInitialState = function getInitialState() {
		return {
			weight: 0.25,
			count: 32
		};
	};
	
	exports.default = {
		name: 'swap2-mutation',
		run: run,
		render: render,
		getInitialState: getInitialState
	};

/***/ },

/***/ 638:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createGroupMutation = __webpack_require__(628);
	
	exports.default = (0, _createGroupMutation.createGroupMutation)('swap-group-mutation', function (groups, _ref) {
		var _ref2 = _slicedToArray(_ref, 2),
		    fromIndexes = _ref2[0],
		    toIndexes = _ref2[1];
	
		groups.swap(fromIndexes, toIndexes);
	}, {
		weight: 0.5,
		groupSize: 5,
		count: 2
	});

/***/ },

/***/ 639:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _calculate = __webpack_require__(640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
		weight: 0.2,
		groupSize: 5,
		count: 2,
		transposeSize: 2
	};
	
	var render = function render(_ref, onblur) {
		var count = _ref.count,
		    groupSize = _ref.groupSize,
		    transposeSize = _ref.transposeSize;
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_UIFactory.SliderControl, {
				defaultValue: count,
				onBlur: onblur,
				field: 'count',
				title: 'Count of groups',
				min: 1,
				max: 10,
				step: 1
			}),
			_react2.default.createElement(_UIFactory.SliderControl, {
				defaultValue: groupSize,
				onBlur: onblur,
				field: 'groupSize',
				title: 'Group size in percents',
				min: 1,
				max: 100,
				step: 1
			}),
			_react2.default.createElement(_UIFactory.SliderControl, {
				defaultValue: transposeSize,
				onBlur: onblur,
				field: 'transposeSize',
				title: 'Size of transposition in steps',
				min: 1,
				max: 7,
				step: 1
			})
		);
	};
	
	exports.default = {
		name: 'transpose-mutation',
		run: _calculate.calculate,
		render: render,
		getInitialState: function getInitialState() {
			return initialState;
		}
	};

/***/ },

/***/ 640:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.calculate = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(198);
	
	var _createGroupMutation = __webpack_require__(628);
	
	var _MusicContext = __webpack_require__(625);
	
	var MAX_GEN_VALUE = (0, _lodash.last)(_MusicContext.availableValuesInGF);
	
	function transposeGen(gen, transposeSize) {
		if ([_MusicContext.PAUSE, _MusicContext.HOLD].includes(gen)) {
			return gen;
		}
		var newValue = gen + transposeSize;
		var rem = newValue % MAX_GEN_VALUE;
		return rem ? rem : MAX_GEN_VALUE;
	}
	
	var calculate = exports.calculate = (0, _createGroupMutation.createCalculate)(function (groups, _ref, _ref2) {
		var _ref3 = _slicedToArray(_ref, 1),
		    indexes = _ref3[0];
	
		var transposeSize = _ref2.transposeSize;
	
		indexes.forEach(function (i) {
			var chunk = groups.get(i);
			groups.set(i, chunk.map(function (g) {
				return transposeGen(g, transposeSize);
			}));
		});
	});

/***/ },

/***/ 641:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _utils = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultOptions = {
		count: 64
	};
	
	var UP_CORNER = 14;
	var DOWN_CORNER = 1;
	
	var UpAndDownMutation = function () {
		function UpAndDownMutation() {
			_classCallCheck(this, UpAndDownMutation);
		}
	
		_createClass(UpAndDownMutation, [{
			key: 'mutate',
			value: function mutate(data) {
				var _this = this;
	
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				options = Object.assign({}, defaultOptions, options);
				var indexes = _utils.arrayUtils.getRandomIndexes(options.count, data.length);
				indexes.forEach(function (i) {
					if (data[i] === -1 || data[i] === 0) {
						return;
					}
					data[i] = _this._mutateOne(data[i]);
				});
				return data;
			}
		}, {
			key: '_mutateOne',
			value: function _mutateOne(value) {
				if (Math.random() > 0.5) {
					//TODO: export to common END
					if (value < UP_CORNER) {
						return value + 1;
					}
	
					return value;
				} else {
					//TODO: export to common START
					if (value > DOWN_CORNER + 1) {
						return value - 1;
					}
	
					return value;
				}
			}
		}]);
	
		return UpAndDownMutation;
	}();
	
	var instance = new UpAndDownMutation();
	var run = instance.mutate.bind(instance);
	
	var render = function render(state, onblur) {
		return _react2.default.createElement(_UIFactory.SliderControl, {
			defaultValue: state.count,
			onBlur: onblur.bind(null, 'count'),
			field: 'count',
			title: 'Count of genes',
			min: 1,
			max: 128,
			step: 1
		});
	};
	
	var getInitialState = function getInitialState() {
		return {
			weight: 1,
			count: 7
		};
	};
	
	exports.default = {
		name: 'up-and-down-mutation',
		run: run,
		render: render,
		getInitialState: getInitialState
	};

/***/ },

/***/ 642:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Component = exports.run = undefined;
	
	var _createProvider = __webpack_require__(606);
	
	var _plugins = __webpack_require__(643);
	
	var _createCompositeProvi = (0, _createProvider.createCompositeProvider)('fitness', _plugins.plugins);
	
	var run = _createCompositeProvi.run,
	    Component = _createCompositeProvi.Component;
	exports.run = run;
	exports.Component = Component;

/***/ },

/***/ 643:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.plugins = undefined;
	
	var _BasicReferenceFitness = __webpack_require__(644);
	
	var _BasicReferenceFitness2 = _interopRequireDefault(_BasicReferenceFitness);
	
	var _ClusterFitness = __webpack_require__(646);
	
	var _ClusterFitness2 = _interopRequireDefault(_ClusterFitness);
	
	var _DirectionFitness = __webpack_require__(650);
	
	var _DirectionFitness2 = _interopRequireDefault(_DirectionFitness);
	
	var _IntervalFitness = __webpack_require__(652);
	
	var _IntervalFitness2 = _interopRequireDefault(_IntervalFitness);
	
	var _MagnitudeFitness = __webpack_require__(655);
	
	var _MagnitudeFitness2 = _interopRequireDefault(_MagnitudeFitness);
	
	var _MelodyFitness = __webpack_require__(657);
	
	var _MelodyFitness2 = _interopRequireDefault(_MelodyFitness);
	
	var _MelodyLineFitness = __webpack_require__(658);
	
	var _MelodyLineFitness2 = _interopRequireDefault(_MelodyLineFitness);
	
	var _NoteSizePartialFitness = __webpack_require__(660);
	
	var _NoteSizePartialFitness2 = _interopRequireDefault(_NoteSizePartialFitness);
	
	var _RhythmLineFitness = __webpack_require__(664);
	
	var _RhythmLineFitness2 = _interopRequireDefault(_RhythmLineFitness);
	
	var _RodNoteFitness = __webpack_require__(666);
	
	var _RodNoteFitness2 = _interopRequireDefault(_RodNoteFitness);
	
	var _SignSequenceFitness = __webpack_require__(668);
	
	var _SignSequenceFitness2 = _interopRequireDefault(_SignSequenceFitness);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plugins = exports.plugins = [_BasicReferenceFitness2.default, _ClusterFitness2.default, _DirectionFitness2.default, _IntervalFitness2.default, _MagnitudeFitness2.default, _MelodyFitness2.default, _MelodyLineFitness2.default, _NoteSizePartialFitness2.default, _RhythmLineFitness2.default, _RodNoteFitness2.default, _SignSequenceFitness2.default];

/***/ },

/***/ 644:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _normalization = __webpack_require__(645);
	
	var run = function run(content, reference) {
		var normContent = (0, _normalization.normalizeNotesDiscrete)(content);
		var normReference = (0, _normalization.normalizeNotesDiscrete)(reference);
		var point = 1 / normContent.length;
	
		return normContent.reduce(function (store, item, index) {
			return item === normReference[index] ? store + point : store;
		}, 0);
	};
	
	var getInitialState = function getInitialState() {
		return { weight: 0 };
	};
	
	exports.default = {
		name: 'basic-reference-fitness',
		run: run,
		getInitialState: getInitialState
	};

/***/ },

/***/ 645:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.normalizer = exports.normalizePitchToOctave = exports.normalizeNotesDiscrete = exports.normalizeRhythm = exports.normalizeHolds = undefined;
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	var _utils = __webpack_require__(610);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Replace holds with pauses
	 * @type {Array<Number>}
	 */
	var normalizeHolds = exports.normalizeHolds = function normalizeHolds(content) {
		return content.reduce(function (store, current) {
			return store.concat(current === -1 ? 0 : current);
		}, []);
	};
	
	var normalizeRhythm = exports.normalizeRhythm = function normalizeRhythm(content) {
		return content.reduce(function (reducer, current) {
			return reducer.concat([_MusicContext.PAUSE, _MusicContext.HOLD].includes(current) ? 0 : 1);
		}, []);
	};
	
	/**
	 * Replace holds with previous notePitchs/pauses
	 * @example 7, -1, -1, 0, -1 = 7, 7, 7, 0, 0
	 */
	var normalizeNotesDiscrete = exports.normalizeNotesDiscrete = function normalizeNotesDiscrete(content) {
		return content.reduce(function (store, current) {
			if (current >= 0) {
				store.note = current;
			}
			store.data.push(store.note);
			return store;
		}, { data: [], note: 0 }).data;
	};
	
	// TODO: probably could be dynamic, for now static
	var MAX_ONE_OCTAVE_VALUE = _MusicContext2.default.getMaxOneOctaveValue();
	var normalizePitchToOctave = exports.normalizePitchToOctave = function normalizePitchToOctave(content) {
		return content.map(function (v) {
			return _utils.numberUtils.normalizeValue(v, MAX_ONE_OCTAVE_VALUE);
		});
	};
	
	var normalizer = exports.normalizer = function normalizer(normalizers) {
		return function (content) {
			return normalizers.reduce(function (data, normalizerFn) {
				return normalizerFn(data);
			}, content);
		};
	};

/***/ },

/***/ 646:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _clusterMask = __webpack_require__(647);
	
	var _executors = __webpack_require__(649);
	
	exports.default = {
		name: 'cluster-fitness',
		run: (0, _executors.fitnessExecutor)(_clusterMask.clusterMask)(_executors.barEqualityComparer),
		getInitialState: function getInitialState() {
			return { weight: 0.1, _important: false };
		}
	};

/***/ },

/***/ 647:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.clusterMask = undefined;
	
	var _MusicContext = __webpack_require__(625);
	
	var _helpers = __webpack_require__(648);
	
	// const DEFAULT_THRESHOLD = 0.5;
	
	var clusterMask = exports.clusterMask = (0, _helpers.maskFactory)(function (bar) {
		return (/* { threshold = DEFAULT_THRESHOLD } = {} */bar.reduce(function (reducer, value) {
				return reducer + value === _MusicContext.PAUSE ? 0 : 1;
			}, 0) / bar.length
		);
	});

/***/ },

/***/ 648:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.maskFactory = undefined;
	
	var _Composition = __webpack_require__(621);
	
	var _Composition2 = _interopRequireDefault(_Composition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var maskFactory = exports.maskFactory = function maskFactory(barAnalyzer) {
		return function (data, options) {
			return _Composition2.default.create(data).rawBars().map(function (bar) {
				return barAnalyzer(bar, options);
			});
		};
	};

/***/ },

/***/ 649:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var fitnessExecutor = exports.fitnessExecutor = function fitnessExecutor(extractor) {
		return function (comparer) {
			return function (content, reference) {
				var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
				return comparer(extractor(content, options), extractor(reference, options), options);
			};
		};
	};
	
	var barEqualityComparer = exports.barEqualityComparer = function barEqualityComparer(content, reference) {
		return reference.reduce(function (reducer, value, index) {
			return content[index] === value ? reducer + 1 : reducer;
		}, 0) / content.length;
	};
	
	var barContentEqualityComparer =
	/* @params {Array<Array<number>>} content - array of bars which are GNF-like [1, 5, ...] */
	exports.barContentEqualityComparer = function barContentEqualityComparer(content, reference) {
		return reference.reduce(function (reducer, value, index) {
			return reducer + barEqualityComparer(value, content[index]);
		}, 0) / content.length;
	};

/***/ },

/***/ 650:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _directionMask = __webpack_require__(651);
	
	var _executors = __webpack_require__(649);
	
	exports.default = {
		name: 'direction-fitness',
		run: (0, _executors.fitnessExecutor)(_directionMask.directionAnalyzer)(_executors.barEqualityComparer),
		getInitialState: function getInitialState() {
			return { weight: 0.01 };
		}
	};

/***/ },

/***/ 651:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.directionAnalyzer = exports.DIRECTION = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.directionForBar = directionForBar;
	
	__webpack_require__(32);
	
	var _MusicContext = __webpack_require__(625);
	
	var _helpers = __webpack_require__(648);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // For Object.entries in jest tests
	
	
	var DIRECTION = exports.DIRECTION = {
		UP: 'UP',
		DOWN: 'DOWN',
		STABLE: 'STABLE',
		NONE: 'NONE'
	};
	
	var DEFAULT_SIZE = 3;
	var MIN_SPREAD = 3;
	
	function getDirection(a, b) {
		if (a === b) {
			return DIRECTION.STABLE;
		}
		return a > b ? DIRECTION.DOWN : DIRECTION.UP;
	}
	
	function calculateFrequencies(bar, _ref) {
		var _storage;
	
		var size = _ref.size;
	
		var storage = (_storage = {}, _defineProperty(_storage, DIRECTION.UP, 0), _defineProperty(_storage, DIRECTION.DOWN, 0), _defineProperty(_storage, DIRECTION.STABLE, 0), _defineProperty(_storage, DIRECTION.NONE, 0), _storage);
		// Dummy implementation need rework
		var chain = [];
		var currentDirection = null;
		for (var i = 0; i < bar.length; i++) {
			var value = bar[i];
			if (value === _MusicContext.PAUSE) {
				if (chain.length >= size) {
					storage[currentDirection || DIRECTION.NONE] += 1;
				}
				chain = [];
				currentDirection = null;
				continue;
			}
	
			if (!chain.length) {
				chain.push(value);
				continue;
			}
	
			var prev = chain[chain.length - 1];
			var direction = getDirection(prev, value);
	
			if (!currentDirection) {
				currentDirection = direction;
				chain.push(value);
				continue;
			}
	
			if (currentDirection === direction) {
				chain.push(value);
			} else {
				if (chain.length > size) {
					storage[currentDirection || DIRECTION.NONE] += 1;
				}
				chain = [value];
				currentDirection = null;
				continue;
			}
		}
		if (chain.length >= size) {
			storage[currentDirection || DIRECTION.NONE] += 1;
		}
		return storage;
	}
	
	/**
	 * @desc exported for tests
	 */
	function directionForBar(bar) {
		var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref2$size = _ref2.size,
		    size = _ref2$size === undefined ? DEFAULT_SIZE : _ref2$size,
		    _ref2$spread = _ref2.spread,
		    spread = _ref2$spread === undefined ? MIN_SPREAD : _ref2$spread;
	
		var cleanedBar = bar.reduce(function (reducer, current) {
			return current === _MusicContext.HOLD ? reducer : [].concat(_toConsumableArray(reducer), [current]);
		}, []);
	
		var frequencies = calculateFrequencies(cleanedBar, { size: size, spread: spread });
	
		var descSortedFrequencies = Object.entries(frequencies).sort(function (a, b) {
			return a[1] < b[1];
		});
	
		var _descSortedFrequencie = _slicedToArray(descSortedFrequencies, 2),
		    first = _descSortedFrequencie[0],
		    second = _descSortedFrequencie[1];
	
		if (first[1] - second[1] >= spread) {
			return first[0];
		} else {
			return DIRECTION.NONE;
		}
	}
	
	/**
	 * @type {Array<number>}
	 * @return {Array<DIRECTION>}
	 */
	var directionAnalyzer = exports.directionAnalyzer = (0, _helpers.maskFactory)(directionForBar);

/***/ },

/***/ 652:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _calculate = __webpack_require__(653);
	
	var _calculate2 = _interopRequireDefault(_calculate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var run = _calculate2.default.fitness.bind(_calculate2.default);
	var getInitialState = function getInitialState() {
		return { weight: 0 };
	};
	
	// TODO: Сделать отрисовку дополнительных опций для передачи их черех executorFabric
	/*
	const defaultOptions = {
		intervalValuesWeight: 0.5,
		intervalDispersionWeight: 0.5
	};
	 */
	
	exports.default = {
		name: 'interval-fitness',
		run: run,
		getInitialState: getInitialState
	};

/***/ },

/***/ 653:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _common = __webpack_require__(654);
	
	var _utils = __webpack_require__(610);
	
	var _lodash = __webpack_require__(198);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultOptions = {
		intervalValuesWeight: 0.5,
		intervalDispersionWeight: 0.5
	};
	
	var IntervalFitness = function () {
		function IntervalFitness() {
			_classCallCheck(this, IntervalFitness);
	
			this._referenceValues /*: Array<{dispersion: number, average: number}> - array of bars and their interval values */ = null;
		}
	
		_createClass(IntervalFitness, [{
			key: 'reset',
			value: function reset() {
				this._referenceValues = null;
			}
	
			//TODO: options could be passed once
	
		}, {
			key: 'fitness',
			value: function fitness(content, reference) {
				var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
				options = this._normalizeOptions(Object.assign({}, defaultOptions, options));
				var contentPitch = _utils.notesUtils.toPitch(content);
				var referencePitch = _utils.notesUtils.toPitch(reference);
	
				var contentValues = this._calculateIntervalValues(contentPitch);
				if (!this._referenceValues) {
					this._referenceValues = this._calculateIntervalValues(referencePitch);
				}
	
				var result = this._calculateFitness(contentValues, options);
				console.assert((0, _lodash.isNumber)(result), 'Result should be a number');
				return result;
			}
		}, {
			key: '_calculateFitness',
			value: function _calculateFitness(contentValues, options) {
				var contentMaxIndex = contentValues.length;
				var averageSum = 0;
				var dispersionSum = 0;
	
				this._referenceValues.some(function (_ref, i) {
					var aRef = _ref.average,
					    dRef = _ref.dispersion;
	
					if (contentMaxIndex <= i) {
						return true;
					}
					var _contentValues$i = contentValues[i],
					    average = _contentValues$i.average,
					    dispersion = _contentValues$i.dispersion;
	
	
					averageSum += Math.abs(aRef - average);
					dispersionSum += Math.abs(dRef - dispersion);
	
					return false;
				});
	
				averageSum = averageSum / this._referenceValues.length;
				dispersionSum = dispersionSum / this._referenceValues.length;
	
				console.assert((0, _lodash.isNumber)(averageSum), 'AverageSum is a number');
	
				averageSum = (1 - averageSum / _common.MAX_AVERAGE_DIFF) * options.intervalValuesWeight;
				dispersionSum = (1 - dispersionSum / _common.MAX_DISPERSION_DIFF) * options.intervalDispersionWeight;
	
				console.assert((0, _lodash.isNumber)(averageSum), 'AverageSum is a number');
				return averageSum + dispersionSum;
			}
		}, {
			key: '_calculateIntervalValues',
			value: function _calculateIntervalValues(bars) {
				var _this = this;
	
				return bars.map(function (bar) {
					return _this._calculateIntervalValuesForBar(bar);
				});
			}
		}, {
			key: '_calculateIntervalValuesForBar',
			value: function _calculateIntervalValuesForBar(pitchesBar) {
				var valuesArray = [];
				var count = pitchesBar.length;
				var sum = 0;
	
				if (!count) {
					return { average: 0, dispersion: 0 };
				}
	
				for (var i = 0; i < count - 1; i++) {
					var a = pitchesBar[i];
					var b = pitchesBar[i + 1];
	
					var value = (0, _common.getValueBetweenNotes)(a, b);
					sum += value;
					valuesArray.push(value);
				}
	
				var average = sum / count;
				var dispersion = valuesArray.map(function (v) {
					return Math.pow(v - average, 2);
				}).reduce(function (prev, val) {
					return prev + val;
				}, 0);
	
				return { average: average, dispersion: dispersion };
			}
		}, {
			key: '_normalizeOptions',
			value: function _normalizeOptions(options) {
				var max = options.intervalValuesWeight + options.intervalDispersionWeight;
				return Object.assign(options, {
					intervalValuesWeight: options.intervalValuesWeight / max,
					intervalDispersionWeight: options.intervalDispersionWeight / max
				});
			}
		}]);
	
		return IntervalFitness;
	}();
	
	exports.default = new IntervalFitness();

/***/ },

/***/ 654:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.MAX_DISPERSION_DIFF = exports.MAX_AVERAGE_DIFF = undefined;
	exports.getValueBetweenNotes = getValueBetweenNotes;
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INTERVAL_TYPE_VALUES = [{
		PERFECT_CONSONANTS: 1,
		IMPERFECT_CONSONANTS: 2,
		SECONDS: 3,
		SEVENTH: 3,
		GRATER_THAN_OCTAVE: 5
	}, {
		PERFECT_CONSONANTS: 1,
		IMPERFECT_CONSONANTS: 3,
		SECONDS: 1,
		SEVENTH: 3,
		GRATER_THAN_OCTAVE: 5
	}];
	
	//0, 1
	function getIntervalValue(interval) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
		var values = {
			//Perfect consonants
			0: INTERVAL_TYPE_VALUES[type].PERFECT_CONSONANTS, //unison
			5: INTERVAL_TYPE_VALUES[type].PERFECT_CONSONANTS, //perfect fourth
			7: INTERVAL_TYPE_VALUES[type].PERFECT_CONSONANTS, //perfect fifth
			12: INTERVAL_TYPE_VALUES[type].PERFECT_CONSONANTS, //octave
	
			//Imperfect consonants
			3: INTERVAL_TYPE_VALUES[type].IMPERFECT_CONSONANTS, // min third
			4: INTERVAL_TYPE_VALUES[type].IMPERFECT_CONSONANTS, // maj third
			8: INTERVAL_TYPE_VALUES[type].IMPERFECT_CONSONANTS, // min sixth
			9: INTERVAL_TYPE_VALUES[type].IMPERFECT_CONSONANTS, // big sixth
	
			//Seconds
			1: INTERVAL_TYPE_VALUES[type].SECONDS, //min second
			2: INTERVAL_TYPE_VALUES[type].SECONDS, //maj second
	
			//Sevenths
			10: INTERVAL_TYPE_VALUES[type].SEVENTH, //min seventh
			11: INTERVAL_TYPE_VALUES[type].SEVENTH, //maj seventh
	
			//More then octave
			6: INTERVAL_TYPE_VALUES[type].GRATER_THAN_OCTAVE,
			'-1': INTERVAL_TYPE_VALUES[type].GRATER_THAN_OCTAVE
		};
	
		if (interval > 12) {
			return values[-1];
		}
	
		return values[interval];
	}
	
	function getValueBetweenNotes(noteA, noteB) {
		var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
		// assume that noteA, noteB are not PAUSE or HOLD;
		var halfTones = _MusicContext2.default.getHalfTonesBeetween(noteA, noteB);
		var intervalValue = getIntervalValue(halfTones, mode);
		return intervalValue;
	}
	
	var MAX_AVERAGE_DIFF = exports.MAX_AVERAGE_DIFF = 4;
	var MAX_DISPERSION_DIFF = exports.MAX_DISPERSION_DIFF = MAX_AVERAGE_DIFF * MAX_AVERAGE_DIFF;

/***/ },

/***/ 655:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _calculate = __webpack_require__(656);
	
	var _calculate2 = _interopRequireDefault(_calculate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var run = _calculate2.default.fitness.bind(_calculate2.default);
	var getInitialState = function getInitialState() {
		return { weight: 0 };
	};
	
	exports.default = {
		name: 'magnitude-fitness',
		run: run,
		getInitialState: getInitialState
	};

/***/ },

/***/ 656:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BIT_VALUES = [4, 2, 3, 1];
	var MAX_DISTANCE = 4;
	//each bar has 10 balls to normalize we need to /16 and it's 1 ball for bar and /8 (8 bars)
	
	var PAUSE = -1;
	var HOLD = 0;
	
	var MagnitudeFitness = function () {
		function MagnitudeFitness() {
			_classCallCheck(this, MagnitudeFitness);
		}
	
		_createClass(MagnitudeFitness, [{
			key: 'fitness',
			value: function fitness(content, reference) {
				var sum = 0;
				for (var i = 0, l = content.length; i < l; i++) {
					var index = i % 16; // from 0 - 15;
					var bitValue = this._getBitValue(index);
					var refValue = reference[i];
					var contentValue = content[i];
	
					if (refValue === PAUSE || contentValue === PAUSE || refValue === HOLD || contentValue === HOLD) {
						if (refValue === contentValue) {
							sum += bitValue;
						}
						continue;
					}
	
					var distance = Math.abs(content[i] - reference[i]);
	
					if (distance > MAX_DISTANCE) {
						continue;
					}
	
					sum += bitValue * (1 - distance / MAX_DISTANCE);
				}
	
				return this._normalize(sum);
			}
		}, {
			key: '_getBitValue',
			value: function _getBitValue(index) {
				for (var i = 0; i < 4; i++) {
					var start = i * 4;
					if (index >= start && index < start + 4) {
						return BIT_VALUES[i];
					}
				}
				throw new 'Something went wrong in MagnitudeFitness._gitBitValue'();
			}
		}, {
			key: '_normalize',
			value: function _normalize(value) {
				return value / 8 / 10 / 4;
			}
		}]);
	
		return MagnitudeFitness;
	}();
	
	exports.default = new MagnitudeFitness();

/***/ },

/***/ 657:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _calculate = __webpack_require__(656);
	
	var _calculate2 = _interopRequireDefault(_calculate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var run = _calculate2.default.fitness.bind(_calculate2.default);
	var getInitialState = function getInitialState() {
		return { weight: 0 };
	};
	
	// TODO: Сделать отрисовку дополнительных опций для передачи их черех executorFabric
	/*
	const defaultOptions = {
		pitch: 1,
		rhythm: 1,
		maxPitchDistance: 4
	};
	*/
	exports.default = {
		name: 'magnitude-fitness',
		run: run,
		getInitialState: getInitialState
	};

/***/ },

/***/ 658:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _melodyLineMask = __webpack_require__(659);
	
	var _executors = __webpack_require__(649);
	
	exports.default = {
		name: 'melody-line-fitness',
		run: (0, _executors.fitnessExecutor)(_melodyLineMask.melodyLineMask)(_executors.barContentEqualityComparer),
		getInitialState: function getInitialState() {
			return { weight: 0.5, _important: false };
		}
	};

/***/ },

/***/ 659:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.melodyLineMask = undefined;
	
	var _helpers = __webpack_require__(648);
	
	var _normalization = __webpack_require__(645);
	
	var melodyLineMask = exports.melodyLineMask = (0, _helpers.maskFactory)(function (bar) {
	  return (0, _normalization.normalizeNotesDiscrete)(bar);
	});

/***/ },

/***/ 660:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _noteSizeDistributionAnalyzer = __webpack_require__(661);
	
	var _calculateError = __webpack_require__(662);
	
	var run = function run(content, reference, _options) {
		console.assert(content.length === reference.length);
	
		var referenceAnalysis = (0, _noteSizeDistributionAnalyzer.noteSizeDistributionAnalyzer)(reference);
		var contentAnalysis = (0, _noteSizeDistributionAnalyzer.noteSizeDistributionAnalyzer)(content);
		return referenceAnalysis.reduce(function (reducer, bar, index) {
			var contentBar = contentAnalysis[index];
			var error = (0, _calculateError.calculateError)(bar, contentBar);
			return reducer + (1 - error);
		}, 0) / referenceAnalysis.length;
	};
	
	var getInitialState = function getInitialState() {
		return {
			weight: 0.3,
			_important: false
		};
	};
	
	exports.default = {
		name: 'note-size-partial-fitness',
		run: run,
		getInitialState: getInitialState
	};

/***/ },

/***/ 661:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.noteSizeDistributionAnalyzer = undefined;
	
	var _Composition = __webpack_require__(621);
	
	var _Composition2 = _interopRequireDefault(_Composition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateDistributionForBar(bar) {
		var step = 1 / bar.length;
		var result = bar.reduce(function (reducer, note) {
			var size = note.length();
			reducer[size] = (reducer[size] || 0) + step;
			return reducer;
		}, {});
	
		return result;
	}
	
	var noteSizeDistributionAnalyzer = exports.noteSizeDistributionAnalyzer = function noteSizeDistributionAnalyzer(data) {
		var ignorePauses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		return _Composition2.default.create(data).bars().map(function (bar) {
			return calculateDistributionForBar(bar, ignorePauses);
		});
	};

/***/ },

/***/ 662:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.calculateError = undefined;
	
	var _calculateDiffObject = __webpack_require__(663);
	
	var calculateError = exports.calculateError = function calculateError(objA, objB) {
		return Object.values((0, _calculateDiffObject.calculateDiffObject)(objA, objB)).reduce(function (prev, current) {
			return prev + current;
		}, 0);
	};

/***/ },

/***/ 663:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var calculateDiffObject = exports.calculateDiffObject = function calculateDiffObject(barA, barB) {
		return Object.keys(barB).map(function (key) {
			return { key: key, value: barB[key] };
		}).reduce(function (diff, _ref) {
			var key = _ref.key,
			    value = _ref.value;
	
			if (diff[key] != null) {
				var difference = diff[key] - value;
				diff[key] = difference > 0 ? difference : 0;
			}
			return diff;
		}, _extends({}, barA));
	};

/***/ },

/***/ 664:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _rhythmLineMask = __webpack_require__(665);
	
	var _executors = __webpack_require__(649);
	
	exports.default = {
		name: 'rhythm-line-fitness',
		run: (0, _executors.fitnessExecutor)(_rhythmLineMask.rhythmLineMask)(_executors.barContentEqualityComparer),
		getInitialState: function getInitialState() {
			return { weight: 0.2, _important: false };
		}
	};

/***/ },

/***/ 665:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rhythmLineMask = undefined;
	
	var _helpers = __webpack_require__(648);
	
	var _normalization = __webpack_require__(645);
	
	var rhythmLineMask = exports.rhythmLineMask = (0, _helpers.maskFactory)(function (bar) {
	  return (0, _normalization.normalizeRhythm)(bar);
	});

/***/ },

/***/ 666:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _rodNoteMask = __webpack_require__(667);
	
	var _executors = __webpack_require__(649);
	
	exports.default = {
		name: 'rod-note-fitness',
		run: (0, _executors.fitnessExecutor)(_rodNoteMask.rodNoteAnalyzer)(function (referenceByBar, contentByBar) {
			var step = 1 / referenceByBar.length;
			return referenceByBar.reduce(function (reducer, value, index) {
				var subStep = step / value.length;
				return value.reduce(function (subReducer, subValue, subIndex) {
					return subValue === contentByBar[index][subIndex] ? subReducer + subStep : subReducer;
				}, 0) + reducer;
			}, 0);
		}),
		getInitialState: function getInitialState() {
			return { weight: 0, _important: false };
		}
	};

/***/ },

/***/ 667:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.rodNoteAnalyzer = exports.rodNoteForBar = exports.ROD_TYPE = undefined;
	
	var _ROD_MASK;
	
	var _MusicContext = __webpack_require__(625);
	
	var _helpers = __webpack_require__(648);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ROD_TYPE = exports.ROD_TYPE = {
		FIRST: 'FIRST',
		TWO: 'TWO',
		FOUR: 'FOUR',
		FIRST_AND_LAST: 'FIRST_AND_LAST'
	};
	
	var ROD_MASK = (_ROD_MASK = {}, _defineProperty(_ROD_MASK, ROD_TYPE.FIRST, [0]), _defineProperty(_ROD_MASK, ROD_TYPE.TWO, [0, 4]), _defineProperty(_ROD_MASK, ROD_TYPE.FOUR, [0, 2, 4, 6]), _defineProperty(_ROD_MASK, ROD_TYPE.FIRST_AND_LAST, [0, 6]), _ROD_MASK);
	
	/**
	 * @description exported for tests
	 */
	var rodNoteForBar = exports.rodNoteForBar = function rodNoteForBar(bar) {
		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$rodeType = _ref.rodeType,
		    rodeType = _ref$rodeType === undefined ? ROD_TYPE.FIRST : _ref$rodeType;
	
		return ROD_MASK[rodeType].reduce(function (reducer, index) {
			return [].concat(_toConsumableArray(reducer), [bar[index] === _MusicContext.HOLD ? null : bar[index]]);
		}, []);
	};
	/**
	 * @description holds in rod notes became nulls
	 * @type {Array<number>}
	 */
	var rodNoteAnalyzer = exports.rodNoteAnalyzer = (0, _helpers.maskFactory)(rodNoteForBar);

/***/ },

/***/ 668:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _signMask = __webpack_require__(669);
	
	var _executors = __webpack_require__(649);
	
	exports.default = {
		name: 'sign-sequence-fitness',
		run: (0, _executors.fitnessExecutor)(_signMask.signMask)(_executors.barContentEqualityComparer),
		getInitialState: function getInitialState() {
			return { weight: 0, _important: false };
		}
	};

/***/ },

/***/ 669:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.signMask = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.barAnalyzer = barAnalyzer;
	
	var _lodash = __webpack_require__(198);
	
	var _MusicContext = __webpack_require__(625);
	
	var _Composition = __webpack_require__(621);
	
	var _Composition2 = _interopRequireDefault(_Composition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var filterBar = function filterBar(bar) {
		return bar.map(function (x) {
			return x === _MusicContext.HOLD ? _MusicContext.PAUSE : x;
		});
	};
	
	/**
	 * @internal Exported for tests 
	 */
	function barAnalyzer(_ref) {
		var _ref2 = _slicedToArray(_ref, 2),
		    bar = _ref2[0],
		    _ref2$ = _ref2[1],
		    prevBar = _ref2$ === undefined ? [] : _ref2$;
	
		return filterBar(bar).reduce(function (_ref3, note) {
			var prev = _ref3.prev,
			    data = _ref3.data;
	
			if (prev == null) {
				return {
					data: [],
					prev: note
				};
			}
	
			var diff = note - prev;
	
			var value = 0;
			if (diff > 0) {
				value = 1;
			} else if (diff < 0) {
				value = -1;
			}
	
			return {
				data: [].concat(_toConsumableArray(data), [value]),
				prev: note
			};
		}, { data: [], prev: (0, _lodash.last)(filterBar(prevBar)) }).data;
	}
	
	var signMask = exports.signMask = function signMask(data, options) {
		return _Composition2.default.create(data).rawBars().reduce(function (reducer, bar, index, array) {
			return [].concat(_toConsumableArray(reducer), [barAnalyzer([bar, index ? array[index - 1] : undefined], options)]);
		}, []);
	};

/***/ },

/***/ 670:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.render = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _UIFactory = __webpack_require__(609);
	
	var _index = __webpack_require__(612);
	
	var _initialState = __webpack_require__(615);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAMESPACE = 'options';
	
	_initialState2.default.GA[NAMESPACE] = {
		maxIterations: 200,
		deathLimit: 0.2,
		count: 100,
		threshold: 0.9, /* End processing when someone near good (best 1) */
		mutationProbability: 0.5,
		useRandomInitialIndividuals: true,
		countOfBestToLiveThrought: 0,
		stopOnEndOfIterations: true,
	
		useEvolutionStrategies: true,
		migrationRate: 20,
		/**
	  * @type {number} from 0 - 1 in percents
	  */
		migrationSize: 0.1,
		groupCount: 4
	};
	
	var createSliderFactory = function createSliderFactory(state, onblur) {
		return function (field, props) {
			return _react2.default.createElement(_UIFactory.SliderControl, _extends({
				defaultValue: state[field],
				onBlur: onblur,
				field: field
			}, props));
		};
	};
	
	var render = exports.render = function render(props) {
		var store = props.store;
	
		var state = store.getState().GA[NAMESPACE];
		var onblur = function onblur(field, value) {
			store.dispatch((0, _index.changeOptions)([NAMESPACE, field], value));
		};
		var createSlider = createSliderFactory(state, onblur);
	
		return _react2.default.createElement(
			_reactBootstrap.Panel,
			{ collapsible: true, defaultExpanded: true, header: 'Options' },
			createSlider('maxIterations', { max: 10000, min: 50, step: 10 }),
			createSlider('deathLimit'),
			createSlider('count', { max: 500, min: 25, step: 1 }),
			createSlider('threshold'),
			createSlider('mutationProbability'),
			createSlider('countOfBestToLiveThrought', { max: 10, min: 0, step: 1 }),
			_react2.default.createElement(_UIFactory.CheckboxControl, {
				onBlur: onblur,
				defaultValue: state['useRandomInitialIndividuals'],
				field: 'useRandomInitialIndividuals' }),
			_react2.default.createElement(_UIFactory.CheckboxControl, {
				onBlur: onblur,
				defaultValue: state['stopOnEndOfIterations'],
				field: 'stopOnEndOfIterations' }),
			_react2.default.createElement(_UIFactory.CheckboxControl, {
				onBlur: onblur,
				defaultValue: state['useEvolutionStrategies'],
				field: 'useEvolutionStrategies' }),
			createSlider('migrationRate', { max: 500, min: 0, step: 1 }),
			createSlider('migrationSize', { title: 'Migration Size (in percents of population)', max: 1, min: 0, step: 0.01 }),
			createSlider('groupCount', { max: 25, min: 0, step: 1 })
		);
	};

/***/ },

/***/ 671:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.plugins = exports.Component = undefined;
	
	var _createRenderComponent = __webpack_require__(608);
	
	var _createPluginsHash = __webpack_require__(607);
	
	var _initialState = __webpack_require__(615);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _DarwinEvolution = __webpack_require__(672);
	
	var _DarwinEvolution2 = _interopRequireDefault(_DarwinEvolution);
	
	var _LamarkEvolution = __webpack_require__(678);
	
	var _LamarkEvolution2 = _interopRequireDefault(_LamarkEvolution);
	
	var _VriesEvolution = __webpack_require__(680);
	
	var _VriesEvolution2 = _interopRequireDefault(_VriesEvolution);
	
	var _KimuraEvolution = __webpack_require__(681);
	
	var _KimuraEvolution2 = _interopRequireDefault(_KimuraEvolution);
	
	var _PunctuatedEquilibriumEvolution = __webpack_require__(689);
	
	var _PunctuatedEquilibriumEvolution2 = _interopRequireDefault(_PunctuatedEquilibriumEvolution);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVOLUTION_KEY = 'evolution';
	
	// TODO: export somewhere, copy paste from BaseCalculateProvider
	
	
	// NOTE: list of available evolutions
	function registerInStore(providerName, initialState, plugins) {
	    initialState[providerName] = {};
	    Object.keys(plugins).map(function (key) {
	        return plugins[key];
	    }).forEach(function (_ref) {
	        var name = _ref.name,
	            getInitialState = _ref.getInitialState;
	        return initialState[providerName][name] = getInitialState();
	    });
	}
	
	function createEvolutionProvider(evolution) {
	    var plugins = (0, _createPluginsHash.createPluginsHash)(evolution);
	    registerInStore(EVOLUTION_KEY, _initialState2.default.GA, plugins);
	    var Component = (0, _createRenderComponent.createRenderComponent)(EVOLUTION_KEY, plugins, { expanded: true });
	
	    return {
	        Component: Component,
	        plugins: plugins
	    };
	}
	
	var _createEvolutionProvi = createEvolutionProvider([_DarwinEvolution2.default, _LamarkEvolution2.default, _VriesEvolution2.default, _KimuraEvolution2.default, _PunctuatedEquilibriumEvolution2.default]);
	
	var Component = _createEvolutionProvi.Component,
	    plugins = _createEvolutionProvi.plugins;
	exports.Component = Component;
	exports.plugins = plugins;

/***/ },

/***/ 672:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _GA = __webpack_require__(673);
	
	exports.default = {
	    executor: _GA.GA,
	    name: 'darwin-evolution',
	    getInitialState: function getInitialState() {
	        return { weight: 0.5 };
	    }
	};

/***/ },

/***/ 673:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GA = exports.NodeGA = exports.BrowserGA = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BaseGA3 = __webpack_require__(674);
	
	var _loop2 = __webpack_require__(677);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BrowserGA = exports.BrowserGA = function (_BaseGA) {
	    _inherits(BrowserGA, _BaseGA);
	
	    function BrowserGA() {
	        _classCallCheck(this, BrowserGA);
	
	        return _possibleConstructorReturn(this, (BrowserGA.__proto__ || Object.getPrototypeOf(BrowserGA)).apply(this, arguments));
	    }
	
	    _createClass(BrowserGA, [{
	        key: '_loop',
	        value: function _loop(cond, body, done) {
	            (0, _loop2.loop)(cond, body, done);
	        }
	    }]);
	
	    return BrowserGA;
	}(_BaseGA3.BaseGA);
	
	var NodeGA = exports.NodeGA = function (_BaseGA2) {
	    _inherits(NodeGA, _BaseGA2);
	
	    function NodeGA(preferences) {
	        var workerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var reference = arguments[2];
	        var rate = arguments[3];
	
	        _classCallCheck(this, NodeGA);
	
	        var _this2 = _possibleConstructorReturn(this, (NodeGA.__proto__ || Object.getPrototypeOf(NodeGA)).call(this, preferences, workerOptions, reference, rate));
	
	        _this2._rate = rate;
	        return _this2;
	    }
	
	    _createClass(NodeGA, [{
	        key: '_loop',
	        value: function _loop(cond, body, done) {
	            //debounceLoop(cond, body, done, this._rate);
	            (0, _loop2.syncLoop)(cond, body, done);
	        }
	    }]);
	
	    return NodeGA;
	}(_BaseGA3.BaseGA);
	
	var isNode = new Function('try { return this === global; } catch(e) { return false; }')();
	console.log('ENVIRONMENT: ' + (isNode ? 'NodeJS' : 'Browser'));
	var GA = exports.GA = isNode ? NodeGA : BrowserGA;

/***/ },

/***/ 674:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BaseGA = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Individual = __webpack_require__(675);
	
	var _Individual2 = _interopRequireDefault(_Individual);
	
	var _lodash = __webpack_require__(198);
	
	var _populationSorter = __webpack_require__(676);
	
	var _CrossoverProvider = __webpack_require__(605);
	
	var _MutationProvider = __webpack_require__(619);
	
	var _FitnessProvider = __webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultWorkerOptions = {
	    onProgress: undefined,
	    onDone: undefined,
	    onPause: undefined,
	    notifyRate: 10,
	
	    onMigration: undefined,
	    migrationRate: undefined,
	    migrationCount: 10
	};
	
	var BaseGA = exports.BaseGA = function () {
	
	    /**
	     * @param {{ options: {}, evolution: {}, crossover: {}, mutation: {}, fitness: {} }} preferences
	     */
	
	
	    /**
	     * @type {{ options: {}, evolution: {}, crossover: {}, mutation: {}, fitness: {} }}
	     */
	    function BaseGA(preferences) {
	        var workerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var reference = arguments[2];
	        var id = arguments[3];
	
	        _classCallCheck(this, BaseGA);
	
	        this._migrants = null;
	        var crossover = preferences.crossover,
	            mutation = preferences.mutation,
	            fitness = preferences.fitness,
	            options = preferences.options,
	            evolution = preferences.evolution;
	
	        this._id = id;
	        // -1) Grab selected reference
	        this._reference = reference;
	
	        // 0) Grab and store options
	        this._preference = preferences;
	        this._options = options;
	        this._evolution = evolution;
	        this._workerOptions = Object.assign({}, defaultWorkerOptions, workerOptions);
	
	        // 1) Create context for individuals
	        this._context = {
	            crossover: (0, _CrossoverProvider.run)(crossover),
	            mutation: (0, _MutationProvider.run)(mutation),
	            fitness: (0, _FitnessProvider.run)(fitness)
	        };
	
	        // 2) Set current state variables
	        this._cleanState();
	
	        // 3) Perform initial run
	        this._run();
	    }
	
	    /**
	     * @description Called from GARunner on migration event
	     * @params {Array<number[]>} migrants - array of migrants of type Individual.content
	     */
	
	
	    /**
	     * @type {Array<Individual> | null}
	     */
	
	
	    _createClass(BaseGA, [{
	        key: 'migrate',
	        value: function migrate(migrants) {
	            var _this = this;
	
	            this._migrants = migrants.map(function (x) {
	                return new _Individual2.default(_this._reference, x, null, false, _this._context);
	            });
	        }
	    }, {
	        key: 'resume',
	        value: function resume() {
	            this._paused = false;
	            this._run();
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this._paused = true;
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this._paused = true;
	            this._stopped = true;
	        }
	
	        //-----------------------------
	        //  1. Initial Population
	        //-----------------------------
	
	    }, {
	        key: '_createInitialPopulation',
	        value: function _createInitialPopulation() {
	            this._population = [];
	
	            for (var i = 0; i < this._options.count; i++) {
	                this._population.push(new _Individual2.default(this._reference, null, null, this._options.useRandomInitialIndividuals, this._context));
	            }
	        }
	
	        //-----------------------------
	        //  2. Mutate/Crossover
	        //-----------------------------
	
	    }, {
	        key: '_crossover',
	        value: function _crossover() {
	            var result = [];
	            var clones = this._sortByFitness(this._population.slice());
	
	            while (clones.length > 2) {
	                var mama = clones.pop();
	                var papa = clones.pop();
	                var baby = papa.crossover(mama);
	                result.push(baby);
	            }
	
	            return result;
	        }
	    }, {
	        key: '_mutate',
	        value: function _mutate(population) {
	            var probability = this._options.mutationProbability;
	            var clones = population.slice();
	            return clones.map(function (item) {
	                if (Math.random() < probability) {
	                    item.mutate();
	                }
	                return item;
	            });
	        }
	
	        //-----------------------------
	        //  3. Selection
	        //-----------------------------
	
	    }, {
	        key: '_removeClones',
	        value: function _removeClones(population) {
	            return Object.values(population.reduce(function (reducer, item) {
	                return _extends({}, reducer, _defineProperty({}, item.getHash(), item));
	            }, {}));
	        }
	    }, {
	        key: '_selection',
	        value: function _selection(newPopulation) {
	            var _options = this._options,
	                deathLimit = _options.deathLimit,
	                stopOnEndOfIterations = _options.stopOnEndOfIterations,
	                count = _options.countOfBestToLiveThrought;
	
	
	            var goodGuys = this._removeClones(newPopulation).filter(function (item) {
	                return item.fitnessValue > deathLimit;
	            });
	
	            // TODO: it's variations i guess
	            if (stopOnEndOfIterations) {
	                goodGuys = goodGuys.filter(function (_ref) {
	                    var fitnessValue = _ref.fitnessValue;
	                    return fitnessValue !== 1;
	                });
	            }
	
	            /*
	            Если порог прохождения никто не прошел
	            И установлено количество_выживающих_без_учета_фитнеса
	            То берем ровно столько лучших возможных, сколько не хватает
	             */
	            if (count && goodGuys.length < count) {
	                var bestWeHave = this._getBestWeHave(count, goodGuys.length, newPopulation);
	                goodGuys = [].concat(_toConsumableArray(goodGuys), _toConsumableArray(bestWeHave));
	            }
	
	            return goodGuys;
	        }
	
	        // PURE
	        // USE: _sortByFitness
	
	    }, {
	        key: '_getBestWeHave',
	        value: function _getBestWeHave(countWeNeed, countWeHave, currentPopulation) {
	            var result = [];
	            var population = this._sortByFitness(currentPopulation);
	
	            for (var i = countWeHave; i < countWeNeed; i++) {
	                result.push(population[i]);
	            }
	            return result;
	        }
	
	        /**
	         * @description 4. Creates sorted by fitness population 
	         * @param { Array<Individual> } newPopulation
	         * @returns { Array<Individual> }
	         */
	
	    }, {
	        key: '_createNewPopulation',
	        value: function _createNewPopulation(newPopulation) {
	            var population = newPopulation.slice();
	            var need = this._options.count - population.length;
	
	            // if we need more guys
	            if (need > 0) {
	                for (var i = 0; i < need; i++) {
	                    population.push(new _Individual2.default(this._reference, null, null, this._options.useRandomInitialIndividuals, this._context));
	                }
	                return population;
	            }
	
	            // if we need cut someone
	            return this._sortByFitness(population).slice(0, this._options.count);
	        }
	
	        //-----------------------------
	        //  5. Finish!
	        //-----------------------------
	
	    }, {
	        key: '_isDone',
	        value: function _isDone() {
	            var _this2 = this;
	
	            return this._population.some(function (item) {
	                return item.fitnessValue > _this2._options.threshold;
	            });
	        }
	    }, {
	        key: '_getBest',
	        value: function _getBest(population) {
	            var _this3 = this;
	
	            population = population || this._population;
	            if (!this._bestOne) {
	                this._bestOne = population[0];
	            }
	            var bestFitness = this._bestOne ? this._bestOne.fitnessValue : 0;
	            population.forEach(function (item) {
	                if (item.fitnessValue > bestFitness) {
	                    bestFitness = item.fitnessValue;
	                    _this3._bestOne = item;
	                }
	            });
	            return bestFitness;
	        }
	    }, {
	        key: '_sortByFitness',
	        value: function _sortByFitness(population) {
	            var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	            return (0, _populationSorter.populationSorter)(population, desc);
	        }
	    }, {
	        key: '_cleanState',
	        value: function _cleanState() {
	            this._i = 0;
	            this._paused = false;
	            this._stopped = false;
	            this._population = [];
	            this._bestOne = null;
	        }
	    }, {
	        key: '_run',
	        value: function _run() {
	            var _this4 = this;
	
	            this._createInitialPopulation();
	            this._loop(function () {
	                return _this4._needToRun();
	            }, function () {
	                return _this4._oneEra();
	            }, function () {
	                return _this4._onCompletion();
	            });
	        }
	
	        /**
	         * @description 1. Condition to run GA loop
	         */
	
	    }, {
	        key: '_needToRun',
	        value: function _needToRun() {
	            var _options2 = this._options,
	                maxIterations = _options2.maxIterations,
	                stopOnEndOfIterations = _options2.stopOnEndOfIterations;
	
	            return (stopOnEndOfIterations || !this._isDone()) && !this._paused && this._i < maxIterations;
	        }
	
	        /**
	         * @description 2. GA loop algorithm one iteration's body
	         */
	
	    }, {
	        key: '_oneEra',
	        value: function _oneEra() {
	            this._i++;
	            var parents = this._population.slice();
	
	            if (this._migrants) {
	                parents.push.apply(parents, _toConsumableArray(this._migrants));
	                this._migrants = null;
	            }
	
	            var children = this._mutate(this._crossover());
	            var newPopulation = this._selection([].concat(_toConsumableArray(children), _toConsumableArray(parents)));
	            this._population = this._createNewPopulation(newPopulation);
	            this._notificationProcess();
	            this._migrationProcess();
	        }
	
	        /**
	         * @description 3. GA completion logic
	         */
	
	    }, {
	        key: '_onCompletion',
	        value: function _onCompletion() {
	            var _workerOptions = this._workerOptions,
	                onPause = _workerOptions.onPause,
	                onDone = _workerOptions.onDone;
	
	
	            var populationDTO = this._snapshot(this._population);
	
	            if (this._stopped) {
	                onDone({
	                    id: this._id,
	                    data: populationDTO
	                });
	            } else if (this._paused) {
	                onPause({
	                    id: this._id,
	                    data: populationDTO
	                });
	            } else {
	                onDone({
	                    id: this._id,
	                    data: populationDTO
	                });
	            }
	        }
	    }, {
	        key: '_notificationProcess',
	        value: function _notificationProcess() {
	            var _workerOptions2 = this._workerOptions,
	                onProgress = _workerOptions2.onProgress,
	                notifyRate = _workerOptions2.notifyRate;
	            var maxIterations = this._options.maxIterations;
	
	            var notify = Boolean(onProgress);
	
	            if (notify && this._i % notifyRate === 0) {
	                //TODO: bad calcs this._bestOne and this._bestFitness
	                this._getBest();
	                var percentage = this._formatFitness(this._i, maxIterations);
	
	                onProgress({
	                    id: this._id,
	                    percentage: percentage,
	                    best: this._bestOne.toFullFitnessDTO()
	                });
	            }
	        }
	    }, {
	        key: '_migrationProcess',
	        value: function _migrationProcess() {
	            var onMigration = this._workerOptions.onMigration;
	            var migrationRate = this._options.migrationRate;
	
	            if (!migrationRate) {
	                return;
	            }
	
	            if (onMigration && this._i % migrationRate === 0) {
	                onMigration({
	                    id: this._id,
	                    migrants: this._getMigrants()
	                });
	            }
	        }
	
	        /**
	         * @returns {Array<number[]>} - array of Individual contents
	         */
	
	    }, {
	        key: '_getMigrants',
	        value: function _getMigrants() {
	            var _options3 = this._options,
	                migrationSize = _options3.migrationSize,
	                count = _options3.count;
	
	            var migrantsCount = count * migrationSize | 0;
	            return migrantsCount ? (0, _lodash.sampleSize)(this._population, migrantsCount).map(function (x) {
	                return x.content;
	            }) : [];
	        }
	    }, {
	        key: '_snapshot',
	        value: function _snapshot(currentPopulation) {
	            var population = this._sortByFitness(currentPopulation);
	            // TODO: create Individual factory with preseted context
	            var original = new _Individual2.default(this._reference, null, null, false, this._context);
	            population.unshift(original);
	            return population.map(function (x) {
	                return x.toFullFitnessDTO();
	            });
	        }
	    }, {
	        key: '_formatFitness',
	        value: function _formatFitness(iteration, maxIterations) {
	            return iteration / maxIterations * 100;
	        }
	    }, {
	        key: '_loop',
	        value: function _loop() /* cond, body, done */{
	            throw new Error('Abstract GA class');
	        }
	
	        /**
	         * @param {number} rate - integer
	         */
	
	    }, {
	        key: '_isOccur',
	        value: function _isOccur(rate) {
	            return this._i % rate === 0;
	        }
	    }]);

	    return BaseGA;
	}();

/***/ },

/***/ 675:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Individual = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(610);
	
	var _common = __webpack_require__(624);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Individual = exports.Individual = function () {
		/**
	  * @param {Array<number>} referenceIndividual
	  * @param {Array<number>} contentToStart
	  * @param {number} fitnessValue
	  * @param {boolean} useRandomToStart
	  * @param {Object} context
	  * @param {Function} context.crossover
	  * @param {Function} context.mutation
	  * @param {Function} context.fitness
	  */
		function Individual(referenceIndividual, contentToStart, fitnessValue) {
			var useRandomToStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
			var context = arguments[4];
	
			_classCallCheck(this, Individual);
	
			// -----------------------------
			// -1) Save context
			// -----------------------------
			this._context = context;
	
			// -----------------------------
			// 0) Reference individual
			// -----------------------------
			this._reference = referenceIndividual.slice();
	
			// -----------------------------
			// 1) Content to start
			// -----------------------------
			if (contentToStart) {
				this._content = contentToStart;
			} else {
				this._content = useRandomToStart ? this._reference.map(function () {
					return _utils.arrayUtils.randomElement(_common.availableValues);
				}) : referenceIndividual.slice();
			}
	
			// -----------------------------
			// 2) Content to start
			// -----------------------------
			this._fitnessValue = fitnessValue == null ? this.fitness().value : fitnessValue;
		}
	
		_createClass(Individual, [{
			key: 'clone',
			value: function clone() {
				return new Individual(this._reference, this.content, this.fitnessValue, false, this._context);
			}
	
			/**
	   * @description Mutate and recalculate inner fitnessValue
	   */
	
		}, {
			key: 'mutate',
			value: function mutate(_options) {
				// TODO: pass options to this._context.mutation(..., options) ???
				this._checkContext();
				this._content = this._context.mutation(this._content);
				this._fitnessValue = this.fitness().value;
			}
		}, {
			key: 'crossover',
			value: function crossover(someone) {
				this._checkContext();
				var newContent = this._context.crossover(this.content, someone.content);
				return new Individual(this._reference, newContent, null, false, this._context);
			}
		}, {
			key: 'fitness',
			value: function fitness() {
				this._checkContext();
				return this._context.fitness(this.content, this._reference);
			}
	
			/**
	   * @description NOTE: Always returns by value
	   */
	
		}, {
			key: 'getHash',
			value: function getHash() {
				return this._content.join();
			}
		}, {
			key: 'toDTO',
			value: function toDTO() {
				return {
					_fitnessValue: this._fitnessValue,
					_reference: this._reference.slice(),
					_content: this._content.slice()
				};
			}
		}, {
			key: 'toFullFitnessDTO',
			value: function toFullFitnessDTO() {
				return {
					fitness: this.fitness(),
					content: this._content.slice()
				};
			}
		}, {
			key: '_checkContext',
			value: function _checkContext() {
				if (!this._context) {
					throw new Error('Context is not defined, created via fromDTO');
				}
			}
	
			// TODO: find out better way of getting private fields, maybe create toDTO (in worker) and fromDTO (in UI tread)
	
		}, {
			key: 'reference',
			get: function get() {
				return this._reference.slice();
			}
		}, {
			key: 'context',
			get: function get() {
				return this._context;
			}
		}, {
			key: 'content',
			get: function get() {
				return this._content.slice();
			}
		}, {
			key: 'fitnessValue',
			get: function get() {
				return this._fitnessValue;
			}
		}], [{
			key: 'fromDTO',
			value: function fromDTO(_ref) {
				var _reference = _ref._reference,
				    _content = _ref._content,
				    _fitnessValue = _ref._fitnessValue;
	
				return new Individual(_reference, _content, _fitnessValue, false);
			}
		}]);
	
		return Individual;
	}();
	
	exports.default = Individual;

/***/ },

/***/ 676:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.populationSorter = populationSorter;
	/**
	 * @param {Individual[]} population 
	 * @param {number} desc (1 for desc) (-1 for asc) 
	 */
	function populationSorter(population) {
	    var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    return population.slice().sort(function (a, b) {
	        var af = a.fitnessValue;
	        var bf = b.fitnessValue;
	
	        if (af === bf) {
	            return 0;
	        }
	
	        return af > bf ? -desc : desc;
	    });
	}

/***/ },

/***/ 677:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.loop = loop;
	exports.debounceLoop = debounceLoop;
	exports.syncLoop = syncLoop;
	function loop(condition, body, done) {
		body();
	
		if (!condition()) {
			done();
			return;
		}
	
		setTimeout(function () {
			return loop(condition, body, done);
		}, 0);
	}
	
	/**
	 * @param {Function} condition
	 * @param {Function} body
	 * @param {Function} done
	 * @param {number} defaultRate
	 * @param {number} currentRate
	 */
	function debounceLoop(condition, body, done) {
		var defaultRate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
		var currentRate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultRate;
	
		body();
	
		if (!condition()) {
			done();
			return;
		}
	
		if (currentRate === 0) {
			setTimeout(function () {
				return debounceLoop(condition, body, done, defaultRate, defaultRate);
			}, 0);
			return;
		}
	
		debounceLoop(condition, body, done, defaultRate, --currentRate);
	}
	
	function syncLoop(condition, body, done) {
		while (condition()) {
			body();
		}
	
		done();
	}

/***/ },

/***/ 678:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _GA2 = __webpack_require__(673);
	
	var _utils = __webpack_require__(610);
	
	var _common = __webpack_require__(679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var render = function render(state, onblur) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        (0, _UIFactory.createSliderFactory)(state, onblur)([{ field: 'adaptationRate' }, { field: 'adaptationPercent' }, { field: 'maxChildren', max: 10 }, { field: 'environmentChangeRate', max: 1000 }, { field: 'changeWeight', min: 0, max: 1, step: 0.01 }])
	    );
	};
	
	var LamarkExecutor = function (_GA) {
	    _inherits(LamarkExecutor, _GA);
	
	    function LamarkExecutor() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LamarkExecutor);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LamarkExecutor.__proto__ || Object.getPrototypeOf(LamarkExecutor)).call.apply(_ref, [this].concat(args))), _this), _this._environmentChanger = new _common.EnvironmentChanger(), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LamarkExecutor, [{
	        key: '_oneEra',
	        value: function _oneEra() {
	            _get(LamarkExecutor.prototype.__proto__ || Object.getPrototypeOf(LamarkExecutor.prototype), '_oneEra', this).call(this);
	            var _evolution = this._evolution,
	                adaptationRate = _evolution.adaptationRate,
	                environmentChangeRate = _evolution.environmentChangeRate;
	
	
	            if (this._isOccur(adaptationRate)) {
	                this._adaptate();
	            }
	
	            if (this._isOccur(environmentChangeRate)) {
	                this._changeEnvironment();
	            }
	        }
	    }, {
	        key: '_changeEnvironment',
	        value: function _changeEnvironment() {
	            var changeWeight = this._evolution.changeWeight;
	
	            this._context = this._environmentChanger.createContext(this._preference, changeWeight);
	        }
	    }, {
	        key: '_adaptate',
	        value: function _adaptate() {
	            var _this2 = this;
	
	            var _evolution2 = this._evolution,
	                adaptationPercent = _evolution2.adaptationPercent,
	                maxChildren = _evolution2.maxChildren;
	
	            var populationSize = this._population.length;
	            var adaptantsCount = Math.floor(populationSize * adaptationPercent / 100);
	
	            if (!adaptantsCount) {
	                return;
	            }
	
	            var indexes = _utils.arrayUtils.getRandomIndexes(adaptantsCount, populationSize);
	            var goodAdaptants = [];
	
	            indexes.forEach(function (index) {
	                var old = _this2._population[index];
	                var newOne = old.clone();
	                newOne.mutate();
	                if (newOne.fitnessValue > old.fitnessValue) {
	                    goodAdaptants.push(newOne);
	                    _this2._population[index] = newOne;
	                }
	            });
	
	            // If we have good adaptants create childrens from them
	            if (goodAdaptants.length >= 2) {
	                while (goodAdaptants.length > 1) {
	                    var childrenCount = _utils.numberUtils.randomBetween(1, maxChildren);
	                    var mama = goodAdaptants.pop();
	                    var papa = goodAdaptants.pop();
	
	                    while (childrenCount > 0) {
	                        childrenCount--;
	                        this._population.push(papa.crossover(mama));
	                    }
	                }
	
	                this._population = this._createNewPopulation(this._population);
	            }
	        }
	    }]);
	
	    return LamarkExecutor;
	}(_GA2.GA);
	
	exports.default = {
	    executor: LamarkExecutor,
	    render: render,
	    name: 'lamark-evolution',
	    getInitialState: function getInitialState() {
	        return {
	            weight: 0.5,
	
	            // Adaptation
	            adaptationRate: 10,
	            adaptationPercent: 20,
	            maxChildren: 4,
	
	            // Environment change
	            environmentChangeRate: 70,
	            changeWeight: 0.2
	        };
	    }
	};

/***/ },

/***/ 679:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EnvironmentChanger = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(610);
	
	var _CrossoverProvider = __webpack_require__(605);
	
	var _MutationProvider = __webpack_require__(619);
	
	var _FitnessProvider = __webpack_require__(642);
	
	var _lodash = __webpack_require__(198);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EnvironmentChanger = exports.EnvironmentChanger = function () {
	    function EnvironmentChanger() {
	        _classCallCheck(this, EnvironmentChanger);
	    }
	
	    _createClass(EnvironmentChanger, [{
	        key: '_changeWeights',
	
	        /**
	         * @description Change weight property of GO options by reference
	         */
	        value: function _changeWeights(geneticOperatorOptions, fluctuateRate) {
	            Object.values(geneticOperatorOptions).forEach(function (x) {
	                x.weight = _utils.numberUtils.fluctuate(x.weight, fluctuateRate);
	            });
	            return geneticOperatorOptions;
	        }
	
	        /**
	         * @param { { crossover: { weight: number }, mutation: { weight: number }, fitness: { weight: number } } } options
	         * @param {number} changeWeight - between 0 and 1
	         */
	
	    }, {
	        key: 'createContext',
	        value: function createContext(options, changeWeight) {
	            var crossover = options.crossover,
	                mutation = options.mutation,
	                fitness = options.fitness;
	
	            return {
	                crossover: (0, _CrossoverProvider.run)(this._changeWeights(crossover, changeWeight)),
	                mutation: (0, _MutationProvider.run)(this._changeWeights(mutation, changeWeight)),
	                fitness: (0, _FitnessProvider.run)(this._changeWeights(fitness, changeWeight))
	            };
	        }
	
	        /**
	         * @param { { crossover: { weight: number }, mutation: { weight: number }, fitness: { weight: number } } } options
	         * @param {number} changeWeight - between 0 and 1
	         */
	
	    }, {
	        key: 'fluctuateOptions',
	        value: function fluctuateOptions(options, changeWeight) {
	            var _cloneDeep = (0, _lodash.cloneDeep)(options),
	                crossover = _cloneDeep.crossover,
	                mutation = _cloneDeep.mutation,
	                fitness = _cloneDeep.fitness;
	
	            return _extends({}, options, {
	                crossover: this._changeWeights(crossover, changeWeight),
	                mutation: this._changeWeights(mutation, changeWeight),
	                fitness: this._changeWeights(fitness, changeWeight)
	            });
	        }
	    }]);

	    return EnvironmentChanger;
	}();

/***/ },

/***/ 680:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	var _GA2 = __webpack_require__(673);
	
	var _utils = __webpack_require__(610);
	
	var _common = __webpack_require__(679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VriesExecutor = function (_GA) {
	    _inherits(VriesExecutor, _GA);
	
	    function VriesExecutor() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, VriesExecutor);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VriesExecutor.__proto__ || Object.getPrototypeOf(VriesExecutor)).call.apply(_ref, [this].concat(args))), _this), _this._environmentChanger = new _common.EnvironmentChanger(), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(VriesExecutor, [{
	        key: '_oneEra',
	        value: function _oneEra() {
	            _get(VriesExecutor.prototype.__proto__ || Object.getPrototypeOf(VriesExecutor.prototype), '_oneEra', this).call(this);
	            var catastropheRate = this._evolution.catastropheRate;
	
	
	            if (this._isOccur(catastropheRate)) {
	                this._catastrophe();
	            }
	        }
	    }, {
	        key: '_catastrophe',
	        value: function _catastrophe() {
	            var _evolution = this._evolution,
	                mutationCatastropheWeight = _evolution.mutationCatastropheWeight,
	                deadCatastropheWeight = _evolution.deadCatastropheWeight,
	                environmentCatastropheWeight = _evolution.environmentCatastropheWeight;
	
	
	            var catastropheKey = this._getCatastropheKey();
	
	            switch (catastropheKey) {
	                case 'mutation':
	                    this._mutationCatastrophe(mutationCatastropheWeight);
	                    break;
	                case 'dead':
	                    this._deadCatastrophe(deadCatastropheWeight);
	                    break;
	                case 'environment':
	                    this._environmentCatastrophe(environmentCatastropheWeight);
	                    break;
	            }
	        }
	    }, {
	        key: '_getCatastropheKey',
	        value: function _getCatastropheKey() {
	            var _evolution2 = this._evolution,
	                mutationCatastropheProbability = _evolution2.mutationCatastropheProbability,
	                deadCatastropheProbability = _evolution2.deadCatastropheProbability,
	                environmentCatastropheProbability = _evolution2.environmentCatastropheProbability;
	
	            return _utils.selectionUtils.getRandomKey({
	                mutationCatastropheProbability: mutationCatastropheProbability,
	                deadCatastropheProbability: deadCatastropheProbability,
	                environmentCatastropheProbability: environmentCatastropheProbability
	            }).replace('CatastropheProbability', '');
	        }
	
	        /**
	         * @param {number} weight - from 0 to 1
	         */
	
	    }, {
	        key: '_mutationCatastrophe',
	        value: function _mutationCatastrophe(weight) {
	            console.log('Mutation Catastrophe Occurs!');
	            if (!weight) {
	                return;
	            }
	
	            this._options.mutationProbability = _utils.numberUtils.strip(this._options.mutationProbability + weight);
	        }
	
	        /**
	         * @param {number} weight - from 0 to 1
	         */
	
	    }, {
	        key: '_deadCatastrophe',
	        value: function _deadCatastrophe(weight) {
	            console.log('Dead Catastrophe Occurs!');
	            if (!weight) {
	                return;
	            }
	            var populationSize = this._population.length;
	            var howMuchWouldDie = Math.floor(weight * populationSize);
	
	            if (!howMuchWouldDie) {
	                return;
	            }
	
	            /**
	             * @type {Array<number>}
	             */
	            var indexesToRemove = _utils.arrayUtils.getRandomIndexes(howMuchWouldDie, populationSize);
	            var stippedPopulation = this._population.filter(function (_, i) {
	                return !indexesToRemove.includes(i);
	            });
	            this._population = this._createNewPopulation(stippedPopulation);
	        }
	
	        /**
	         * @param {number} weight - from 0 to 1
	         */
	
	    }, {
	        key: '_environmentCatastrophe',
	        value: function _environmentCatastrophe(weight) {
	            console.log('Environmental Catastrophe Occurs!');
	            if (!weight) {
	                return;
	            }
	            this._context = this._environmentChanger.createContext(this._preference, weight);
	        }
	    }]);
	
	    return VriesExecutor;
	}(_GA2.GA);
	
	var render = function render(state, onblur) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        (0, _UIFactory.createSliderFactory)(state, onblur)([{ field: 'catastropheRate', min: 0, max: 100 }, (0, _UIFactory.probabilitySlider)('mutationCatastropheProbability'), (0, _UIFactory.probabilitySlider)('mutationCatastropheWeight'), (0, _UIFactory.probabilitySlider)('deadCatastropheProbability'), (0, _UIFactory.probabilitySlider)('deadCatastropheWeight'), (0, _UIFactory.probabilitySlider)('environmentCatastropheProbability'), (0, _UIFactory.probabilitySlider)('environmentCatastropheWeight')])
	    );
	};
	
	exports.default = {
	    render: render,
	    executor: VriesExecutor,
	    name: 'vries-evolution',
	    getInitialState: function getInitialState() {
	        return {
	            weight: 0.5,
	            catastropheRate: 10,
	            mutationCatastropheProbability: 0.2,
	            mutationCatastropheWeight: 0.3,
	            deadCatastropheProbability: 0.2,
	            deadCatastropheWeight: 0.3,
	            environmentCatastropheProbability: 0.2,
	            environmentCatastropheWeight: 0.3
	        };
	    }
	};

/***/ },

/***/ 681:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _KimuraExecutor = __webpack_require__(682);
	
	var _getInitialStateFromMeta = __webpack_require__(687);
	
	var _getRenderFromMeta = __webpack_require__(688);
	
	var META = {
	    speciesCount: {
	        value: 2,
	        min: 2,
	        max: 10
	    },
	    speciesSeparationRate: {
	        value: 10,
	        min: 10,
	        max: 1000
	    }
	};
	
	exports.default = {
	    executor: _KimuraExecutor.KimuraExecutor,
	    render: (0, _getRenderFromMeta.getRenderFromMeta)(META),
	    name: 'kimura-evolution',
	    getInitialState: (0, _getInitialStateFromMeta.getInitialStateFromMeta)(META, 0.5)
	};

/***/ },

/***/ 682:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	exports.KimuraExecutor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _clusterfck = __webpack_require__(683);
	
	var _clusterfck2 = _interopRequireDefault(_clusterfck);
	
	var _GA2 = __webpack_require__(673);
	
	var _Individual = __webpack_require__(675);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KimuraExecutor = exports.KimuraExecutor = function (_GA) {
	        _inherits(KimuraExecutor, _GA);
	
	        function KimuraExecutor() {
	                _classCallCheck(this, KimuraExecutor);
	
	                return _possibleConstructorReturn(this, (KimuraExecutor.__proto__ || Object.getPrototypeOf(KimuraExecutor)).apply(this, arguments));
	        }
	
	        _createClass(KimuraExecutor, [{
	                key: '_oneEra',
	                value: function _oneEra() {
	                        _get(KimuraExecutor.prototype.__proto__ || Object.getPrototypeOf(KimuraExecutor.prototype), '_oneEra', this).call(this);
	                        var speciesSeparationRate = this._evolution.speciesSeparationRate;
	
	
	                        if (this._isOccur(speciesSeparationRate)) {
	                                this._separate();
	                        }
	                }
	                /**
	                 * @type { { speciesSeparationRate: number, speciesCount: number } }
	                 */
	
	        }, {
	                key: '_separate',
	                value: function _separate() {
	                        var _this2 = this;
	
	                        var speciesCount = this._evolution.speciesCount;
	
	                        // 0. Create clusters
	                        /**
	                         * @type { Array<{ Array<number> }> } - array of clusters and its content Individual.content
	                         */
	
	                        var clusters = _clusterfck2.default.kmeans(this._population.map(function (x) {
	                                return x.content;
	                        }));
	                        var countOfClusters = clusters.length;
	
	                        if (speciesCount >= countOfClusters) {
	                                return;
	                        }
	
	                        /**
	                         * NOTE: The choice of clusters can be. (TODO: Could be an option later on)
	                         * 1. By best fitness of random individual in cluster
	                         * 2. By best fitness in cluster
	                         * 3. Random
	                         * ✓ 4. By cluster size
	                         */
	
	                        // 1. Sort by size
	                        clusters.sort(function (c1, c2) {
	                                return c1.length - c2.length;
	                        });
	
	                        // 2. Grab only needed count of clusters
	                        var clustersToUse = clusters.slice(0, speciesCount);
	
	                        // 3. Flatten clusters
	                        var gensForNewPopulation = clustersToUse.reduce(function (store, cluster) {
	                                return [].concat(_toConsumableArray(store), _toConsumableArray(cluster));
	                        }, []);
	
	                        // 4. Recreate individuals from gens
	                        var newPopulation = gensForNewPopulation.map(function (x) {
	                                return new _Individual.Individual(_this2._reference, x, null, false, _this2._context);
	                        });
	
	                        // 5. Recreate population
	                        this._population = this._createNewPopulation(newPopulation);
	                }
	        }]);

	        return KimuraExecutor;
	}(_GA2.GA);

/***/ },

/***/ 687:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * @param { { [field]: { min: number, max: number, value: number } } } meta
	 * @param {number} weight - from 0 to 1
	 */
	var getInitialStateFromMeta = exports.getInitialStateFromMeta = function getInitialStateFromMeta(meta) {
	    var weight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.3;
	    return function () {
	        return _extends({
	            weight: weight
	        }, Object.entries(meta).reduce(function (store, _ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                key = _ref2[0],
	                value = _ref2[1].value;
	
	            return _extends({}, store, _defineProperty({}, key, value));
	        }, {}));
	    };
	};

/***/ },

/***/ 688:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getRenderFromMeta = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UIFactory = __webpack_require__(609);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRenderFromMeta = exports.getRenderFromMeta = function getRenderFromMeta(meta) {
	    return function (state, onblur) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            (0, _UIFactory.createSliderFactory)(state, onblur)(Object.entries(meta).map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    field = _ref2[0],
	                    _ref2$ = _ref2[1],
	                    min = _ref2$.min,
	                    max = _ref2$.max;
	
	                return {
	                    field: field,
	                    min: min,
	                    max: max,
	                    step: max === 1 ? 0.01 : 1
	                };
	            }))
	        );
	    };
	};

/***/ },

/***/ 689:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PunctuatedEquilibriumExecutor = __webpack_require__(690);
	
	var _getInitialStateFromMeta = __webpack_require__(687);
	
	var _getRenderFromMeta = __webpack_require__(688);
	
	var META = {
	    // NOTE: not implemented for now
	    // environmentChangeWeight: {
	    //     value: 0.3,
	    //     min: 0,
	    //     max: 1
	    // },
	    // environmentChangeRate: {
	    //     value: 10,
	    //     min: 0,
	    //     max: 100
	    // },
	    environmentDifferenceWeight: {
	        value: 0.3,
	        min: 0,
	        max: 1
	    },
	    groupsCount: {
	        value: 4,
	        min: 1,
	        max: 25
	    }
	};
	
	exports.default = {
	    executor: _PunctuatedEquilibriumExecutor.PunctuatedEquilibriumExecutor,
	    render: (0, _getRenderFromMeta.getRenderFromMeta)(META),
	    name: 'punctuated-equilibrium-evolution',
	    getInitialState: (0, _getInitialStateFromMeta.getInitialStateFromMeta)(META, .5)
	};

/***/ },

/***/ 690:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PunctuatedEquilibriumExecutor = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(691);
	
	var _SimpleGARunner = __webpack_require__(692);
	
	var _utils = __webpack_require__(610);
	
	var _FitnessProvider = __webpack_require__(642);
	
	var _Individual = __webpack_require__(675);
	
	var _common = __webpack_require__(679);
	
	var _populationSorter = __webpack_require__(676);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_NOTIFY_RATE = 10;
	
	var PunctuatedEquilibriumExecutor = exports.PunctuatedEquilibriumExecutor = function () {
	
	    /**
	     * @param {{ options: {}, evolution: { groupsCount: number, environmentChangeWeight: number, environmentChangeRate: number, environmentDifferenceWeight: number }, crossover: {}, mutation: {}, fitness: {} }} preferences
	     * @param { { onDone: Function, onProgress: Function, onPause: Function } } workerOptions
	     */
	
	
	    /**
	     * @type { [uuid: string]: boolean }
	     */
	
	
	    /**
	     * @type { { [uuid: string]: { data: { content: Array<number> }[] } } }
	     */
	
	
	    /**
	     * @description Hash of runner and its current iteration.
	     * @type { { [uuid: string]: number } }
	     */
	    function PunctuatedEquilibriumExecutor(preferences) {
	        var workerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var reference = arguments[2];
	        var id = arguments[3];
	
	        _classCallCheck(this, PunctuatedEquilibriumExecutor);
	
	        this._environmentChanger = new _common.EnvironmentChanger();
	        this.currentIteration = 0;
	        this.runners = {};
	        this.iteration = {};
	        this.progressEvents = {};
	        this.pauseEvents = {};
	        this.doneEvents = {};
	        this._pauseFlags = null;
	        this._doneFlags = {};
	        this._best = null;
	        this._migrants = null;
	        this._migrantsToSendToChilds = null;
	        this._currentEra = 0;
	
	        var groupsCount = preferences.evolution.groupsCount;
	
	        this.preferences = preferences;
	        this.evolutionId = id;
	        this.workerOptions = _extends({}, workerOptions, { notifyRate: DEFAULT_NOTIFY_RATE });
	        this.reference = reference;
	
	        if (this.preferences.options.migrationRate % DEFAULT_NOTIFY_RATE) {
	            console.warn('Migration rate (' + this.preferences.options.migrationRate + ') is not supported. Should int divided by notification rate (' + DEFAULT_NOTIFY_RATE + ').');
	        }
	
	        for (var i = 0; i < groupsCount; i++) {
	            this._createInstance(preferences, reference);
	        }
	    }
	
	    /**
	     * @description Called from GARunner on migration event
	     * @params {Array<number[]>} migrants - array of migrants of type Individual.content
	     */
	
	
	    /**
	     * @type {Array<number[]>}
	     */
	
	
	    /**
	     * @type { [uuid: string]: boolean }
	     */
	
	
	    /**
	     * @type { { [uuid: string]: { data: { content: Array<number> }[] } } }
	     */
	
	
	    /**
	     * @type { { [uuid: string]: { { best: { content: Array<number>, fitness: { full: { [fitnessName: string]: value }, value: number } }, percentage: number } } } }
	     */
	
	
	    /**
	     * @type { [uuid: string]: SimpleGARunner }
	     */
	
	
	    _createClass(PunctuatedEquilibriumExecutor, [{
	        key: 'migrate',
	        value: function migrate(migrants) {
	            var _migrantsToSendToChil;
	
	            if (!migrants || !migrants.length) {
	                return;
	            }
	            this._migrantsToSendToChilds = this._migrantsToSendToChilds || [];
	            (_migrantsToSendToChil = this._migrantsToSendToChilds).push.apply(_migrantsToSendToChil, _toConsumableArray(migrants));
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            Object.values(this.runners).forEach(function (r) {
	                r.stop();
	                r.destroy();
	            });
	            this.runners = {};
	            this.iteration = {};
	            this.progressEvents = {};
	            this._currentEra = 0;
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this._pauseFlags = Object.keys(this.runners).reduce(function (store, key) {
	                return _extends({}, store, _defineProperty({}, key, false));
	            }, {});
	            Object.values(this.runners).forEach(function (r) {
	                return r.pause();
	            });
	        }
	    }, {
	        key: 'resume',
	        value: function resume() {
	            Object.values(this.runners).forEach(function (r) {
	                return r.resume();
	            });
	        }
	    }, {
	        key: '_oneEra',
	        value: function _oneEra() {
	            var onMigration = this.workerOptions.onMigration;
	
	            this._currentEra += DEFAULT_NOTIFY_RATE;
	            console.log('new era', this._currentEra);
	
	            if (onMigration && this._migrants && this._currentEra % this.preferences.options.migrationRate === 0) {
	                console.log('migration from PunctuatedEquilibriumExecutor');
	                onMigration({
	                    id: this.evolutionId,
	                    migrants: this._migrants
	                });
	                this._migrants = null;
	            }
	        }
	    }, {
	        key: '_createInstance',
	        value: function _createInstance(rootOptions, reference) {
	            var _this = this;
	
	            var id = (0, _utils.uuid)();
	            var options = this._createInstanceOptions(rootOptions);
	
	            var instanceWorkerOptions = {
	                onDone: function onDone(e) {
	                    return _this._onInstanceDone(e, id);
	                },
	                onProgress: function onProgress(e) {
	                    return _this._onInstanceProgress(e, id);
	                },
	
	                /**
	                 * @param { { data: { content: Array<number> }[] } } e
	                 */
	                onPause: function onPause(e) {
	                    return _this._onInstancePause(e, id);
	                }
	            };
	
	            var instance = new _SimpleGARunner.SimpleGARunner(options, instanceWorkerOptions, reference, function (migrants) {
	                return _this._onMigrationFromInstances(migrants);
	            });
	            this.progressEvents[id] = null;
	            this.iteration[id] = 0;
	            this.runners[id] = instance;
	            this._doneFlags[id] = false;
	        }
	    }, {
	        key: '_onMigrationFromInstances',
	        value: function _onMigrationFromInstances(migrants) {
	            var _migrants;
	
	            this._migrants = this._migrants || [];
	            (_migrants = this._migrants).push.apply(_migrants, _toConsumableArray(migrants));
	            var migrantsToSend = this._migrantsToSendToChilds;
	            this._migrantsToSendToChilds = null;
	            return migrantsToSend;
	        }
	    }, {
	        key: '_onInstanceDone',
	        value: function _onInstanceDone(e, subId) {
	            this.doneEvents[subId] = e;
	            this._doneFlags[subId] = true;
	
	            if (Object.values(this._doneFlags).some(function (x) {
	                return !x;
	            })) {
	                return;
	            }
	
	            var event = this._getSnapshotEvent(this.doneEvents);
	            this.workerOptions.onDone(_extends({
	                id: this.evolutionId
	            }, event));
	            this._doneFlags = {};
	        }
	
	        /**
	         * 
	         * @param { { best: { content: Array<number>, fitness: { full: { [fitnessName: string]: value }, value: number } }, percentage: number } } e 
	         * @param {string} subId 
	         */
	
	    }, {
	        key: '_onInstanceProgress',
	        value: function _onInstanceProgress(e, subId) {
	            this.iteration[subId] += 1;
	            this.progressEvents[subId] = e;
	
	            if (this.currentIteration >= this._getMinIteration()) {
	                return;
	            }
	
	            this._oneEra();
	            this.currentIteration += 1;
	
	            var event = this._getCurrentIterationEvent();
	            if (!event) {
	                return;
	            }
	
	            this.workerOptions.onProgress(_extends({}, event, {
	                id: this.evolutionId
	            }));
	        }
	
	        /**
	         * @param { { data: { content: Array<number> }[] } } e
	         * @param {string} subId
	         */
	
	    }, {
	        key: '_onInstancePause',
	        value: function _onInstancePause(e, subId) {
	            this.pauseEvents[subId] = e;
	            this._pauseFlags[subId] = true;
	
	            if (Object.values(this._pauseFlags).some(function (x) {
	                return !x;
	            })) {
	                return;
	            }
	
	            var event = this._getSnapshotEvent(this.pauseEvents);
	            this.workerOptions.onPause(_extends({
	                id: this.evolutionId
	            }, event));
	            this._pauseFlags = {};
	        }
	    }, {
	        key: '_getSnapshotEvent',
	        value: function _getSnapshotEvent(events) {
	            var _this2 = this;
	
	            // NOTE: population snapshot contains original reference as a first element
	            var original = void 0;
	            var raw = Object.values(events).filter(function (x) {
	                return x;
	            }).reduce(function (store, _ref) {
	                var data = _ref.data;
	
	                original = data.shift();
	                return [].concat(_toConsumableArray(store), _toConsumableArray(data.map(function (_ref2) {
	                    var content = _ref2.content;
	                    return content;
	                })));
	            }, []);
	
	            var fitness = this.preferences.fitness;
	
	            var context = {
	                fitness: (0, _FitnessProvider.run)(fitness)
	            };
	
	            // 2. Recreate and sort population;
	            /**
	             * @type {Array<{ content: Array[number], fitness: { value: number } }>}
	             */
	            var individuals = (0, _populationSorter.populationSorter)(raw.map(function (x) {
	                return new _Individual.Individual(_this2.reference, x, null, false, context);
	            })).map(function (x) {
	                return x.toFullFitnessDTO();
	            });
	            individuals.unshift(original);
	
	            return {
	                data: individuals
	            };
	        }
	    }, {
	        key: '_getCurrentIterationEvent',
	        value: function _getCurrentIterationEvent() {
	            var _this3 = this;
	
	            var fitness = this.preferences.fitness;
	
	
	            var context = {
	                fitness: (0, _FitnessProvider.run)(fitness)
	            };
	
	            /**
	             * @type { { best: { content: Array<number>, fitness: { full: { [fitnessName: string]: value }, value: number } }, percentage: number }[] }
	             */
	            var events = Object.values(this.progressEvents).filter(function (x) {
	                return x;
	            });
	            var percentage = events.reduce(function (value, _ref3) {
	                var percentage = _ref3.percentage;
	                return percentage > value ? value : percentage;
	            }, events[0].percentage);
	
	            // NOTE: for the end we don't wanna have two 100 points on graph so we wait for done
	            if (percentage === 100) {
	                return null;
	            }
	
	            var bestGuys = events.map(function (event) {
	                return new _Individual.Individual(_this3.reference, event.best.content, null, false, context);
	            });
	
	            if (!this._best) {
	                this._best = bestGuys[0];
	            }
	
	            var best = bestGuys.reduce(function (bestOne, individual) {
	                return bestOne.fitnessValue > individual.fitnessValue ? bestOne : individual;
	            }, bestGuys[0]);
	
	            if (best.fitnessValue > this._best.fitnessValue) {
	                this._best = best;
	            }
	
	            return {
	                best: this._best.toFullFitnessDTO(),
	                percentage: percentage
	            };
	        }
	
	        /**
	         * @param {{ options: {}, evolution: { groupsCount: number, environmentChangeWeight: number, environmentChangeRate: number, environmentDifferenceWeight: number }, crossover: {}, mutation: {}, fitness: {} }} rootOptions
	         */
	
	    }, {
	        key: '_createInstanceOptions',
	        value: function _createInstanceOptions(rootOptions) {
	            var _rootOptions$evolutio = rootOptions.evolution,
	                environmentDifferenceWeight = _rootOptions$evolutio.environmentDifferenceWeight,
	                groupsCount = _rootOptions$evolutio.groupsCount,
	                count = rootOptions.options.count;
	
	            var oneGroupCount = Math.floor(count / groupsCount);
	            return _extends({}, this._environmentChanger.fluctuateOptions(rootOptions, environmentDifferenceWeight), {
	                options: _extends({}, rootOptions.options, {
	                    count: oneGroupCount
	                })
	            });
	        }
	    }, {
	        key: '_getMinIteration',
	        value: function _getMinIteration() {
	            return Math.min.apply(Math, _toConsumableArray(Object.values(this.iteration)));
	        }
	    }]);

	    return PunctuatedEquilibriumExecutor;
	}();

/***/ },

/***/ 691:
/***/ function(module, exports) {

	"use strict";
	
	// https://github.com/dmihal/Subworkers
	/* eslint-disable */
	(function () {
	
	  /* Detect if we're in a worker or not */
	  var isWorker = false;
	  try {
	    document;
	  } catch (e) {
	    isWorker = true;
	  }
	
	  if (isWorker) {
	    if (!self.Worker) {
	      self.Worker = function (path) {
	        var that = this;
	        this.id = Math.random().toString(36).substr(2, 5);
	
	        this.eventListeners = {
	          "message": []
	        };
	        self.addEventListener("message", function (e) {
	          if (e.data._from === that.id) {
	            var newEvent = new MessageEvent("message");
	            newEvent.initMessageEvent("message", false, false, e.data.message, that, "", null, []);
	            that.dispatchEvent(newEvent);
	            if (that.onmessage) {
	              that.onmessage(newEvent);
	            }
	          }
	        });
	
	        var location = self.location.pathname;
	        var absPath = location.substring(0, location.lastIndexOf('/')) + '/' + path;
	        self.postMessage({
	          _subworker: true,
	          cmd: 'newWorker',
	          id: this.id,
	          path: absPath
	        });
	      };
	      Worker.prototype = {
	        onerror: null,
	        onmessage: null,
	        postMessage: function postMessage(message) {
	          self.postMessage({
	            _subworker: true,
	            id: this.id,
	            cmd: 'passMessage',
	            message: message
	          });
	        },
	        terminate: function terminate() {
	          self.postMessage({
	            _subworker: true,
	            cmd: 'terminate',
	            id: this.id
	          });
	        },
	        addEventListener: function addEventListener(type, listener, useCapture) {
	          if (this.eventListeners[type]) {
	            this.eventListeners[type].push(listener);
	          }
	        },
	        removeEventListener: function removeEventListener(type, listener, useCapture) {
	          if (!(type in this.eventListeners)) return;
	          var index = this.eventListeners[type].indexOf(listener);
	          if (index !== -1) {
	            this.eventListeners[type].splice(index, 1);
	          }
	        },
	        dispatchEvent: function dispatchEvent(event) {
	          var listeners = this.eventListeners[event.type];
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i](event);
	          }
	        }
	      };
	    }
	  }
	
	  var allWorkers = {};
	  var cmds = {
	    newWorker: function newWorker(event) {
	      var worker = new Worker(event.data.path);
	      worker.addEventListener("message", function (e) {
	        var envelope = {
	          _from: event.data.id,
	          message: e.data
	        };
	        event.target.postMessage(envelope);
	      });
	      allWorkers[event.data.id] = worker;
	    },
	    terminate: function terminate(event) {
	      allWorkers[event.data.id].terminate();
	    },
	    passMessage: function passMessage(event) {
	      allWorkers[event.data.id].postMessage(event.data.message);
	    }
	  };
	  var messageRecieved = function messageRecieved(event) {
	    if (event.data._subworker) {
	      cmds[event.data.cmd](event);
	    }
	  };
	
	  /* Hijack Worker */
	  var oldWorker = Worker;
	  Worker = function (_Worker) {
	    function Worker(_x) {
	      return _Worker.apply(this, arguments);
	    }
	
	    Worker.toString = function () {
	      return _Worker.toString();
	    };
	
	    return Worker;
	  }(function (path) {
	    if (this.constructor !== Worker) {
	      throw new TypeError("Failed to construct 'Worker': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");
	    }
	
	    var blobIndex = path.indexOf('blob:');
	
	    if (blobIndex !== -1 && blobIndex !== 0) {
	      path = path.substring(blobIndex);
	    }
	
	    var newWorker = new oldWorker(path);
	    newWorker.addEventListener("message", messageRecieved);
	
	    return newWorker;
	  });
	})();

/***/ },

/***/ 692:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SimpleGARunner = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _SimpleGAWorker = __webpack_require__(693);
	
	var _SimpleGAWorker2 = _interopRequireDefault(_SimpleGAWorker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @description TODO: merge with GARunner
	 */
	var SimpleGARunner = exports.SimpleGARunner = function () {
	
	    /**
	     * @param { Object } options
	     * @param { { onDone: Function, onProgress: Function, onPause: Function } } workerOptions
	     */
	    function SimpleGARunner(options, workerOptions, reference, onMigration) {
	        _classCallCheck(this, SimpleGARunner);
	
	        this.onMigration = onMigration;
	        this._setupDefault(options, workerOptions, reference);
	    }
	
	    /**
	     * @param { Object } options
	     * @param { { onDone: Function, onProgress: Function, onPause: Function } } workerOptions
	     * @param {*} reference 
	     */
	
	    /**
	     * @type {Worker}
	     */
	
	
	    _createClass(SimpleGARunner, [{
	        key: '_setupDefault',
	        value: function _setupDefault(options, workerOptions, reference) {
	            this._worker = new _SimpleGAWorker2.default();
	            this._worker.onmessage = this._createOnMessage(workerOptions, this._worker);
	            this._worker.onerror = function (err) {
	                return console.warn(err);
	            };
	            this._worker.postMessage({ data: { options: options, reference: reference }, action: 'start' });
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            this._worker.postMessage({ action: 'pause' });
	        }
	    }, {
	        key: 'resume',
	        value: function resume() {
	            this._worker.postMessage({ action: 'resume' });
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            this._worker.postMessage({ action: 'stop' });
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this._worker.terminate();
	        }
	
	        /**
	         * @description To react on worker postMessages
	         */
	
	    }, {
	        key: '_createOnMessage',
	        value: function _createOnMessage(_ref, instance) {
	            var _this = this;
	
	            var onDone = _ref.onDone,
	                onProgress = _ref.onProgress,
	                onPause = _ref.onPause;
	
	            return function (_ref2) {
	                var _ref2$data = _ref2.data,
	                    data = _ref2$data.data,
	                    action = _ref2$data.action;
	
	                console.log('SimpleGARunner: onmessage from worker ' + action);
	
	                if (action === 'done') {
	                    var population = data.data;
	                    onProgress({ percentage: 100, best: population[1] });
	                    onDone(data);
	                    return;
	                }
	
	                if (onProgress && action === 'progress') {
	                    onProgress({
	                        percentage: data.percentage,
	                        best: data.best
	                    });
	                }
	
	                if (onPause && action === 'pause') {
	                    onPause(data);
	                }
	
	                if (action === 'migrate') {
	                    var migrantsToSendBack = _this.onMigration(data.migrants);
	                    if (migrantsToSendBack) {
	                        instance.postMessage({
	                            action: 'migrate',
	                            data: { migrants: migrantsToSendBack }
	                        });
	                    }
	                }
	            };
	        }
	    }]);

	    return SimpleGARunner;
	}();

/***/ },

/***/ 693:
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		return new Worker(__webpack_require__.p + "c01b4358ef245848376a.worker.js");
	};

/***/ },

/***/ 694:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GARunner = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	var _GAWorker = __webpack_require__(695);
	
	var _GAWorker2 = _interopRequireDefault(_GAWorker);
	
	var _utils = __webpack_require__(610);
	
	var _lodash = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class Creates GA worker instance and passes options to it.
	 * Creates everytime user pushes to "run" button
	 */
	var GARunner = exports.GARunner = function () {
	
	    /**
	     * @param { { useEvolutionStrategies: boolean } } options
	     * @param { { onDone: Function, onProgress: Function, onPause: Function } } workerOptions
	     */
	
	
	    /**
	     * @type {Worker}
	     */
	
	
	    /**
	     * @type {Array<number[]>} - an array of Individuals content
	     */
	    function GARunner(options, workerOptions) {
	        _classCallCheck(this, GARunner);
	
	        this.workersPool = {};
	        this.migrationPool = [];
	        this._useEvolutionStrategies = false;
	
	        var reference = _MusicContext2.default.getCurrentComposition();
	        var evolution = options.evolution;
	        this._useEvolutionStrategies = options.options.useEvolutionStrategies;
	
	        if (this._useEvolutionStrategies) {
	            this._setupEvolutions(evolution, options, workerOptions, reference);
	        } else {
	            this._setupDefault(options, workerOptions, reference);
	        }
	    }
	
	    _createClass(GARunner, [{
	        key: '_setupEvolutions',
	        value: function _setupEvolutions(evolution, options, workerOptions, reference) {
	            var _this = this;
	
	            // 1. Determine which evolution is used
	            var migrationSize = options.options.migrationSize;
	
	
	            var availableEvolutions = Object.entries(evolution).filter(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    _ = _ref2[0],
	                    evolutionOptions = _ref2[1];
	
	                return evolutionOptions.weight > 0;
	            });
	
	            var max = availableEvolutions.reduce(function (sum, _ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    _ = _ref4[0],
	                    weight = _ref4[1].weight;
	
	                return sum + weight;
	            }, 0);
	
	            var normalizedPopulation = availableEvolutions.map(function (_ref5) {
	                var _ref6 = _slicedToArray(_ref5, 2),
	                    name = _ref6[0],
	                    evolutionOptions = _ref6[1];
	
	                return [name, _extends({}, evolutionOptions, {
	                    size: Math.floor(migrationSize * evolutionOptions.weight / max)
	                })];
	            });
	
	            normalizedPopulation.forEach(function (_ref7) {
	                var _ref8 = _slicedToArray(_ref7, 2),
	                    evolutionName = _ref8[0],
	                    evolutionOptions = _ref8[1];
	
	                var randomKey = evolutionName + '_' + (0, _utils.uuid)();
	                var worker = _this.workersPool[randomKey] = new _GAWorker2.default();
	                worker.onmessage = _this._createOnMessageForEvolution(workerOptions, evolutionOptions, worker, evolutionName);
	                worker.onerror = function (err) {
	                    return console.warn(err);
	                };
	
	                worker.postMessage({
	                    data: {
	                        options: _extends({}, options, {
	                            // NOTE: Change population size according to weight 
	                            count: evolutionOptions.size
	                        }),
	                        reference: reference,
	                        id: randomKey,
	                        evolutionName: evolutionName
	                    },
	                    action: 'start'
	                });
	            });
	        }
	    }, {
	        key: '_setupDefault',
	        value: function _setupDefault(options, workerOptions, reference) {
	            this._worker = new _GAWorker2.default();
	            this._worker.onmessage = this._createOnMessage(workerOptions);
	            this._worker.onerror = function (err) {
	                return console.warn(err);
	            };
	            this._worker.postMessage({ data: { options: options, reference: reference }, action: 'start' });
	        }
	    }, {
	        key: 'pause',
	        value: function pause() {
	            if (this._useEvolutionStrategies) {
	                // TODO: do i need id to pass to pause?
	                Object.values(this.workersPool).forEach(function (w) {
	                    return w.postMessage({ action: 'pause' });
	                });
	            } else {
	                this._worker.postMessage({ action: 'pause' });
	            }
	        }
	    }, {
	        key: 'resume',
	        value: function resume() {
	            if (this._useEvolutionStrategies) {
	                // TODO: do i need id to pass to resume?
	                Object.values(this.workersPool).forEach(function (w) {
	                    return w.postMessage({ action: 'resume' });
	                });
	            } else {
	                this._worker.postMessage({ action: 'resume' });
	            }
	        }
	    }, {
	        key: 'stop',
	        value: function stop() {
	            if (this._useEvolutionStrategies) {
	                // TODO: do i need id to pass to stop?
	                Object.values(this.workersPool).forEach(function (w) {
	                    return w.postMessage({ action: 'stop' });
	                });
	            } else {
	                this._worker.postMessage({ action: 'stop' });
	            }
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            if (this._useEvolutionStrategies) {
	                Object.values(this.workersPool).forEach(function (w) {
	                    return w.terminate();
	                });
	                this.workersPool = {};
	            } else {
	                this._worker.terminate();
	            }
	        }
	    }, {
	        key: '_createOnMessageForEvolution',
	        value: function _createOnMessageForEvolution(_ref9, evolutionOptions, instance, evolutionName) {
	            var onDone = _ref9.onDone,
	                onProgress = _ref9.onProgress,
	                onPause = _ref9.onPause;
	
	            var _this2 = this;
	
	            return function (_ref10) {
	                var _ref10$data = _ref10.data,
	                    data = _ref10$data.data,
	                    action = _ref10$data.action;
	
	                console.log('Evolutions: onmessage from worker ' + evolutionName + ', ' + action);
	
	                if (action === 'done') {
	                    var population = data.data;
	                    onProgress({
	                        id: data.id,
	                        percentage: 100,
	                        best: population[1]
	                    });
	                    onDone(data);
	                    return;
	                }
	
	                if (onProgress && action === 'progress') {
	                    onProgress({
	                        id: data.id,
	                        percentage: data.percentage,
	                        best: data.best
	                    });
	                }
	
	                if (onPause && action === 'pause') {
	                    onPause(data);
	                }
	
	                if (action === 'migrate') {
	                    var _migrationPool;
	
	                    var migrants = data.migrants,
	                        id = data.id;
	
	                    // Send migrants back
	
	                    var migrantsToSend = _this2._getMigrants(migrants.length);
	                    if (migrantsToSend) {
	                        instance.postMessage({
	                            action: 'migrate',
	                            data: { migrants: migrantsToSend }
	                        });
	                    }
	
	                    // Store received migrants
	                    (_migrationPool = _this2.migrationPool).push.apply(_migrationPool, _toConsumableArray(migrants));
	                }
	            };
	        }
	    }, {
	        key: '_createOnMessage',
	        value: function _createOnMessage(_ref11) {
	            var onDone = _ref11.onDone,
	                onProgress = _ref11.onProgress,
	                onPause = _ref11.onPause;
	
	            return function (_ref12) {
	                var _ref12$data = _ref12.data,
	                    data = _ref12$data.data,
	                    action = _ref12$data.action;
	
	                console.log('onmessage from worker ' + action);
	
	                if (action === 'done') {
	                    var population = data.data;
	                    onProgress({ percentage: 100, best: population[1] });
	                    onDone(data);
	                    return;
	                }
	
	                if (onProgress && action === 'progress') {
	                    onProgress({
	                        percentage: data.percentage,
	                        best: data.best
	                    });
	                }
	
	                if (onPause && action === 'pause') {
	                    onPause(data);
	                }
	            };
	        }
	
	        /**
	         * @description Grab random migrants from pool.
	         * NOTE! it could even be previous migrants from this exact evolution
	         * @param {number} count 
	         */
	
	    }, {
	        key: '_getMigrants',
	        value: function _getMigrants(count) {
	            var _this3 = this;
	
	            console.log(this.migrationPool.length);
	            var indexes = _utils.arrayUtils.getRandomIndexes(count, this.migrationPool.length);
	            var result = indexes.map(function (i) {
	                return _this3.migrationPool[i];
	            });
	            (0, _lodash.remove)(this.migrationPool, function (_, index) {
	                return indexes.includes(index);
	            });
	            console.log(this.migrationPool.length);
	            return result;
	        }
	    }]);

	    return GARunner;
	}();

/***/ },

/***/ 695:
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		return new Worker(__webpack_require__.p + "7325311df0010cbd8d08.worker.js");
	};

/***/ },

/***/ 696:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.IndividualsTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _Player = __webpack_require__(461);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndividualsTable = exports.IndividualsTable = function (_React$Component) {
		_inherits(IndividualsTable, _React$Component);
	
		function IndividualsTable(params) {
			_classCallCheck(this, IndividualsTable);
	
			var _this = _possibleConstructorReturn(this, (IndividualsTable.__proto__ || Object.getPrototypeOf(IndividualsTable)).call(this, params));
	
			_this.stop = function () {
				_Player2.default.stop();
			};
	
			_this.state = {
				selectedIndex: -1
			};
			return _this;
		}
	
		_createClass(IndividualsTable, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'individuals-table-wrapper' },
					_react2.default.createElement(
						'h4',
						null,
						'Population ',
						this.props.name,
						':'
					),
					_react2.default.createElement(
						_reactBootstrap.Table,
						{ striped: true, bordered: true, condensed: true, hover: true },
						_react2.default.createElement(
							'thead',
							null,
							_react2.default.createElement(
								'tr',
								null,
								_react2.default.createElement('th', null),
								_react2.default.createElement(
									'th',
									null,
									'Name'
								),
								_react2.default.createElement(
									'th',
									null,
									'Fitness'
								)
							)
						),
						_react2.default.createElement(
							'tbody',
							null,
							this._renderPopulation()
						)
					)
				);
			}
		}, {
			key: 'renderItem',
			value: function renderItem(item, index) {
				var selected = this.state.selectedIndex === index;
				var classes = selected ? 'highlight' : '';
				var fitnessFrag = selected ? this.renderFitnessInfo(item) : item.fitness.value.toFixed(3);
	
				return _react2.default.createElement(
					'tr',
					{ className: classes, key: index, onClick: this.onSelect.bind(this, item, index) },
					_react2.default.createElement(
						'td',
						null,
						_react2.default.createElement(
							_reactBootstrap.ButtonGroup,
							null,
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ bsStyle: 'info', onClick: this.play.bind(this, item.content) },
								_react2.default.createElement('span', { className: 'glyphicon glyphicon-play' })
							),
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ bsStyle: 'info', onClick: this.stop },
								_react2.default.createElement('span', { className: 'glyphicon glyphicon-stop' })
							)
						)
					),
					_react2.default.createElement(
						'td',
						null,
						'name' + index
					),
					_react2.default.createElement(
						'td',
						null,
						fitnessFrag
					)
				);
			}
		}, {
			key: '_renderPopulation',
			value: function _renderPopulation() {
				var _this2 = this;
	
				return this.props.population.map(function (x, i) {
					return _this2.renderItem(x, i);
				});
			}
		}, {
			key: 'renderFitnessInfoItems',
			value: function renderFitnessInfoItems(items) {
				return items.map(function (_ref) {
					var key = _ref.key,
					    value = _ref.value,
					    className = _ref.className;
					return _react2.default.createElement(
						'tr',
						{ key: key, className: className },
						_react2.default.createElement(
							'td',
							null,
							key
						),
						_react2.default.createElement(
							'td',
							null,
							value.toFixed(3)
						)
					);
				});
			}
		}, {
			key: 'renderFitnessInfo',
			value: function renderFitnessInfo(item) {
				var fitness = this.renderFitnessInfoItems([{
					key: 'total',
					className: 'total',
					value: item.fitness.value
				}].concat(Object.keys(item.fitness.full).map(function (key) {
					return { key: key, value: item.fitness.full[key] };
				})));
				return _react2.default.createElement(
					_reactBootstrap.Table,
					{ condensed: true, style: { marginBottom: 0 } },
					_react2.default.createElement(
						'tbody',
						null,
						fitness
					)
				);
			}
		}, {
			key: 'play',
			value: function play(content) {
				_Player2.default.play(content);
			}
		}, {
			key: 'onSelect',
			value: function onSelect(item, index) {
				this.setState({
					selectedIndex: index
				});
				this.props.onSelect(item);
			}
		}]);
	
		return IndividualsTable;
	}(_react2.default.Component);

/***/ },

/***/ 697:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ABCJS = __webpack_require__(698);
	
	var _ABCJS2 = _interopRequireDefault(_ABCJS);
	
	var _convertToABC = __webpack_require__(699);
	
	var _convertToABC2 = _interopRequireDefault(_convertToABC);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sheet = function (_React$Component) {
		_inherits(Sheet, _React$Component);
	
		function Sheet(params) {
			_classCallCheck(this, Sheet);
	
			var _this = _possibleConstructorReturn(this, (Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call(this, params));
	
			_this._element = null;
			return _this;
		}
	
		_createClass(Sheet, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this._element = this.refs.abcjs;
				if (this.props.data) {
					this._initializeWidget(this.props.data);
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!nextProps.data) {
					return;
				}
	
				this._initializeWidget(nextProps.data);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement('div', { ref: 'abcjs' });
			}
		}, {
			key: '_initializeWidget',
			value: function _initializeWidget(data) {
				_ABCJS2.default.renderAbc(this._element, (0, _convertToABC2.default)(data), null, {
					scale: 1
				});
			}
		}]);
	
		return Sheet;
	}(_react2.default.Component);
	
	exports.default = Sheet;

/***/ },

/***/ 698:
/***/ function(module, exports) {

	module.exports = ABCJS;

/***/ },

/***/ 699:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = convertToABC;
	/*
	!assumptations 
	1/8 as a default length
	c maj as a default key
	*/
	var NEW_LINE = '\n';
	
	var defaultHeader = '\nX:1\nT:Abc\nM:4/4\nC:GA\nK:C\nL:1/8\n';
	
	var referenceTable = {
		0: 'z',
		1: 'C',
		2: 'D',
		3: 'E',
		4: 'F',
		5: 'G',
		6: 'A',
		7: 'B',
		8: 'c',
		9: 'd',
		10: 'e',
		11: 'f',
		12: 'g',
		13: 'a',
		14: 'b'
	};
	
	function createNote(noteIndex, size) {
		if (noteIndex == null) {
			return '';
		}
		return referenceTable[noteIndex] + size;
	}
	
	function convertToABC(source) {
		var answer = defaultHeader;
	
		var previousNote = null;
		var size = 1;
	
		for (var i = 0, l = source.length; i < l; i++) {
			var item = source[i];
	
			if (item === -1) {
				size++;
			} else {
				answer += createNote(previousNote, size);
				previousNote = item;
				size = 1;
			}
	
			//last note
			if (i === source.length - 1) {
				answer += createNote(previousNote, size);
			}
	
			if (i && i % 8 === 0) {
				answer += '|';
			}
	
			if (i && i % 32 === 0) {
				answer += NEW_LINE;
			}
		}
	
		return answer;
	}

/***/ },

/***/ 700:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(479);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 3d Party
	
	
	// Plugin
	
	
	var DEFAULT = 'default';
	
	var Compositions = function (_React$Component) {
		_inherits(Compositions, _React$Component);
	
		function Compositions(params) {
			_classCallCheck(this, Compositions);
	
			var _this = _possibleConstructorReturn(this, (Compositions.__proto__ || Object.getPrototypeOf(Compositions)).call(this, params));
	
			_this.select = function (item) {
				_MusicContext2.default.selectComposition(item);
				_this.setState({
					currentKey: item
				});
			};
	
			_this.state = {
				compositions: _MusicContext2.default.getAllCompositions(),
				nameRaw: '',
				name: '',
				currentKey: _MusicContext2.default.getCurrentKey()
			};
			return _this;
		}
	
		_createClass(Compositions, [{
			key: 'onNameChange',
			value: function onNameChange(e) {
				var nameRaw = e.target.value;
				this.setState({ nameRaw: nameRaw });
				this.setState({ name: '' });
	
				if (_MusicContext2.default.isValidName(nameRaw)) {
					this.setState({ name: nameRaw });
				}
			}
		}, {
			key: 'remove',
			value: function remove(item) {
				_MusicContext2.default.remove(item);
				this.setState({
					compositions: _MusicContext2.default.getAllCompositions()
				});
			}
		}, {
			key: 'renderCompositionItem',
			value: function renderCompositionItem(item) {
				var _this2 = this;
	
				return _react2.default.createElement(
					'tr',
					{ key: item, className: item === this.state.currentKey ? 'selected' : '' },
					_react2.default.createElement(
						'td',
						null,
						_react2.default.createElement(
							_reactRouter.Link,
							{ to: '/compositions/' + item },
							item
						)
					),
					_react2.default.createElement(
						'td',
						null,
						item !== DEFAULT ? _react2.default.createElement(
							_reactBootstrap.ButtonGroup,
							null,
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ bsStyle: 'info', onClick: function onClick() {
										return _this2.select(item);
									} },
								_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'ok-sign' })
							),
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ bsStyle: 'danger', onClick: this.remove.bind(this, item) },
								_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'remove' })
							)
						) : _react2.default.createElement(
							_reactBootstrap.Button,
							{ bsStyle: 'info', onClick: function onClick() {
									return _this2.select(item);
								} },
							_react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'ok-sign' })
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_reactBootstrap.Grid,
					{ fluid: true },
					_react2.default.createElement(
						'h2',
						null,
						'Compositions'
					),
					_react2.default.createElement(
						_reactBootstrap.Table,
						{ striped: true, bordered: true, condensed: true, hover: true },
						_react2.default.createElement(
							'tbody',
							null,
							this.state.compositions.map(this.renderCompositionItem.bind(this))
						)
					),
					_react2.default.createElement(
						'h2',
						null,
						'New'
					),
					_react2.default.createElement(_reactBootstrap.FormControl, { type: 'text', label: 'Name', onChange: this.onNameChange.bind(this), value: this.state.nameRaw }),
					_react2.default.createElement(
						_reactRouter.Link,
						{ to: '/compositions/' + this.state.name },
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ bsStyle: 'info', disabled: !this.state.name },
							'New'
						)
					)
				);
			}
		}]);
	
		return Compositions;
	}(_react2.default.Component);
	
	exports.default = Compositions;

/***/ },

/***/ 701:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(206);
	
	var _Player = __webpack_require__(461);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _MusicContext = __webpack_require__(625);
	
	var _MusicContext2 = _interopRequireDefault(_MusicContext);
	
	var _Sheet = __webpack_require__(697);
	
	var _Sheet2 = _interopRequireDefault(_Sheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 3d Party
	
	
	// Framework
	
	
	// Plugin
	
	
	// Local
	
	
	var DEFAULT = 'default';
	
	var Composition = function (_React$Component) {
		_inherits(Composition, _React$Component);
	
		function Composition(params) {
			_classCallCheck(this, Composition);
	
			var _this = _possibleConstructorReturn(this, (Composition.__proto__ || Object.getPrototypeOf(Composition)).call(this, params));
	
			var composition = _MusicContext2.default.getByKey(_this.props.params.composition) || null;
	
			_this.state = {
				compositionRaw: composition ? _this.compositionToString(composition) : '',
				composition: composition,
				invalidName: true,
				invalidComposition: false,
				isDefault: _this.props.params.composition === DEFAULT
			};
			return _this;
		}
	
		_createClass(Composition, [{
			key: '_convert',
			value: function _convert(raw) {
				var rawArray = raw.split(' ');
	
				rawArray = rawArray.map(function (item) {
					return Number(item);
				});
	
				if (rawArray.some(function (item) {
					return isNaN(item) || _MusicContext.availableValuesInGF.indexOf(item) === -1;
				})) {
					return null;
				}
	
				return rawArray;
			}
		}, {
			key: 'compositionToString',
			value: function compositionToString(array) {
				return array && array.join(' ') || '';
			}
		}, {
			key: 'save',
			value: function save() {
				var composition = this.state.composition;
				var name = this.props.params.composition;
				_MusicContext2.default.save(name, composition);
			}
		}, {
			key: 'onChange',
			value: function onChange(e) {
				var composition = e.target.value;
				var converted = this._convert(e.target.value);
	
				this.setState({
					compositionRaw: composition
				});
	
				if (converted) {
					_Player2.default.set(converted);
					this.setState({
						composition: converted,
						invalidComposition: false
					});
				} else {
					this.setState({
						invalidComposition: true
					});
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var compositionKey = this.props.params.composition;
	
				return _react2.default.createElement(
					_reactBootstrap.Grid,
					{ fluid: true },
					_react2.default.createElement(
						'h3',
						null,
						compositionKey
					),
					_react2.default.createElement(
						_reactBootstrap.Row,
						null,
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ sm: 4, md: 4 },
							_react2.default.createElement(_reactBootstrap.FormControl, { componentClass: 'textarea', style: { height: 230 }, label: 'Notes', onChange: this.onChange.bind(this), value: this.state.compositionRaw }),
							_react2.default.createElement(
								_reactBootstrap.Button,
								{ disabled: this.state.isDefault || this.state.invalidComposition, bsStyle: 'success', onClick: this.save.bind(this) },
								'Save'
							)
						),
						_react2.default.createElement(
							_reactBootstrap.Col,
							{ sm: 4, md: 4 },
							_react2.default.createElement(_Sheet2.default, { data: this.state.composition })
						)
					)
				);
			}
		}]);
	
		return Composition;
	}(_react2.default.Component);
	
	exports.default = Composition;

/***/ },

/***/ 702:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Root = undefined;
	
	var _react = __webpack_require__(33);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(703);
	
	var _reactRouter = __webpack_require__(479);
	
	var _routes = __webpack_require__(203);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = exports.Root = function Root(_ref) {
	    var store = _ref.store;
	    return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(_reactRouter.Router, { history: _reactRouter.hashHistory, routes: _routes2.default })
	    );
	};

/***/ },

/***/ 726:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.configureStore = configureStore;
	
	var _redux = __webpack_require__(709);
	
	var _reducers = __webpack_require__(727);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
		return (0, _redux.createStore)(_reducers2.default, initialState);
	}

/***/ },

/***/ 727:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(709);
	
	var _reducers = __webpack_require__(728);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({ GA: _reducers2.default });

/***/ },

/***/ 728:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _redux = __webpack_require__(709);
	
	var _utils = __webpack_require__(729);
	
	var _initialState = __webpack_require__(615);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var crossover = (0, _utils.createPluginsReducer)('crossover', _initialState2.default.GA);
	var mutation = (0, _utils.createPluginsReducer)('mutation', _initialState2.default.GA);
	var options = (0, _utils.createPluginsReducer)('options', _initialState2.default.GA);
	var fitness = (0, _utils.createPluginsReducer)('fitness', _initialState2.default.GA);
	var evolution = (0, _utils.createPluginsReducer)('evolution', _initialState2.default.GA);
	
	exports.default = (0, _redux.combineReducers)({
		crossover: crossover,
		mutation: mutation,
		fitness: fitness,
		options: options,
		evolution: evolution
	});

/***/ },

/***/ 729:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createDeepProperty = createDeepProperty;
	exports.createPluginsReducer = createPluginsReducer;
	
	var _lodash = __webpack_require__(198);
	
	var _index = __webpack_require__(612);
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createDeepProperty(_ref) {
		var optionsPath = _ref.optionsPath,
		    value = _ref.value;
	
		var obj = {};
		var stopIndex = optionsPath.length - 1;
		return optionsPath.reduce(function (prev, current, currentIndex) {
			if (currentIndex === stopIndex) {
				prev[current] = value;
				return obj;
			}
			return prev[current] = {};
		}, obj);
	}
	
	function createPluginsReducer(namespace, fullState) {
		var initialState = fullState[namespace];
		return function () {
			var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
			var action = arguments[1];
	
			switch (action.type) {
				case _index.OPTIONS_CHANGE_ACTION:
					{
						if (action.optionsPath[0] !== namespace) {
							return state;
						}
						// NOTE: remove namespace from path;
	
						var _action$optionsPath = _toArray(action.optionsPath),
						    optionsPath = _action$optionsPath.slice(1);
	
						var newFragment = createDeepProperty({ optionsPath: optionsPath, value: action.value });
	
						return (0, _lodash.merge)(_extends({}, state), newFragment);
					}
				default:
					return state;
			}
		};
	}

/***/ }

});


// WEBPACK FOOTER //
// app.560af2f67b39365b5266.js